// @ts-nocheck — monolith pending component split (REFACTOR_TODO.md)
import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  Database, Shield, Search, Upload, Play, Bot, AlertTriangle,
  CheckCircle2, XCircle, ChevronRight, FileSpreadsheet, Sparkles,
  Filter, X, Send, Loader2, ArrowRight, ArrowLeft, FlaskConical, Wand2,
  BarChart3, Zap, BookOpen, ChevronDown, Info, Plus, Trash2,
  TrendingUp, Layers, Lightbulb, FileText, PenLine, Check,
  LogOut, Plug, Boxes, Network, CloudCog, Server, Settings,
  KeyRound, CircleAlert, Lock, ShieldCheck, Users, UserPlus,
  Home, Menu, Brain, Activity, Fingerprint, GitCompare, Shuffle,
  Clock, Calendar, Pause, PlayCircle, LayoutDashboard, History,
  CircleCheck, RefreshCw, TrendingDown, HardDrive, Save,
  Table as TableIcon, CheckSquare, Square
} from "lucide-react";
import {
  AreaChart, Area, BarChart, Bar, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from "recharts";
import Papa from "papaparse";

// -----------------------------------------------------------------------------
// IDWTEAM brand logo — embedded as base64 data URL so the artifact has zero external deps
const IDWTEAM_LOGO = "data:image/png;base64,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";

// Static rule library (484 rules across 10 SAP master data domains)
// Compact keys: n=number, d=domain, x=dimension, t=text, b=tables, s=severity, m=method
// -----------------------------------------------------------------------------
const RULES = [{"n":1,"d":"MM","x":"Validity","t":"Material number follows naming convention (alphanumeric, no special chars except -)","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":2,"d":"MM","x":"Completeness","t":"Material description (MAKTX) populated for all required languages","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":3,"d":"MM","x":"Accuracy","t":"Material description length \u2265 10 characters","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":4,"d":"MM","x":"Completeness","t":"English language description must exist for all materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":5,"d":"MM","x":"Validity","t":"Material type (MTART) is valid value per T134","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":6,"d":"MM","x":"Completeness","t":"Industry sector (MBRSH) populated for all materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":7,"d":"MM","x":"Validity","t":"Base unit of measure (MEINS) is valid ISO unit","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":8,"d":"MM","x":"Uniqueness","t":"Old material number (BISMT) is unique across all materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":9,"d":"MM","x":"Accuracy","t":"Net weight (NTGEW) > 0 for FERT/HALB material types","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":10,"d":"MM","x":"Consistency","t":"Gross weight (BRGEW) \u2265 Net weight (NTGEW)","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":11,"d":"MM","x":"Completeness","t":"Weight unit (GEWEI) populated whenever weight fields are populated","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":12,"d":"MM","x":"Completeness","t":"Volume unit (VOLEH) populated whenever volume is populated","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":13,"d":"MM","x":"Validity","t":"EAN/UPC (EAN11) check digit valid for materials with external identifiers","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":14,"d":"MM","x":"Completeness","t":"Product hierarchy (PRDHA) populated for FERT/HAWA materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":15,"d":"MM","x":"Completeness","t":"Material group (MATKL) populated for all materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":16,"d":"MM","x":"Completeness","t":"Division (SPART) populated for all sales-relevant materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":17,"d":"MM","x":"Validity","t":"Cross-plant material status (MSTAE) is valid value per T141","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":18,"d":"MM","x":"Consistency","t":"Valid-from date (MSTDE) \u2264 today for active materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":19,"d":"MM","x":"Consistency","t":"Deletion flag (LVORM) consistent with plant-level status","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":20,"d":"MM","x":"Completeness","t":"MRP type (DISMM) populated for all MRP-relevant materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":21,"d":"MM","x":"Completeness","t":"MRP controller (DISPO) populated for MRP-active plants","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":22,"d":"MM","x":"Validity","t":"Lot size procedure (DISLS) is valid value per T090","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":23,"d":"MM","x":"Accuracy","t":"Reorder point (MINBE) \u2265 0","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":24,"d":"MM","x":"Accuracy","t":"Safety stock (EISBE) \u2265 0","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":25,"d":"MM","x":"Consistency","t":"Maximum stock level (MABST) \u2265 safety stock when populated","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":26,"d":"MM","x":"Accuracy","t":"Planned delivery time (PLIFZ) > 0 for externally procured materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":27,"d":"MM","x":"Accuracy","t":"Goods receipt processing time (WEBAZ) \u2265 0","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":28,"d":"MM","x":"Accuracy","t":"In-house production time (DZEIT) > 0 for internally produced materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":29,"d":"MM","x":"Consistency","t":"Procurement type (BESKZ) consistent with MRP type","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":30,"d":"MM","x":"Validity","t":"Special procurement key (SOBSL) valid for the plant","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":31,"d":"MM","x":"Consistency","t":"Backflush indicator (RGEKZ) consistency with routing/BOM setup","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":32,"d":"MM","x":"Consistency","t":"Plant-specific material status aligned with cross-plant status","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":33,"d":"MM","x":"Completeness","t":"Scheduling margin key (FHORI) populated for materials with planned orders","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":34,"d":"MM","x":"Completeness","t":"Availability check (MTVFP) populated for all plant views","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":35,"d":"MM","x":"Validity","t":"Price control indicator (VPRSV) is S or V and populated","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":36,"d":"MM","x":"Accuracy","t":"Standard price (STPRS) > 0 when price control = S","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":37,"d":"MM","x":"Accuracy","t":"Moving average price (VERPR) > 0 when price control = V","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":38,"d":"MM","x":"Completeness","t":"Valuation class (BKLAS) populated and valid for material type","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":39,"d":"MM","x":"Consistency","t":"Valuation class consistent with material type mapping","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":40,"d":"MM","x":"Accuracy","t":"Price unit (PEINH) > 0","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":41,"d":"MM","x":"Accuracy","t":"Costing lot size (LOSGR) > 0 for all costed materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":42,"d":"MM","x":"Completeness","t":"Variance key (AWSLS) populated for standard-cost materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":43,"d":"MM","x":"Completeness","t":"Delivering plant (DWERK) populated for all sales org materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":44,"d":"MM","x":"Validity","t":"Sales unit (VRKME) is valid unit of measure with conversion to base UoM","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":45,"d":"MM","x":"Accuracy","t":"Minimum order quantity (MINBM) \u2265 0 for sales views","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":46,"d":"MM","x":"Completeness","t":"Loading group (LADGR) populated for shipping-relevant materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":47,"d":"MM","x":"Completeness","t":"Transportation group (TRAGR) populated for shipping materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":48,"d":"MM","x":"Completeness","t":"General item category group (MTPOS_MARA) populated","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":49,"d":"MM","x":"Completeness","t":"Item category group (ITMGR) populated for sales org data","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":50,"d":"MM","x":"Completeness","t":"Tax classification (TAKLV) populated for all materials sold in a country","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":51,"d":"MM","x":"Completeness","t":"Storage conditions (LGPBE) valid when populated for warehouse mgmt","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":52,"d":"MM","x":"Completeness","t":"Hazardous material number (STOFF) populated for hazmat materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":53,"d":"MM","x":"Completeness","t":"Shelf life / expiry date indicator populated for perishable materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":54,"d":"MM","x":"Completeness","t":"QM procurement key (QMPUR) populated for quality-relevant materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":55,"d":"MM","x":"Completeness","t":"Certificate type (QSZAB) consistent with QM procurement key","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":56,"d":"MM","x":"Completeness","t":"At least one class assigned for configurable/KMAT materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":57,"d":"MM","x":"Completeness","t":"All required class characteristics populated for classified materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":58,"d":"MM","x":"Validity","t":"Characteristic values within valid range defined in classification","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":59,"d":"MM","x":"Referential","t":"Plant view (MARC) exists for all active sales org/plant combinations","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":60,"d":"MM","x":"Referential","t":"MRP view exists for all plants where production planning is active","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":61,"d":"MM","x":"Referential","t":"Purchasing view exists for all externally procured materials","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":62,"d":"MM","x":"Referential","t":"Costing view exists for materials with standard price control","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":63,"d":"MM","x":"Referential","t":"Base UoM must have conversion to purchasing UoM in MARM","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":64,"d":"MM","x":"Referential","t":"Sales UoM must have conversion to base UoM in MARM","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":65,"d":"MM","x":"Referential","t":"Material number referenced in open orders must not have deletion flag","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":66,"d":"MM","x":"Referential","t":"FERT material must have at least one BOM in usage 1 (production)","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":67,"d":"MM","x":"Referential","t":"HALB material must have at least one BOM or routing","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":68,"d":"MM","x":"Referential","t":"ROH material must have at least one purchasing info record","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":69,"d":"MM","x":"Referential","t":"FERT material must have at least one routing","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":70,"d":"MM","x":"Consistency","t":"Plant-specific material status consistent with active purchase orders","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":71,"d":"MM","x":"Referential","t":"Material with active reservations must not have MARC deletion flag","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":72,"d":"MM","x":"Uniqueness","t":"Duplicate material check \u2014 same description + material group + base UoM","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":73,"d":"MM","x":"Referential","t":"Material referenced in cost center must have accounting/costing view","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":74,"d":"MM","x":"AI-Assisted","t":"Material description contains only part number \u2014 potential duplication signal","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":75,"d":"MM","x":"AI-Assisted","t":"Net weight statistical outlier within material group (> 3 sigma)","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":76,"d":"MM","x":"AI-Assisted","t":"Price deviation > 25% from 12-month moving average trend","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":77,"d":"MM","x":"AI-Assisted","t":"Stagnant material \u2014 no movement 24+ months, no deletion flag set","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":78,"d":"MM","x":"Uniqueness","t":"Multiple materials sharing same EAN number","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":79,"d":"MM","x":"AI-Assisted","t":"Material group to valuation class mapping anomaly detected","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":80,"d":"MM","x":"AI-Assisted","t":"MRP parameters inconsistent with historical consumption pattern","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":81,"d":"MM","x":"AI-Assisted","t":"Lifecycle status vs. last goods movement date inconsistency","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":82,"d":"MM","x":"AI-Assisted","t":"Costing lot size not aligned with BOM lot-size dependency","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":83,"d":"MM","x":"Completeness","t":"Accounting view missing for materials with open cost collectors","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":84,"d":"MM","x":"Validity","t":"Purchasing value key (EKWSL) valid when populated","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":85,"d":"MM","x":"Completeness","t":"Forecast model (PRMOD) populated for materials using forecast-based MRP","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":86,"d":"MM","x":"Accuracy","t":"Safety time (EISLO) \u2265 0 when safety time indicator set","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"DMC / BW Query / ABAP"},{"n":87,"d":"MM","x":"Consistency","t":"MRP planning horizon not shorter than total lead time","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":88,"d":"MM","x":"Completeness","t":"Batch management indicator (XCHPF) consistent with production process","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":89,"d":"MM","x":"Consistency","t":"Serialization profile consistent with equipment management setup","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":90,"d":"MM","x":"Completeness","t":"Material with active batch splits has batch classification setup","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":91,"d":"MM","x":"Validity","t":"Profit center (PRCTR) populated and valid in material master","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"Domain check / ABAP / DMC"},{"n":92,"d":"MM","x":"Referential","t":"Profit center in material master must exist in profit center master","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":93,"d":"MM","x":"AI-Assisted","t":"Materials with zero value but active stock \u2014 investigate valuation","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":94,"d":"MM","x":"Completeness","t":"Split valuation: all valuation types have accounting view","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"High","m":"ABAP Report / DMC Validation"},{"n":95,"d":"MM","x":"Consistency","t":"Split valuation category consistent with batch management flag","b":"MARA/MARC/MAKT/MBEW/MVKE","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":96,"d":"Customer","x":"Completeness","t":"Business Partner name (NAME1) populated and \u2265 5 characters","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":97,"d":"Customer","x":"Validity","t":"BP category (BPKIND) is valid value \u2014 person, organization, or group","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":98,"d":"Customer","x":"Validity","t":"Country key (LAND1) populated and valid ISO 3166-1 alpha-2 code","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":99,"d":"Customer","x":"Consistency","t":"Region (REGIO) populated and consistent with country key","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":100,"d":"Customer","x":"Completeness","t":"City (ORT01) populated for all customer records","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":101,"d":"Customer","x":"Validity","t":"Postal code (PSTLZ) format matches country-specific pattern","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":102,"d":"Customer","x":"Completeness","t":"Street or PO Box populated \u2014 not both null","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":103,"d":"Customer","x":"Validity","t":"Tax number 1 (STCD1) format valid for the customer country","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":104,"d":"Customer","x":"Validity","t":"VAT registration number (STCEG) format valid for EU customers","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":105,"d":"Customer","x":"Completeness","t":"BP role for customer (FLBPD-ROLE) assigned","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":106,"d":"Customer","x":"Validity","t":"Phone number format valid (E.164 or country pattern)","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":107,"d":"Customer","x":"Validity","t":"Email address format valid \u2014 must contain @ and domain","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":108,"d":"Customer","x":"Completeness","t":"Bank account populated for customers with direct debit payment method","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":109,"d":"Customer","x":"Validity","t":"IBAN format valid for country when populated","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":110,"d":"Customer","x":"Uniqueness","t":"Duplicate BP check \u2014 name + address + tax number combination","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":111,"d":"Customer","x":"Accuracy","t":"Customer creation date \u2264 today","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"DMC / BW Query / ABAP"},{"n":112,"d":"Customer","x":"Completeness","t":"Language key (SPRAS) populated for all customer records","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":113,"d":"Customer","x":"Completeness","t":"Search term (SORTL) populated for all customers","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":114,"d":"Customer","x":"Completeness","t":"Reconciliation account (AKONT) populated in company code data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":115,"d":"Customer","x":"Referential","t":"Reconciliation account is valid GL account in chart of accounts","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":116,"d":"Customer","x":"Completeness","t":"Payment terms (ZTERM) populated in company code data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":117,"d":"Customer","x":"Completeness","t":"Dunning procedure (MAHNA) populated for active customers","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":118,"d":"Customer","x":"Accuracy","t":"Credit limit (KLIMK) > 0 for customers without zero-limit policy","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"DMC / BW Query / ABAP"},{"n":119,"d":"Customer","x":"Completeness","t":"Credit control area (KKBER) populated","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":120,"d":"Customer","x":"Validity","t":"Currency (WAERS) populated and valid ISO 4217 currency code","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":121,"d":"Customer","x":"Completeness","t":"Tolerance group (TOGRU) populated in company code data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":122,"d":"Customer","x":"Completeness","t":"Payment method (ZWELS) populated in company code data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":123,"d":"Customer","x":"Referential","t":"House bank (HBKID) populated when payment method requires direct bank","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":124,"d":"Customer","x":"Validity","t":"Sales organization (VKORG) valid in organizational structure","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":125,"d":"Customer","x":"Validity","t":"Distribution channel (VTWEG) valid for the sales organization","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":126,"d":"Customer","x":"Validity","t":"Division (SPART) valid for the distribution channel","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":127,"d":"Customer","x":"Completeness","t":"Customer group (KDGRP) populated in sales area data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":128,"d":"Customer","x":"Completeness","t":"Customer pricing procedure (KZAZU) populated","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":129,"d":"Customer","x":"Completeness","t":"Incoterms (INCO1) populated for export customers","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":130,"d":"Customer","x":"Consistency","t":"Incoterms location (INCO2) populated when Incoterms 1 requires a place","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":131,"d":"Customer","x":"Completeness","t":"Shipping conditions (VSBED) populated in sales area data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":132,"d":"Customer","x":"Completeness","t":"Account assignment group (KTGRD) populated","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":133,"d":"Customer","x":"Completeness","t":"Tax classification populated for all relevant tax categories/countries","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":134,"d":"Customer","x":"Referential","t":"Sold-to party (SP) partner function assigned in sales area","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":135,"d":"Customer","x":"Referential","t":"Ship-to party (SH) \u2014 at least one assigned","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":136,"d":"Customer","x":"Referential","t":"Bill-to party (BP) \u2014 at least one assigned","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":137,"d":"Customer","x":"Referential","t":"Payer (PY) \u2014 at least one assigned","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":138,"d":"Customer","x":"Referential","t":"All mandatory partner functions exist for the customer sales area","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":139,"d":"Customer","x":"Referential","t":"Payer reconciliation account consistent with sold-to account group rules","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":140,"d":"Customer","x":"Referential","t":"Customer sales area must exist in organizational structure","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":141,"d":"Customer","x":"Referential","t":"Delivering plant must have material extended to it","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":142,"d":"Customer","x":"Referential","t":"Active customer with open orders must not have deletion flag set","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":143,"d":"Customer","x":"Accuracy","t":"Customer credit limit review date not more than 12 months in the past","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"DMC / BW Query / ABAP"},{"n":144,"d":"Customer","x":"Completeness","t":"Blocked customer must have a block reason code populated","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":145,"d":"Customer","x":"Consistency","t":"Ship-to country must match Incoterms applicability for export","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":146,"d":"Customer","x":"AI-Assisted","t":"Address near-duplicate detection \u2014 Levenshtein distance < 3 on name+city","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":147,"d":"Customer","x":"Uniqueness","t":"Tax number duplicated across multiple business partner records","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":148,"d":"Customer","x":"AI-Assisted","t":"Payment terms outlier vs. customer group median (> 2x standard deviation)","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":149,"d":"Customer","x":"AI-Assisted","t":"Inactive customer \u2014 no invoices in 24 months but no archive flag","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":150,"d":"Customer","x":"AI-Assisted","t":"Email domain mismatch with company name (e.g., gmail vs. enterprise name)","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":151,"d":"Customer","x":"AI-Assisted","t":"City / postal code mismatch for country based on reference data","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":152,"d":"Customer","x":"AI-Assisted","t":"Credit limit never reviewed since record creation (> 2 years old)","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":153,"d":"Customer","x":"AI-Assisted","t":"IBAN country code mismatch with customer country field","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":154,"d":"Customer","x":"Uniqueness","t":"Multiple payers for same BP with inconsistent payment terms","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":155,"d":"Customer","x":"AI-Assisted","t":"Contact person email address duplicated across multiple customer records","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":156,"d":"Customer","x":"AI-Assisted","t":"Sales area extension missing for customer with active pricing condition","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":157,"d":"Customer","x":"Validity","t":"VAT number format structurally valid per country-specific algorithm","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":158,"d":"Customer","x":"Completeness","t":"Customer name does not contain placeholder text (e.g. TEST, DUMMY)","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":159,"d":"Customer","x":"Completeness","t":"Delivery priority (LPRIO) populated for key account customers","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":160,"d":"Customer","x":"Consistency","t":"Account group (KTOKD) consistent with customer reconciliation account","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":161,"d":"Customer","x":"Completeness","t":"Maximum partial deliveries value > 0 when partial delivery is allowed","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":162,"d":"Customer","x":"Referential","t":"Customer credit exposure: credit limit covers open orders + open invoices","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":163,"d":"Customer","x":"AI-Assisted","t":"Phone area code inconsistency with customer region","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":164,"d":"Customer","x":"Consistency","t":"Complete delivery indicator (AUTLF) appropriate for customer type","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":165,"d":"Customer","x":"Completeness","t":"Customer time zone populated for international customers","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"ABAP Report / DMC Validation"},{"n":166,"d":"Customer","x":"Validity","t":"Dunning area (MABER) consistent with company code","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"Domain check / ABAP / DMC"},{"n":167,"d":"Customer","x":"Accuracy","t":"GR-based invoice verification flag consistent with order type for customer","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"High","m":"DMC / BW Query / ABAP"},{"n":168,"d":"Customer","x":"AI-Assisted","t":"Bank account IBAN duplicated \u2014 potential fraud or data entry error","b":"KNA1/KNB1/KNVV/BUT000/BUT100","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":169,"d":"Vendor","x":"Completeness","t":"Vendor name (NAME1) \u2265 5 characters and populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":170,"d":"Vendor","x":"Validity","t":"Country (LAND1) populated and valid ISO 3166-1 alpha-2 code","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":171,"d":"Vendor","x":"Consistency","t":"Region (REGIO) consistent with country key","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":172,"d":"Vendor","x":"Completeness","t":"City (ORT01) populated for all vendor records","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":173,"d":"Vendor","x":"Validity","t":"Postal code format valid for vendor country","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":174,"d":"Vendor","x":"Completeness","t":"Street or PO Box populated \u2014 not both null","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":175,"d":"Vendor","x":"Validity","t":"Tax number format valid for vendor country","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":176,"d":"Vendor","x":"Validity","t":"VAT registration valid format for EU vendors","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":177,"d":"Vendor","x":"Completeness","t":"Language key (SPRAS) populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":178,"d":"Vendor","x":"Completeness","t":"Search term (SORTL) populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":179,"d":"Vendor","x":"Completeness","t":"Phone or email populated (at least one contact method)","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":180,"d":"Vendor","x":"Validity","t":"Email format valid when populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":181,"d":"Vendor","x":"Uniqueness","t":"Duplicate vendor check \u2014 name + country + tax number","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":182,"d":"Vendor","x":"Completeness","t":"BP role vendor assigned to business partner","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":183,"d":"Vendor","x":"Consistency","t":"One-time vendor (XCPDK) flag consistency with account group","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":184,"d":"Vendor","x":"Completeness","t":"Reconciliation account (AKONT) populated in company code data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":185,"d":"Vendor","x":"Referential","t":"Reconciliation account is valid GL account in chart of accounts","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":186,"d":"Vendor","x":"Completeness","t":"Payment terms (ZTERM) populated in company code data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":187,"d":"Vendor","x":"Completeness","t":"Payment method (ZWELS) populated in company code data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":188,"d":"Vendor","x":"Referential","t":"Bank key (BANKL) valid when payment method is bank transfer","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":189,"d":"Vendor","x":"Completeness","t":"Bank account number (BANKN) populated for EFT/ACH vendors","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":190,"d":"Vendor","x":"Validity","t":"IBAN format valid for country when populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":191,"d":"Vendor","x":"Completeness","t":"House bank (HBKID) populated in company code data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":192,"d":"Vendor","x":"Validity","t":"Currency (WAERS) populated and valid ISO 4217 code","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":193,"d":"Vendor","x":"Completeness","t":"Tolerance group (TOGRU) populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":194,"d":"Vendor","x":"Completeness","t":"Clerk (BUSAB) populated for AP team assignment","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":195,"d":"Vendor","x":"Completeness","t":"Check double invoice indicator (XDEZV) enabled for active vendors","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":196,"d":"Vendor","x":"Completeness","t":"Payment block reason (ZAHLS) populated when vendor is blocked","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":197,"d":"Vendor","x":"Referential","t":"Alternative payee BP exists when alternative payee field populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":198,"d":"Vendor","x":"Consistency","t":"GR-based invoice verification (REPRF) consistent with purchasing org data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":199,"d":"Vendor","x":"Validity","t":"Purchasing organization (EKORG) valid in organizational structure","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":200,"d":"Vendor","x":"Completeness","t":"Order currency (WAERS) populated in purchasing org data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":201,"d":"Vendor","x":"Completeness","t":"Payment terms in purchasing org data populated","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":202,"d":"Vendor","x":"Completeness","t":"Incoterms (INCO1) populated in purchasing org data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":203,"d":"Vendor","x":"Consistency","t":"Incoterms location (INCO2) populated when Incoterms 1 requires place","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":204,"d":"Vendor","x":"Accuracy","t":"Minimum order value (MINBW) \u2265 0","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"DMC / BW Query / ABAP"},{"n":205,"d":"Vendor","x":"Accuracy","t":"Standard delivery time (LBLIF) > 0 for active suppliers","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"DMC / BW Query / ABAP"},{"n":206,"d":"Vendor","x":"Completeness","t":"Confirmation control key (BSTAE) populated in purchasing org data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":207,"d":"Vendor","x":"Completeness","t":"Vendor evaluation/quality score populated for strategic vendors","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":208,"d":"Vendor","x":"Completeness","t":"Blocked purchasing reason populated when purchasing block active","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":209,"d":"Vendor","x":"Validity","t":"Bank country consistent with vendor country for domestic payments","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":210,"d":"Vendor","x":"Validity","t":"IBAN length matches country-specific standard","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":211,"d":"Vendor","x":"Referential","t":"Bank key valid in banking directory (BNKA)","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":212,"d":"Vendor","x":"Validity","t":"SWIFT/BIC format valid \u2014 8 or 11 characters","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":213,"d":"Vendor","x":"Validity","t":"IBAN check digit valid per MOD 97 algorithm","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":214,"d":"Vendor","x":"Uniqueness","t":"Bank account IBAN not duplicated across multiple vendor records","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":215,"d":"Vendor","x":"Consistency","t":"Multiple bank accounts: exactly one marked as primary/preferred","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":216,"d":"Vendor","x":"Consistency","t":"Payment method must support currency of vendor invoices","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":217,"d":"Vendor","x":"Referential","t":"Vendor with open POs must not have deletion flag set","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":218,"d":"Vendor","x":"Completeness","t":"Active EFT vendor must have at least one valid bank account","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":219,"d":"Vendor","x":"Referential","t":"Reconciliation account exists in chart of accounts","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":220,"d":"Vendor","x":"Referential","t":"Vendor purchasing org extension exists for all active purchase orders","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":221,"d":"Vendor","x":"Referential","t":"Info record exists for regularly ordered material/vendor pairs","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":222,"d":"Vendor","x":"Referential","t":"Source list entry exists for single-source obligatory materials","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":223,"d":"Vendor","x":"Accuracy","t":"Vendor evaluation score updated within last 12 months for strategic vendors","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"DMC / BW Query / ABAP"},{"n":224,"d":"Vendor","x":"Consistency","t":"Payment terms consistent between company code and purchasing org","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":225,"d":"Vendor","x":"Consistency","t":"Vendor currency consistent with country of origin expectations","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":226,"d":"Vendor","x":"AI-Assisted","t":"Duplicate vendor detection \u2014 name similarity + matching bank account","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":227,"d":"Vendor","x":"AI-Assisted","t":"Vendor with no purchase orders in 24 months \u2014 candidate for deactivation","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":228,"d":"Vendor","x":"Uniqueness","t":"Tax number duplicated across multiple vendor records","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":229,"d":"Vendor","x":"AI-Assisted","t":"IBAN duplicated across vendors \u2014 potential fraud signal, requires review","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":230,"d":"Vendor","x":"AI-Assisted","t":"Payment terms outlier vs. vendor category median (> 2x standard deviation)","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":231,"d":"Vendor","x":"AI-Assisted","t":"Vendor contact email domain mismatch with company name","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":232,"d":"Vendor","x":"AI-Assisted","t":"City / postal code mismatch for vendor country per reference data","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":233,"d":"Vendor","x":"AI-Assisted","t":"SWIFT/BIC code country prefix mismatch with bank country","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":234,"d":"Vendor","x":"AI-Assisted","t":"Vendor evaluation score missing for strategic spend category vendor","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":235,"d":"Vendor","x":"AI-Assisted","t":"Sudden change in bank account details \u2014 audit alert, requires approval","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":236,"d":"Vendor","x":"Completeness","t":"Corporate group (KONZS) populated for intercompany vendors","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":237,"d":"Vendor","x":"Completeness","t":"Vendor time zone populated for international procurement","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"ABAP Report / DMC Validation"},{"n":238,"d":"Vendor","x":"Accuracy","t":"Delivery tolerance (UEBTK, UNBTK) between 0 and 100%","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"DMC / BW Query / ABAP"},{"n":239,"d":"Vendor","x":"Consistency","t":"Returns vendor flag consistent with material master returns setup","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":240,"d":"Vendor","x":"Validity","t":"Vendor account group (KTOKK) consistent with reconciliation account range","b":"LFA1/LFB1/LFM1/BUT000/LFBK","s":"High","m":"Domain check / ABAP / DMC"},{"n":241,"d":"BOM","x":"Completeness","t":"BOM usage (STLAN) populated and valid per T416 values","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":242,"d":"BOM","x":"Validity","t":"BOM status (STLST) is active/released for all production BOMs","b":"MAST/STKO/STPO","s":"High","m":"Domain check / ABAP / DMC"},{"n":243,"d":"BOM","x":"Accuracy","t":"BOM base quantity (BMENG) > 0","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":244,"d":"BOM","x":"Consistency","t":"BOM base unit of measure (BMEIN) matches material base UoM in material master","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":245,"d":"BOM","x":"Consistency","t":"Valid-from date (DATUV) \u2264 today for all active BOMs","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":246,"d":"BOM","x":"Consistency","t":"Valid-to date > valid-from date when valid-to date is populated","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":247,"d":"BOM","x":"Completeness","t":"Engineering change number (AENR) populated for ECM-managed BOMs","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":248,"d":"BOM","x":"Completeness","t":"Plant (WERKS) populated for all plant-specific BOMs","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":249,"d":"BOM","x":"Referential","t":"Material assigned to BOM header exists in material master","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":250,"d":"BOM","x":"Referential","t":"All component material numbers (IDNRK) exist in material master","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":251,"d":"BOM","x":"Accuracy","t":"Component quantity (MENGE) > 0 for all BOM items","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":252,"d":"BOM","x":"Validity","t":"Component unit of measure (MEINS) valid with conversion to component base UoM","b":"MAST/STKO/STPO","s":"High","m":"Domain check / ABAP / DMC"},{"n":253,"d":"BOM","x":"Validity","t":"Item category (POSTP) valid \u2014 L, D, N, R, T, or M","b":"MAST/STKO/STPO","s":"High","m":"Domain check / ABAP / DMC"},{"n":254,"d":"BOM","x":"Completeness","t":"Item text populated for all non-standard item categories","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":255,"d":"BOM","x":"Accuracy","t":"Scrap factor (AUSCH) between 0% and 100%","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":256,"d":"BOM","x":"Accuracy","t":"Operation scrap (OPSCRAP) < 50% (flag for review if exceeded)","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":257,"d":"BOM","x":"Consistency","t":"Lead-time offset (EWAHR) consistent with routing operation sequence","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":258,"d":"BOM","x":"Referential","t":"Recursive component check \u2014 component must not lead back to parent material","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":259,"d":"BOM","x":"Referential","t":"Component deletion flag not set while component is active in BOM","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":260,"d":"BOM","x":"Consistency","t":"Phantom assembly (SCHGT) flag consistent with BOM usage type","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":261,"d":"BOM","x":"Consistency","t":"Bulk material indicator consistent with storage location management","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":262,"d":"BOM","x":"Completeness","t":"Relevant to costing flag (KKZMA) consistent with costing setup in material master","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":263,"d":"BOM","x":"Consistency","t":"Alternative item group: all alternatives have selection priority populated","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":264,"d":"BOM","x":"Accuracy","t":"Usage probability for alternative items sums to 100% within group","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":265,"d":"BOM","x":"Accuracy","t":"Subassembly nesting depth check \u2014 maximum 10 levels","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":266,"d":"BOM","x":"Consistency","t":"BOM item valid-from date \u2265 BOM header valid-from date","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":267,"d":"BOM","x":"Referential","t":"FERT material must have at least one BOM with usage = 1 (production)","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":268,"d":"BOM","x":"Referential","t":"HALB material must have BOM if in-house production is used","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":269,"d":"BOM","x":"Consistency","t":"Phantom assembly must itself have a BOM at the next level","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":270,"d":"BOM","x":"Referential","t":"Co-product (KUPPROD) must have valuation class in costing","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":271,"d":"BOM","x":"Accuracy","t":"By-product quantity \u2264 10% of parent quantity (flag otherwise)","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":272,"d":"BOM","x":"Referential","t":"BOM exists for all materials with active scheduled production orders","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":273,"d":"BOM","x":"Referential","t":"BOM usage = 5 (sales) must exist for all configurable KMAT materials","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":274,"d":"BOM","x":"Referential","t":"BOM header material must not also appear as a component (self-reference)","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":275,"d":"BOM","x":"Referential","t":"Superseded component in BOM must have active successor in material master","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":276,"d":"BOM","x":"Completeness","t":"BOM change after ERP go-live must have change reason code populated","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":277,"d":"BOM","x":"Referential","t":"All items in a plant-specific BOM must have the material extended to that plant","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":278,"d":"BOM","x":"Completeness","t":"All FERT materials in scope have at least one component in BOM","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":279,"d":"BOM","x":"Completeness","t":"All primary components have unit of measure conversion maintained","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":280,"d":"BOM","x":"Referential","t":"All HALB components have their own sub-BOM","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":281,"d":"BOM","x":"Completeness","t":"Text items have item long text populated","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":282,"d":"BOM","x":"AI-Assisted","t":"Component weight sum vs. finished good net weight \u2014 tolerance \u00b1 5%","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":283,"d":"BOM","x":"AI-Assisted","t":"Component quantity outlier vs. historical average (> 200% deviation)","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":284,"d":"BOM","x":"AI-Assisted","t":"BOM with zero costing-relevant items \u2014 0% cost coverage flag","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":285,"d":"BOM","x":"Uniqueness","t":"Duplicate component \u2014 same material number appears twice in same BOM level","b":"MAST/STKO/STPO","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":286,"d":"BOM","x":"AI-Assisted","t":"BOM last changed > 3 years ago with active production orders \u2014 review flag","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":287,"d":"BOM","x":"AI-Assisted","t":"BOM exists but no production order ever created against it","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":288,"d":"BOM","x":"AI-Assisted","t":"Component ratio inconsistency vs. similar parent material structures","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":289,"d":"BOM","x":"Consistency","t":"BOM base quantity not aligned with standard order lot size in material master","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":290,"d":"BOM","x":"AI-Assisted","t":"Component with recent price spike > 50% but no BOM revision initiated","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":291,"d":"BOM","x":"Referential","t":"Production version: BOM and routing combination valid and active","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":292,"d":"BOM","x":"Consistency","t":"Production version alternative dates must not overlap","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":293,"d":"BOM","x":"Completeness","t":"At least one production version alternative marked as preferred","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":294,"d":"BOM","x":"Referential","t":"MRP explosion: BOM exists for all dependent demand materials","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":295,"d":"BOM","x":"Completeness","t":"Change master: all ECO-affected BOMs updated within change effectivity date","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":296,"d":"BOM","x":"Accuracy","t":"Multi-level BOM: total component weight within \u00b1 5% of finished good weight","b":"MAST/STKO/STPO","s":"High","m":"DMC / BW Query / ABAP"},{"n":297,"d":"BOM","x":"Referential","t":"Multi-level BOM: no orphaned sub-assemblies unreferenced from parent","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":298,"d":"BOM","x":"Validity","t":"Multi-level BOM: max depth does not exceed ERP explosion limit (10 levels)","b":"MAST/STKO/STPO","s":"High","m":"Domain check / ABAP / DMC"},{"n":299,"d":"BOM","x":"Completeness","t":"Variant configuration: all mandatory object dependencies maintained","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":300,"d":"BOM","x":"Consistency","t":"Phantom assembly BOM items: explosion type consistent with routing reference","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":301,"d":"BOM","x":"Completeness","t":"BOM item with co-product indicator: settlement rule consistent with costing","b":"MAST/STKO/STPO","s":"High","m":"ABAP Report / DMC Validation"},{"n":302,"d":"BOM","x":"Referential","t":"BOM component must exist in same plant as parent for plant-specific BOM","b":"MAST/STKO/STPO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":303,"d":"BOM","x":"Consistency","t":"BOM with fixed quantity indicator: verify against production order confirmation logic","b":"MAST/STKO/STPO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":304,"d":"BOM","x":"AI-Assisted","t":"BOM component without any goods issue postings in 12 months \u2014 review flag","b":"MAST/STKO/STPO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":305,"d":"Work Center","x":"Validity","t":"Work center key (ARBPL) follows naming convention per plant","b":"CRHD/CRTX/KAKO","s":"High","m":"Domain check / ABAP / DMC"},{"n":306,"d":"Work Center","x":"Validity","t":"Work center category (VERWE) populated and valid","b":"CRHD/CRTX/KAKO","s":"High","m":"Domain check / ABAP / DMC"},{"n":307,"d":"Work Center","x":"Completeness","t":"Plant (WERKS) populated for all work centers","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":308,"d":"Work Center","x":"Completeness","t":"Responsible cost center (KOSTL) populated","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":309,"d":"Work Center","x":"Referential","t":"Responsible cost center exists in controlling area","b":"CRHD/CRTX/KAKO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":310,"d":"Work Center","x":"Completeness","t":"Control key (STEUS) populated for plant control","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":311,"d":"Work Center","x":"Completeness","t":"Standard value key (NORMA) populated","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":312,"d":"Work Center","x":"Completeness","t":"Activity type 1 (LARNT) populated for all costed work centers","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":313,"d":"Work Center","x":"Referential","t":"Activity type valid in the controlling area and cost center","b":"CRHD/CRTX/KAKO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":314,"d":"Work Center","x":"Completeness","t":"Capacity category (KAPID) populated for capacity planning","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":315,"d":"Work Center","x":"Completeness","t":"Base quantity (BMSCH) > 0 for capacity calculation","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":316,"d":"Work Center","x":"Completeness","t":"Unit of capacity (MEINH) populated","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":317,"d":"Work Center","x":"Accuracy","t":"Operating hours per day configured in shift definition","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":318,"d":"Work Center","x":"Accuracy","t":"Number of individual capacities > 0","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":319,"d":"Work Center","x":"Validity","t":"Efficiency rate (MGVGW) between 1% and 200%","b":"CRHD/CRTX/KAKO","s":"High","m":"Domain check / ABAP / DMC"},{"n":320,"d":"Work Center","x":"Validity","t":"Capacity utilization (AUKAS) between 1% and 120%","b":"CRHD/CRTX/KAKO","s":"High","m":"Domain check / ABAP / DMC"},{"n":321,"d":"Work Center","x":"Accuracy","t":"Setup time (RUSTE) \u2265 0 for all setup-relevant work centers","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":322,"d":"Work Center","x":"Completeness","t":"Work center formula key (KSCHL) populated for all standard values","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":323,"d":"Work Center","x":"Referential","t":"Work center formula exists in formula definition table","b":"CRHD/CRTX/KAKO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":324,"d":"Work Center","x":"Accuracy","t":"Machine count > 0 for machine-type work centers","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":325,"d":"Work Center","x":"Accuracy","t":"Labor count > 0 for labor-type work centers","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":326,"d":"Work Center","x":"Accuracy","t":"Start time \u2264 end time in all shift definitions","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":327,"d":"Work Center","x":"Consistency","t":"Breaks do not overlap with shift operating time","b":"CRHD/CRTX/KAKO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":328,"d":"Work Center","x":"Accuracy","t":"Maximum capacity does not exceed theoretical capacity","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":329,"d":"Work Center","x":"Consistency","t":"Work center active status consistent with production orders in system","b":"CRHD/CRTX/KAKO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":330,"d":"Work Center","x":"Referential","t":"Cost center assignment consistent with plant and company code","b":"CRHD/CRTX/KAKO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":331,"d":"Work Center","x":"Referential","t":"Activity type rate maintained in CO for current fiscal period","b":"CRHD/CRTX/KAKO","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":332,"d":"Work Center","x":"AI-Assisted","t":"Work center with no routing operations in last 12 months \u2014 review flag","b":"CRHD/CRTX/KAKO","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":333,"d":"Work Center","x":"Accuracy","t":"Available capacity must be \u2265 scheduled capacity for current month","b":"CRHD/CRTX/KAKO","s":"High","m":"DMC / BW Query / ABAP"},{"n":334,"d":"Work Center","x":"Validity","t":"Work center calendar (FABKL) valid and maintained for current fiscal year","b":"CRHD/CRTX/KAKO","s":"High","m":"Domain check / ABAP / DMC"},{"n":335,"d":"Work Center","x":"Consistency","t":"Cost center validity period covers work center validity period","b":"CRHD/CRTX/KAKO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":336,"d":"Work Center","x":"Completeness","t":"Overload percentage (UEBLA) set and within company capacity policy","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":337,"d":"Work Center","x":"Completeness","t":"Shift sequence (SCHKZ) populated for capacity leveling work centers","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":338,"d":"Work Center","x":"Consistency","t":"Backflush indicator consistent with material master backflush setting","b":"CRHD/CRTX/KAKO","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":339,"d":"Work Center","x":"Completeness","t":"Maintenance work center flag consistent with PM module setup","b":"CRHD/CRTX/KAKO","s":"High","m":"ABAP Report / DMC Validation"},{"n":340,"d":"Routing","x":"Validity","t":"Routing group type (PLNTY) is valid value (N, R, E, M, Q, S)","b":"PLKO/PLPO/PLAS","s":"High","m":"Domain check / ABAP / DMC"},{"n":341,"d":"Routing","x":"Referential","t":"Material assignment for routing exists in material master","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":342,"d":"Routing","x":"Completeness","t":"Plant (WERKS) populated and valid for routing","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":343,"d":"Routing","x":"Accuracy","t":"Base quantity (BMSCH) > 0 for routing header","b":"PLKO/PLPO/PLAS","s":"High","m":"DMC / BW Query / ABAP"},{"n":344,"d":"Routing","x":"Consistency","t":"Base unit of measure (MEINH) matches material base UoM","b":"PLKO/PLPO/PLAS","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":345,"d":"Routing","x":"Validity","t":"Status (STATU) is released (4) for all production routings","b":"PLKO/PLPO/PLAS","s":"High","m":"Domain check / ABAP / DMC"},{"n":346,"d":"Routing","x":"Consistency","t":"Valid-from date (DATUV) \u2264 today for active routings","b":"PLKO/PLPO/PLAS","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":347,"d":"Routing","x":"Completeness","t":"All operations have a valid control key (STEUS) assigned","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":348,"d":"Routing","x":"Referential","t":"Operation work center (ARBPL) exists in the plant","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":349,"d":"Routing","x":"Completeness","t":"Standard values populated for all costing-relevant operations","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":350,"d":"Routing","x":"Accuracy","t":"Setup time standard value (RUSTE) \u2265 0 for all operations","b":"PLKO/PLPO/PLAS","s":"High","m":"DMC / BW Query / ABAP"},{"n":351,"d":"Routing","x":"Accuracy","t":"Machine time standard value \u2265 0 for all machine operations","b":"PLKO/PLPO/PLAS","s":"High","m":"DMC / BW Query / ABAP"},{"n":352,"d":"Routing","x":"Accuracy","t":"Labor time standard value \u2265 0 for all labor operations","b":"PLKO/PLPO/PLAS","s":"High","m":"DMC / BW Query / ABAP"},{"n":353,"d":"Routing","x":"Accuracy","t":"At least one standard value > 0 per operation (not all zero)","b":"PLKO/PLPO/PLAS","s":"High","m":"DMC / BW Query / ABAP"},{"n":354,"d":"Routing","x":"Validity","t":"Operation sequence (VORNR) ascending and unique within routing","b":"PLKO/PLPO/PLAS","s":"High","m":"Domain check / ABAP / DMC"},{"n":355,"d":"Routing","x":"Completeness","t":"Operation long text populated for operations with planned time \u2265 30 min","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":356,"d":"Routing","x":"Completeness","t":"No gaps in operation sequence greater than 50 steps","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":357,"d":"Routing","x":"Completeness","t":"Inspection characteristics (QM) populated for quality-relevant operations","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":358,"d":"Routing","x":"Completeness","t":"Subcontracting operation has external processing flag set","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":359,"d":"Routing","x":"Referential","t":"External processing: purchasing info record exists for subcontractor","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":360,"d":"Routing","x":"Completeness","t":"Parallel sequence has join operation defined for all parallel paths","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":361,"d":"Routing","x":"Completeness","t":"Alternative sequence has selection condition populated","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":362,"d":"Routing","x":"Referential","t":"Production version references this routing with non-overlapping validity dates","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":363,"d":"Routing","x":"Accuracy","t":"No routing operation exceeds work center available capacity by > 200%","b":"PLKO/PLPO/PLAS","s":"High","m":"DMC / BW Query / ABAP"},{"n":364,"d":"Routing","x":"Consistency","t":"Routing costing lot size consistent with BOM base quantity","b":"PLKO/PLPO/PLAS","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":365,"d":"Routing","x":"Consistency","t":"In-house production time in material master consistent with routing lead time","b":"PLKO/PLPO/PLAS","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":366,"d":"Routing","x":"AI-Assisted","t":"Routing last changed > 3 years ago with active production orders \u2014 review","b":"PLKO/PLPO/PLAS","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":367,"d":"Routing","x":"Referential","t":"Routing exists for all FERT materials with in-house production type","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":368,"d":"Routing","x":"Referential","t":"Routing operation work center cost center assignment is active","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":369,"d":"Routing","x":"Completeness","t":"Routing with locked status must have reason/description text","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":370,"d":"Routing","x":"Consistency","t":"All standard value units consistent with work center standard value key","b":"PLKO/PLPO/PLAS","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":371,"d":"Routing","x":"Referential","t":"HALB assigned to at least one production version when routing exists","b":"PLKO/PLPO/PLAS","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":372,"d":"Routing","x":"Completeness","t":"Reference operation set: operations referenced in routing all exist","b":"PLKO/PLPO/PLAS","s":"High","m":"ABAP Report / DMC Validation"},{"n":373,"d":"Routing","x":"AI-Assisted","t":"Multi-level routing: total cumulative lead time \u2264 customer required lead time","b":"PLKO/PLPO/PLAS","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":374,"d":"Routing","x":"Consistency","t":"Rate routing: planned rate matches takt time for production line","b":"PLKO/PLPO/PLAS","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":375,"d":"GL Account","x":"Validity","t":"GL account number (SAKNR) follows chart of accounts numbering logic","b":"SKA1/SKB1/SKAT","s":"High","m":"Domain check / ABAP / DMC"},{"n":376,"d":"GL Account","x":"Completeness","t":"GL account short text (TXT20) populated for all active languages","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":377,"d":"GL Account","x":"Completeness","t":"GL account long text (TXT50) populated","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":378,"d":"GL Account","x":"Validity","t":"Account type (KOART) populated \u2014 A, D, K, M, or S","b":"SKA1/SKB1/SKAT","s":"High","m":"Domain check / ABAP / DMC"},{"n":379,"d":"GL Account","x":"Consistency","t":"Account type consistent with account number range defined in FSV","b":"SKA1/SKB1/SKAT","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":380,"d":"GL Account","x":"Completeness","t":"Balance sheet / P&L indicator (XBILK) populated for all accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":381,"d":"GL Account","x":"Validity","t":"Tax category (MWSKZ) valid for all tax-posting accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"Domain check / ABAP / DMC"},{"n":382,"d":"GL Account","x":"Consistency","t":"Tax category must be blank for balance sheet accounts without tax","b":"SKA1/SKB1/SKAT","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":383,"d":"GL Account","x":"Completeness","t":"Reconciliation account type populated for all AP/AR/asset accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":384,"d":"GL Account","x":"Completeness","t":"Field status group (ZUAWA) populated and valid","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":385,"d":"GL Account","x":"Completeness","t":"Sort key (ZUAWA) populated for all accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":386,"d":"GL Account","x":"Completeness","t":"Line item management (XKRES) enabled for all AP, AR, and bank accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":387,"d":"GL Account","x":"Completeness","t":"Open item management (XOPVW) enabled where required by process","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":388,"d":"GL Account","x":"Completeness","t":"Alternative account number populated for group/consolidation accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":389,"d":"GL Account","x":"Consistency","t":"Account blocked for posting must have reason/description documented","b":"SKA1/SKB1/SKAT","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":390,"d":"GL Account","x":"Uniqueness","t":"Duplicate GL account check within same chart of accounts","b":"SKA1/SKB1/SKAT","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":391,"d":"GL Account","x":"Completeness","t":"P&L statement account type (GVTYP) populated for all income statement accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":392,"d":"GL Account","x":"Validity","t":"Account currency (WAERS) valid ISO 4217 currency code","b":"SKA1/SKB1/SKAT","s":"High","m":"Domain check / ABAP / DMC"},{"n":393,"d":"GL Account","x":"Consistency","t":"Field status group variant exists and is valid in company code","b":"SKA1/SKB1/SKAT","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":394,"d":"GL Account","x":"Completeness","t":"Planning level (FDLEV) populated for all cash management accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":395,"d":"GL Account","x":"Completeness","t":"Relevant to cash flow indicator consistent with account type","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":396,"d":"GL Account","x":"Completeness","t":"Account authorization group (BEGRU) populated","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":397,"d":"GL Account","x":"Completeness","t":"Interest rate indicator populated for all bank/loan/investment accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":398,"d":"GL Account","x":"Referential","t":"House bank assignment valid for all bank GL accounts","b":"SKA1/SKB1/SKAT","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":399,"d":"GL Account","x":"Referential","t":"GL account with open balance must not have deletion flag set","b":"SKA1/SKB1/SKAT","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":400,"d":"GL Account","x":"Completeness","t":"Account created date \u2264 today","b":"SKA1/SKB1/SKAT","s":"High","m":"ABAP Report / DMC Validation"},{"n":401,"d":"GL Account","x":"Consistency","t":"Posting period lock indicator consistent with current period-close status","b":"SKA1/SKB1/SKAT","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":402,"d":"GL Account","x":"Accuracy","t":"Currency type populated for all foreign currency accounts","b":"SKA1/SKB1/SKAT","s":"High","m":"DMC / BW Query / ABAP"},{"n":403,"d":"GL Account","x":"AI-Assisted","t":"GL account with no postings in 24 months \u2014 candidate for blocking","b":"SKA1/SKB1/SKAT","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":404,"d":"GL Account","x":"Referential","t":"Reconciliation account referenced in vendor/customer master must exist","b":"SKA1/SKB1/SKAT","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":405,"d":"Cost Center","x":"Validity","t":"Cost center (KOSTL) follows naming convention for controlling area","b":"CSKS/CSKT/CSKA","s":"High","m":"Domain check / ABAP / DMC"},{"n":406,"d":"Cost Center","x":"Completeness","t":"Cost center description (KTEXT) populated","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":407,"d":"Cost Center","x":"Accuracy","t":"Valid-from date (DATAB) \u2264 today for active cost centers","b":"CSKS/CSKT/CSKA","s":"High","m":"DMC / BW Query / ABAP"},{"n":408,"d":"Cost Center","x":"Consistency","t":"Valid-to date (DATBI) > valid-from date when populated","b":"CSKS/CSKT/CSKA","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":409,"d":"Cost Center","x":"Completeness","t":"Controlling area (KOKRS) populated and valid","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":410,"d":"Cost Center","x":"Referential","t":"Company code (BUKRS) assigned to the controlling area","b":"CSKS/CSKT/CSKA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":411,"d":"Cost Center","x":"Completeness","t":"Cost center category (KOSAR) populated and valid","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":412,"d":"Cost Center","x":"Completeness","t":"Person responsible (VERAK) populated for accountability","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":413,"d":"Cost Center","x":"Referential","t":"Hierarchy area assignment exists in cost center standard hierarchy","b":"CSKS/CSKT/CSKA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":414,"d":"Cost Center","x":"Completeness","t":"Profit center (PRCTR) assigned to all cost centers","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":415,"d":"Cost Center","x":"Completeness","t":"Business area (GSBER) populated where required by reporting structure","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":416,"d":"Cost Center","x":"Validity","t":"Cost center currency (WAERS) valid ISO currency code","b":"CSKS/CSKT/CSKA","s":"High","m":"Domain check / ABAP / DMC"},{"n":417,"d":"Cost Center","x":"Completeness","t":"Cost center planning \u2014 budget loaded for current fiscal year","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":418,"d":"Cost Center","x":"Referential","t":"Distribution/assessment cycle reference exists for overhead cost centers","b":"CSKS/CSKT/CSKA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":419,"d":"Cost Center","x":"AI-Assisted","t":"Cost center with no postings in 12 months \u2014 candidate for review","b":"CSKS/CSKT/CSKA","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":420,"d":"Cost Center","x":"Consistency","t":"Cost center blocking indicator consistent with open purchase/production orders","b":"CSKS/CSKT/CSKA","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":421,"d":"Cost Center","x":"Referential","t":"Parent hierarchy node exists in cost center standard hierarchy (OKEON)","b":"CSKS/CSKT/CSKA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":422,"d":"Cost Center","x":"Consistency","t":"Cost center time dependency: no gaps in validity periods","b":"CSKS/CSKT/CSKA","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":423,"d":"Cost Center","x":"Completeness","t":"Allocation indicator populated for indirect cost centers","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":424,"d":"Cost Center","x":"Completeness","t":"Profit center (PRCTR) follows naming convention for controlling area","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":425,"d":"Cost Center","x":"Completeness","t":"Profit center description populated for all active profit centers","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":426,"d":"Cost Center","x":"Referential","t":"Profit center standard hierarchy assignment exists (OKEC)","b":"CSKS/CSKT/CSKA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":427,"d":"Cost Center","x":"Completeness","t":"Profit center controlling area valid and populated","b":"CSKS/CSKT/CSKA","s":"High","m":"ABAP Report / DMC Validation"},{"n":428,"d":"Cost Center","x":"Referential","t":"Profit center validity covers all assigned cost center validity periods","b":"CSKS/CSKT/CSKA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":429,"d":"Cost Center","x":"AI-Assisted","t":"Profit center with no document postings in 12 months \u2014 review flag","b":"CSKS/CSKT/CSKA","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":430,"d":"Equipment","x":"Validity","t":"Equipment number (EQUNR) follows naming convention per category","b":"EQUI/EQKT/ILOA","s":"High","m":"Domain check / ABAP / DMC"},{"n":431,"d":"Equipment","x":"Validity","t":"Equipment category (EQTYP) valid value in T370 table","b":"EQUI/EQKT/ILOA","s":"High","m":"Domain check / ABAP / DMC"},{"n":432,"d":"Equipment","x":"Completeness","t":"Equipment description (EQKTX) \u2265 10 characters","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":433,"d":"Equipment","x":"Referential","t":"Functional location (TPLNR) assigned for all production-critical equipment","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":434,"d":"Equipment","x":"Referential","t":"Functional location hierarchy valid \u2014 parent functional location exists","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":435,"d":"Equipment","x":"Completeness","t":"Plant (SWERK) populated and valid for all equipment records","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":436,"d":"Equipment","x":"Completeness","t":"Location (ILOC) populated for all field/remote equipment","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":437,"d":"Equipment","x":"Accuracy","t":"Installation date (INBDT) \u2264 today","b":"EQUI/EQKT/ILOA","s":"High","m":"DMC / BW Query / ABAP"},{"n":438,"d":"Equipment","x":"Referential","t":"Construction type material number exists in material master","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":439,"d":"Equipment","x":"Uniqueness","t":"Serial number (SERNR) unique within the construction type material","b":"EQUI/EQKT/ILOA","s":"Critical","m":"SQL Distinct / DMC Dedupe"},{"n":440,"d":"Equipment","x":"Completeness","t":"Manufacturer (HERST) populated for all critical/safety equipment","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":441,"d":"Equipment","x":"Validity","t":"Country of manufacture (HERLD) valid ISO 3166-1 alpha-2 code","b":"EQUI/EQKT/ILOA","s":"High","m":"Domain check / ABAP / DMC"},{"n":442,"d":"Equipment","x":"Completeness","t":"Manufacturer part number (MZHNR) populated when available","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":443,"d":"Equipment","x":"Accuracy","t":"Acquisition value (ANSWT) > 0 for all capitalized equipment","b":"EQUI/EQKT/ILOA","s":"High","m":"DMC / BW Query / ABAP"},{"n":444,"d":"Equipment","x":"Completeness","t":"Acquisition date (ANDAT) populated when acquisition value exists","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":445,"d":"Equipment","x":"Referential","t":"Asset number (ANLNR) linked to valid fixed asset record in FI-AA","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":446,"d":"Equipment","x":"Completeness","t":"Maintenance plant (INGRP) / planning group populated","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":447,"d":"Equipment","x":"Completeness","t":"Planning plant (SOWRK) populated for all planned maintenance equipment","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":448,"d":"Equipment","x":"Completeness","t":"Catalog profile (RBNR) populated for work order/notification creation","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":449,"d":"Equipment","x":"Completeness","t":"ABC indicator (ABCKZ) populated for criticality classification","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":450,"d":"Equipment","x":"Referential","t":"Equipment with open work orders must not have deletion flag","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":451,"d":"Equipment","x":"Completeness","t":"Measurement point unit of measure populated for all counter-type points","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":452,"d":"Equipment","x":"Referential","t":"Measuring point characteristic exists in classification system","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":453,"d":"Equipment","x":"Referential","t":"Maintenance strategy (WARPL) assigned for all preventive maintenance equipment","b":"EQUI/EQKT/ILOA","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":454,"d":"Equipment","x":"Consistency","t":"Warranty end date > equipment installation date","b":"EQUI/EQKT/ILOA","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":455,"d":"Equipment","x":"Accuracy","t":"Equipment hierarchy depth \u2264 8 levels from top functional location","b":"EQUI/EQKT/ILOA","s":"High","m":"DMC / BW Query / ABAP"},{"n":456,"d":"Equipment","x":"Consistency","t":"Sub-equipment must be in same plant as parent equipment","b":"EQUI/EQKT/ILOA","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":457,"d":"Equipment","x":"Consistency","t":"Functional location structure indicator consistent with FL hierarchy rules","b":"EQUI/EQKT/ILOA","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":458,"d":"Equipment","x":"Completeness","t":"All mandatory classification characteristics populated for equipment","b":"EQUI/EQKT/ILOA","s":"High","m":"ABAP Report / DMC Validation"},{"n":459,"d":"Equipment","x":"AI-Assisted","t":"Counter reading current \u2265 counter reading at last maintenance call","b":"EQUI/EQKT/ILOA","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":460,"d":"Info Record","x":"Referential","t":"Info record material (MATNR) exists in material master","b":"EINE/EINA/EORD","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":461,"d":"Info Record","x":"Referential","t":"Info record vendor (LIFNR) exists in vendor master","b":"EINE/EINA/EORD","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":462,"d":"Info Record","x":"Completeness","t":"Purchasing organization (EKORG) populated and valid","b":"EINE/EINA/EORD","s":"High","m":"ABAP Report / DMC Validation"},{"n":463,"d":"Info Record","x":"Completeness","t":"Plant (WERKS) populated for all plant-specific info records","b":"EINE/EINA/EORD","s":"High","m":"ABAP Report / DMC Validation"},{"n":464,"d":"Info Record","x":"Consistency","t":"Info record type (ESART) consistent with material type","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":465,"d":"Info Record","x":"Accuracy","t":"Net price (NETPR) > 0 for all active info records","b":"EINE/EINA/EORD","s":"High","m":"DMC / BW Query / ABAP"},{"n":466,"d":"Info Record","x":"Accuracy","t":"Price unit (PEINH) > 0","b":"EINE/EINA/EORD","s":"High","m":"DMC / BW Query / ABAP"},{"n":467,"d":"Info Record","x":"Validity","t":"Order unit (BSTME) has conversion to material base UoM","b":"EINE/EINA/EORD","s":"High","m":"Domain check / ABAP / DMC"},{"n":468,"d":"Info Record","x":"Consistency","t":"Valid-from date (DATAB) \u2264 today for active info records","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":469,"d":"Info Record","x":"Consistency","t":"Valid-to date (DATBI) > valid-from date when populated","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":470,"d":"Info Record","x":"Accuracy","t":"Planned delivery time (EINDT) > 0 for all active info records","b":"EINE/EINA/EORD","s":"High","m":"DMC / BW Query / ABAP"},{"n":471,"d":"Info Record","x":"Validity","t":"Tolerance levels \u2014 over and under delivery between 0% and 100%","b":"EINE/EINA/EORD","s":"High","m":"Domain check / ABAP / DMC"},{"n":472,"d":"Info Record","x":"Accuracy","t":"Minimum order quantity (MINBM) \u2265 0","b":"EINE/EINA/EORD","s":"High","m":"DMC / BW Query / ABAP"},{"n":473,"d":"Info Record","x":"Completeness","t":"Reminder/expediting days populated for all critical material records","b":"EINE/EINA/EORD","s":"High","m":"ABAP Report / DMC Validation"},{"n":474,"d":"Info Record","x":"Consistency","t":"GR-based invoice verification consistent with vendor master setting","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":475,"d":"Info Record","x":"AI-Assisted","t":"Info record with zero price \u2014 flagged for review and approval","b":"EINE/EINA/EORD","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":476,"d":"Info Record","x":"Completeness","t":"Incoterms consistent with vendor master purchasing org data","b":"EINE/EINA/EORD","s":"High","m":"ABAP Report / DMC Validation"},{"n":477,"d":"Info Record","x":"Consistency","t":"Currency (WAERS) consistent with vendor purchasing org currency","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":478,"d":"Info Record","x":"Completeness","t":"Tax code (MWSKZ) populated where applicable for tax compliance","b":"EINE/EINA/EORD","s":"High","m":"ABAP Report / DMC Validation"},{"n":479,"d":"Info Record","x":"Referential","t":"Source list entry exists for all single-source obligatory materials","b":"EINE/EINA/EORD","s":"Critical","m":"ABAP Join / SE16N / DMC"},{"n":480,"d":"Info Record","x":"Consistency","t":"Source list validity covers all open purchase orders for material","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":481,"d":"Info Record","x":"Consistency","t":"Fixed source indicator (FXKZ) only set for single-source arrangements","b":"EINE/EINA/EORD","s":"Medium","m":"Cross-field ABAP / DMC Rule"},{"n":482,"d":"Info Record","x":"Completeness","t":"Blocked info record must have reason code populated","b":"EINE/EINA/EORD","s":"High","m":"ABAP Report / DMC Validation"},{"n":483,"d":"Info Record","x":"AI-Assisted","t":"Net price deviation > 20% vs. last invoice amount \u2014 review flag","b":"EINE/EINA/EORD","s":"Medium","m":"DataQ Agent GenAI Advisor"},{"n":484,"d":"Info Record","x":"AI-Assisted","t":"Info record for strategic vendor with no PO in 12 months \u2014 review flag","b":"EINE/EINA/EORD","s":"Medium","m":"DataQ Agent GenAI Advisor"}];

// Sample dirty Material Master dataset (seeded violations for demo)
const SAMPLE_DATA = [
  { MATNR: "MAT-1001", MAKTX: "Brake pad kit FL",      MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A1", NTGEW: 1.2,  BRGEW: 1.4,  GEWEI: "KG", MATKL: "B001", STPRS: 24.5,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1002", MAKTX: "Shock absorber rear",    MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A2", NTGEW: 3.1,  BRGEW: 3.4,  GEWEI: "KG", MATKL: "B001", STPRS: 89.0,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1003", MAKTX: "Strut",                  MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A1", NTGEW: 2.4,  BRGEW: 2.1,  GEWEI: "KG", MATKL: "B001", STPRS: 0,     VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1004", MAKTX: "",                       MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A3", NTGEW: 0,    BRGEW: 0.2,  GEWEI: "KG", MATKL: "",     STPRS: 12.0,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1005", MAKTX: "Filter oil",             MTART: "HALB", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A5", NTGEW: 0.4,  BRGEW: 0.5,  GEWEI: "KG", MATKL: "B002", STPRS: 8.5,   VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1006", MAKTX: "Clutch assembly",        MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A6", NTGEW: 4.2,  BRGEW: 4.8,  GEWEI: "KG", MATKL: "B003", STPRS: 210,   VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT1007",  MAKTX: "Oil pan",                MTART: "FERT", MBRSH: "",  MEINS: "EA", BISMT: "OLD-A7", NTGEW: 1.6,  BRGEW: 1.7,  GEWEI: "KG", MATKL: "B003", STPRS: 48.0,  VPRSV: "V", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1008", MAKTX: "Short",                  MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: null,     NTGEW: 0.9,  BRGEW: 1.0,  GEWEI: "KG", MATKL: "B001", STPRS: 14.0,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1009", MAKTX: "Brake rotor front",      MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A9", NTGEW: 5.1,  BRGEW: 5.3,  GEWEI: "KG", MATKL: "B001", STPRS: 78.5,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1010", MAKTX: "Gasket head",            MTART: "HALB", MBRSH: "M", MEINS: "EA", BISMT: "OLD-A1", NTGEW: 0.2,  BRGEW: 0.25, GEWEI: "KG", MATKL: "B002", STPRS: 6.0,   VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT 1011", MAKTX: "Belt timing",            MTART: "FERT", MBRSH: "M", MEINS: "EA", BISMT: "OLD-B1", NTGEW: 0.3,  BRGEW: 0.35, GEWEI: "KG", MATKL: "B004", STPRS: 22.0,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
  { MATNR: "MAT-1012", MAKTX: "Spark plug premium",     MTART: "HAWA", MBRSH: "M", MEINS: "EA", BISMT: "OLD-B2", NTGEW: 0.05, BRGEW: 0.07, GEWEI: "KG", MATKL: "B004", STPRS: -2.5,  VPRSV: "S", PEINH: 1, DISMM: "PD" },
];

// -----------------------------------------------------------------------------
// Connector catalog — source systems the agent can integrate with.
// Each connector defines its category, a short description, a branding badge
// (abbreviation + color, not actual vendor logos), and the config schema.
// -----------------------------------------------------------------------------
const CONNECTORS = [
  {
    id: "sap_ecc", name: "SAP ECC", category: "ERP", abbrev: "ECC", tone: "#1f6f91",
    icon: Boxes,
    blurb: "Classic SAP ERP Central Component. Read master data via RFC/BAPI or stream delta extracts via CDS views and ODP.",
    fields: [
      { key: "host",   label: "Application server",  placeholder: "sap-prod.corp.local" },
      { key: "sysnr",  label: "System number",       placeholder: "00", w: "sm" },
      { key: "client", label: "Client",              placeholder: "100", w: "sm" },
      { key: "user",   label: "Service user",        placeholder: "DATAQ_SVC" },
      { key: "auth",   label: "Authentication",      type: "select",
        options: ["Username / password", "SNC (Secure Network)", "SAP logon ticket"] },
      { key: "lang",   label: "Language",            placeholder: "EN", w: "sm" }
    ]
  },
  {
    id: "sap_s4", name: "SAP S/4HANA", category: "ERP", abbrev: "S/4", tone: "#0a4d7a",
    icon: Boxes,
    blurb: "S/4HANA on-premise or Private Cloud. Consume CDS views, OData APIs, or leverage the Migration Cockpit for mass extracts.",
    fields: [
      { key: "endpoint", label: "System endpoint",     placeholder: "https://s4.corp.example.com" },
      { key: "client",   label: "Client",              placeholder: "100", w: "sm" },
      { key: "auth",     label: "Authentication",      type: "select",
        options: ["OAuth 2.0 (SAML bearer)", "Basic auth", "X.509 certificate"] },
      { key: "user",     label: "Integration user",    placeholder: "DATAQ_INTEG" },
      { key: "odata",    label: "OData catalog root",  placeholder: "/sap/opu/odata/sap/" }
    ]
  },
  {
    id: "kinaxis", name: "Kinaxis RapidResponse", category: "Planning", abbrev: "RR", tone: "#6d28d9",
    icon: Network,
    blurb: "Supply chain planning platform. Profile the integration schema, planning data, and scenario tables to catch upstream data issues before they skew the plan.",
    fields: [
      { key: "url",     label: "RapidResponse URL",   placeholder: "https://rr.company.kinaxis.com" },
      { key: "schema",  label: "Integration schema", placeholder: "Enterprise" },
      { key: "user",    label: "Service user",       placeholder: "dataq.svc" },
      { key: "auth",    label: "Authentication",     type: "select",
        options: ["API key", "OAuth 2.0", "Basic auth"] }
    ]
  },
  {
    id: "datalake", name: "Data Lakes", category: "Data Platform", abbrev: "DL", tone: "#047857",
    icon: CloudCog,
    blurb: "Azure Data Lake, AWS S3, Databricks, Snowflake, or BigQuery. Query Parquet/Delta/Iceberg datasets for bulk profiling at scale.",
    fields: [
      { key: "type",     label: "Platform",           type: "select",
        options: ["Azure Data Lake Gen2", "AWS S3", "Databricks", "Snowflake", "Google BigQuery"] },
      { key: "endpoint", label: "Endpoint / storage URI", placeholder: "abfss://data@acct.dfs.core.windows.net/" },
      { key: "auth",     label: "Authentication",     type: "select",
        options: ["Managed identity", "Service principal", "Access key / SAS", "OAuth 2.0"] },
      { key: "catalog",  label: "Catalog / database", placeholder: "dataq_prod" }
    ]
  },
  {
    id: "jde", name: "JD Edwards EnterpriseOne", category: "ERP", abbrev: "JDE", tone: "#c2410c",
    icon: Boxes,
    blurb: "Oracle JDE EnterpriseOne. Extract via AIS (Application Interface Services) or Orchestrator endpoints; reconcile F-tables against master data.",
    fields: [
      { key: "ais",  label: "AIS server URL",  placeholder: "https://jde-ais.corp.local:9302" },
      { key: "env",  label: "Environment",     placeholder: "JPY920", w: "sm" },
      { key: "role", label: "Role",            placeholder: "*ALL", w: "sm" },
      { key: "user", label: "User",            placeholder: "DATAQ" },
      { key: "auth", label: "Authentication",  type: "select", options: ["Basic auth", "Bearer token"] }
    ]
  },
  {
    id: "oracle_fusion", name: "Oracle Fusion Cloud", category: "ERP", abbrev: "OF", tone: "#a61e1e",
    icon: Boxes,
    blurb: "Oracle Fusion Cloud ERP / SCM. Pull master data via REST APIs, BI Publisher reports, or BICC extract scheduler.",
    fields: [
      { key: "host",  label: "Pod host",         placeholder: "https://fa-abcd-dev.fa.ocs.oraclecloud.com" },
      { key: "auth",  label: "Authentication",   type: "select", options: ["OAuth 2.0", "Basic auth", "JWT"] },
      { key: "user",  label: "Integration user", placeholder: "dataq.integration" },
      { key: "root",  label: "REST API root",    placeholder: "/fscmRestApi/resources/11.13.18.05/" }
    ]
  },
  {
    id: "oracle_ebs", name: "Oracle E-Business Suite", category: "ERP", abbrev: "EBS", tone: "#7f1d1d",
    icon: Boxes,
    blurb: "Oracle EBS on-premise. Integrated SOA Gateway REST/SOAP endpoints, HDL loaders, or direct read of the APPS schema for master data profiling.",
    fields: [
      { key: "host", label: "EBS host",         placeholder: "https://ebs.corp.example.com" },
      { key: "env",  label: "Environment",      placeholder: "PROD", w: "sm" },
      { key: "resp", label: "Responsibility",   placeholder: "System administrator" },
      { key: "user", label: "User",             placeholder: "SYSADMIN" },
      { key: "auth", label: "Authentication",   type: "select", options: ["Basic auth", "HDL token", "ISG token"] }
    ]
  }
];

// Connector → available tables (what users can pick once a connector is configured).
// "domain" is used to tint the dashboard by SAP master-data area; "rows" is an
// approximate row count shown in the picker. In production this would be populated
// by a /api/connectors/{id}/tables call that introspects the live schema.
const CONNECTOR_TABLES = {
  "sap_ecc": [
    { name: "MARA",  domain: "MM",       description: "General Material Data",          rows: 148320 },
    { name: "MARC",  domain: "MM",       description: "Plant Data for Material",        rows: 312045 },
    { name: "MAKT",  domain: "MM",       description: "Material Descriptions",          rows: 296640 },
    { name: "MBEW",  domain: "MM",       description: "Material Valuation",             rows: 148320 },
    { name: "KNA1",  domain: "Customer", description: "Customer Master (General)",      rows: 42180 },
    { name: "KNB1",  domain: "Customer", description: "Customer Master (Company Code)", rows: 38940 },
    { name: "LFA1",  domain: "Vendor",   description: "Vendor Master (General)",        rows: 28450 },
    { name: "LFB1",  domain: "Vendor",   description: "Vendor Master (Company Code)",   rows: 26380 },
    { name: "MAST",  domain: "BOM",      description: "BOM Header",                      rows: 18240 },
    { name: "STPO",  domain: "BOM",      description: "BOM Items",                       rows: 164280 }
  ],
  "sap_s4": [
    { name: "MARA",     domain: "MM",       description: "General Material Data",       rows: 162840 },
    { name: "MARC",     domain: "MM",       description: "Plant Data for Material",     rows: 341860 },
    { name: "BUT000",   domain: "Customer", description: "Business Partner (General)",  rows: 71420 },
    { name: "KNA1",     domain: "Customer", description: "Customer Master",             rows: 44820 },
    { name: "LFA1",     domain: "Vendor",   description: "Vendor Master",               rows: 31260 },
    { name: "SKA1",     domain: "GL Account", description: "G/L Account Master (Chart)", rows: 1840 },
    { name: "CSKS",     domain: "Cost Center", description: "Cost Center Master",       rows: 3420 },
    { name: "EQUI",     domain: "Equipment", description: "Equipment Master",           rows: 8960 }
  ],
  "kinaxis": [
    { name: "Part",          domain: "MM",     description: "Part master (integration)", rows: 152000 },
    { name: "Customer",      domain: "Customer", description: "Customer integration",    rows: 38000 },
    { name: "Supplier",      domain: "Vendor", description: "Supplier integration",      rows: 26000 },
    { name: "IndependentDemand", domain: "MM", description: "Demand records",            rows: 485000 }
  ],
  "datalake": [
    { name: "silver.mara",       domain: "MM",     description: "Curated material master (Delta)", rows: 162000 },
    { name: "silver.kna1",       domain: "Customer", description: "Curated customer master",       rows: 44000 },
    { name: "silver.lfa1",       domain: "Vendor", description: "Curated vendor master",           rows: 31000 },
    { name: "silver.bom_expanded", domain: "BOM",  description: "BOM explosion table",             rows: 2840000 }
  ],
  "jde": [
    { name: "F4101",  domain: "MM",       description: "Item Master",           rows: 95600 },
    { name: "F4102",  domain: "MM",       description: "Item Branch Master",    rows: 214000 },
    { name: "F0101",  domain: "Customer", description: "Address Book Master",   rows: 58400 },
    { name: "F3002",  domain: "BOM",      description: "Bill of Material Master", rows: 34500 }
  ],
  "oracle_fusion": [
    { name: "ItemsV",       domain: "MM",       description: "Item master (REST)",    rows: 128000 },
    { name: "CustomersV",   domain: "Customer", description: "Customer account",      rows: 42000 },
    { name: "SuppliersV",   domain: "Vendor",   description: "Supplier master",       rows: 28000 },
    { name: "StructuresV",  domain: "BOM",      description: "Item structure (BOM)",  rows: 19000 }
  ],
  "oracle_ebs": [
    { name: "MTL_SYSTEM_ITEMS_B", domain: "MM",       description: "Item master",          rows: 112000 },
    { name: "HZ_PARTIES",         domain: "Customer", description: "TCA parties",          rows: 51000 },
    { name: "AP_SUPPLIERS",       domain: "Vendor",   description: "Supplier master",      rows: 27000 },
    { name: "BOM_BILL_OF_MATERIALS", domain: "BOM",   description: "Bills of material",    rows: 22000 }
  ]
};

// -----------------------------------------------------------------------------
// Security: feature map + roles + initial users (session-scoped)
// -----------------------------------------------------------------------------
// Features that Security can gate access to
const FEATURES = [
  { key: "build",    label: "Build Rules", icon: Wand2,       description: "Profile data · author dynamic rules · use NL rule builder" },
  { key: "ml",       label: "ML Insights", icon: Brain,       description: "Unsupervised anomaly detection on the loaded dataset" },
  { key: "validate", label: "Validate",    icon: Play,        description: "Select rules · run the engine · trigger validation" },
  { key: "results",  label: "Results",     icon: TrendingUp,  description: "View outcomes · drill into failed records · export" },
  { key: "agent",    label: "AI Agent",    icon: Sparkles,    description: "Chat with the grounded AI agent · ask about rules or failures" },
  { key: "jobs",     label: "Jobs",        icon: Clock,       description: "Schedule recurring validations, ML scans, and connector syncs" }
];

// Role definitions — each role has a default permission set
const ROLES = {
  "Admin":        { tone: "#7c3aed", bg: "#faf5ff", br: "#e9d5ff", defaults: { build: true,  ml: true,  validate: true,  results: true,  agent: true,  jobs: true  } },
  "Data Steward": { tone: "#0369a1", bg: "#eff6ff", br: "#bfdbfe", defaults: { build: true,  ml: true,  validate: true,  results: true,  agent: true,  jobs: true  } },
  "Analyst":      { tone: "#0f766e", bg: "#f0fdfa", br: "#99f6e4", defaults: { build: false, ml: true,  validate: true,  results: true,  agent: true,  jobs: false } },
  "Viewer":       { tone: "#64748b", bg: "#f8fafc", br: "#e2e8f0", defaults: { build: false, ml: false, validate: false, results: true,  agent: false, jobs: false } }
};

const INITIAL_USERS = [
  { id: "u0", name: "Vijay Naraharishetty", email: "vijay.naraharishetty@idwteam.com", initial: "VN", role: "Admin",        permissions: { build: true,  ml: true,  validate: true,  results: true,  agent: true,  jobs: true  }, lastActive: "Active now" },
  { id: "u1", name: "Demo User",    email: "demo.user@idwteam.com",  initial: "DU", role: "Admin",        permissions: { build: true,  ml: true,  validate: true,  results: true,  agent: true,  jobs: true  }, lastActive: "Active now" },
  { id: "u2", name: "Data Admin",   email: "data.admin@idwteam.com", initial: "DA", role: "Admin",        permissions: { build: true,  ml: true,  validate: true,  results: true,  agent: true,  jobs: true  }, lastActive: "2 hours ago" },
  { id: "u3", name: "Jane Steward", email: "jane.s@idwteam.com",     initial: "JS", role: "Data Steward", permissions: { build: true,  ml: true,  validate: true,  results: true,  agent: true,  jobs: true  }, lastActive: "Yesterday" },
  { id: "u4", name: "Raj Kumar",    email: "raj.k@idwteam.com",      initial: "RK", role: "Data Steward", permissions: { build: true,  ml: false, validate: true,  results: true,  agent: false, jobs: true  }, lastActive: "3 days ago" },
  { id: "u5", name: "Priya M.",     email: "priya.m@idwteam.com",    initial: "PM", role: "Analyst",      permissions: { build: false, ml: true,  validate: true,  results: true,  agent: true,  jobs: false }, lastActive: "1 week ago" },
  { id: "u6", name: "Tom Reader",   email: "tom.r@idwteam.com",      initial: "TR", role: "Viewer",       permissions: { build: false, ml: false, validate: false, results: true,  agent: false, jobs: false }, lastActive: "2 weeks ago" }
];

// -----------------------------------------------------------------------------
// Job scheduler: seed jobs + job types
// -----------------------------------------------------------------------------
const JOB_TYPES = {
  "validation": { label: "Validation",      icon: Play,   tone: "#0f766e", description: "Runs the rule engine against a data extract" },
  "ml":         { label: "ML anomaly scan", icon: Brain,  tone: "#7c3aed", description: "Runs the five unsupervised detectors" },
  "sync":       { label: "Connector sync",  icon: RefreshCw, tone: "#0369a1", description: "Refreshes data from a configured source system" }
};

const SCHEDULE_LABELS = {
  "hourly":  "Hourly",
  "daily":   "Daily",
  "weekly":  "Weekly",
  "monthly": "Monthly",
  "manual":  "On-demand"
};

const INITIAL_JOBS = [
  {
    id: "job-001",
    name: "Daily MM Master Validation",
    description: "Full MM domain validation against latest ECC extract",
    type: "validation",
    schedule: "daily", time: "06:00", timezone: "America/New_York",
    source: "sap_ecc", sourceLabel: "SAP ECC",
    scope: "MM domain · 95 rules",
    status: "enabled",
    lastRun: { status: "success", timestamp: "2 hours ago", duration: "1m 42s", passed: 87, failed: 8, total: 95 },
    nextRun: "Tomorrow at 06:00 EST",
    createdAt: "2026-04-01"
  },
  {
    id: "job-002",
    name: "Weekly Vendor Master ML Scan",
    description: "Unsupervised anomaly detection on vendor master extract",
    type: "ml",
    schedule: "weekly", time: "02:00", timezone: "America/New_York",
    source: "sap_s4", sourceLabel: "SAP S/4HANA",
    scope: "Vendor domain · 5 algorithms",
    status: "enabled",
    lastRun: { status: "success", timestamp: "3 days ago", duration: "3m 12s", anomalies: 23, total: 72 },
    nextRun: "Sunday at 02:00 EST",
    createdAt: "2026-03-15"
  },
  {
    id: "job-003",
    name: "Hourly Customer Sync",
    description: "Incremental customer master refresh from S/4HANA",
    type: "sync",
    schedule: "hourly", time: ":00", timezone: "UTC",
    source: "sap_s4", sourceLabel: "SAP S/4HANA",
    scope: "KNA1 · KNB1 · KNVV",
    status: "enabled",
    lastRun: { status: "running", timestamp: "Just now", duration: "12s", progress: 45 },
    nextRun: "In 48 minutes",
    createdAt: "2026-02-20"
  },
  {
    id: "job-004",
    name: "Monthly Full Catalog Audit",
    description: "Run all 484 rules against current dataset",
    type: "validation",
    schedule: "monthly", time: "01:00", timezone: "America/New_York",
    source: "current", sourceLabel: "Current dataset",
    scope: "All domains · 484 rules",
    status: "enabled",
    lastRun: { status: "success", timestamp: "14 days ago", duration: "18m 04s", passed: 412, failed: 72, total: 484 },
    nextRun: "May 1, 01:00 EST",
    createdAt: "2026-01-10"
  },
  {
    id: "job-005",
    name: "BOM Structure Validation",
    description: "Manual trigger for BOM consistency checks",
    type: "validation",
    schedule: "manual", time: "", timezone: "",
    source: "sap_ecc", sourceLabel: "SAP ECC",
    scope: "BOM domain · 64 rules",
    status: "disabled",
    lastRun: { status: "failed", timestamp: "1 week ago", duration: "0m 18s", error: "Connection timeout to AIS endpoint" },
    nextRun: "Manual trigger only",
    createdAt: "2026-03-28"
  }
];

// -----------------------------------------------------------------------------
// Repository: persistent store for validation runs, ML results, job logs, etc.
// -----------------------------------------------------------------------------
const REPO_TYPES = [
  { id: "postgres",  name: "PostgreSQL",             tone: "#336791", category: "Relational", recommended: true,
    defaultPort: "5432", description: "Open-source relational database. Recommended for most deployments." },
  { id: "sqlserver", name: "Microsoft SQL Server",   tone: "#cc2927", category: "Relational",
    defaultPort: "1433", description: "Enterprise-grade SQL Server or Azure SQL Managed Instance." },
  { id: "azuresql",  name: "Azure SQL Database",     tone: "#0078d4", category: "Cloud",
    defaultPort: "1433", description: "Managed SQL on Azure with automatic patching and backups." },
  { id: "oracle",    name: "Oracle Database",        tone: "#c74634", category: "Relational",
    defaultPort: "1521", description: "Oracle 19c, 21c, or Oracle Cloud Infrastructure DB." },
  { id: "mysql",     name: "MySQL / MariaDB",        tone: "#4479a1", category: "Relational",
    defaultPort: "3306", description: "MySQL 8+ or MariaDB compatible database." },
  { id: "snowflake", name: "Snowflake",              tone: "#29b5e8", category: "Cloud Warehouse",
    defaultPort: "443",  description: "Cloud-native data warehouse — ideal for large audit histories." },
  { id: "databricks",name: "Databricks Delta",       tone: "#ff3621", category: "Lakehouse",
    defaultPort: "443",  description: "Persist results as Delta tables in your lakehouse." },
  { id: "mongodb",   name: "MongoDB",                tone: "#47a248", category: "Document",
    defaultPort: "27017", description: "Flexible document store for schemaless result payloads." }
];

const INITIAL_REPO_CONFIG = {
  configured: true,
  type: "postgres",
  host: "dataq-repo-prod.idwteam.internal",
  port: "5432",
  database: "dataq_repo",
  schema: "dqa",
  user: "dataq_svc",
  auth: "Username / password",
  ssl: true,
  encryption: true,
  retention: "90",      // days
  persist: {
    validationRuns: true,
    mlResults: true,
    jobLogs: true,
    userActivity: true,
    dynamicRules: true,
    recordSnapshots: false
  },
  stats: {
    validationRuns: 127,
    mlResults: 34,
    jobLogs: 89,
    auditEvents: 1842,
    sizeOnDisk: "218 MB",
    connectedSince: "Feb 15, 2026"
  }
};

// -----------------------------------------------------------------------------
// Static-rule engine helpers (same as before)
// -----------------------------------------------------------------------------
function extractSapFields(text) {
  const paren = [...text.matchAll(/\(([A-Z][A-Z0-9_]{2,})\)/g)].map(m => m[1]);
  return [...new Set(paren)];
}

function classifyStaticRule(rule) {
  const t = rule.t;
  const fields = extractSapFields(t);
  const primary = fields[0];

  if (rule.x === "Uniqueness" && primary) return { type: "uniqueness", primary, fields };
  const lenMatch = t.match(/length\s*[≥>=]+\s*(\d+)/i);
  if (lenMatch && primary) return { type: "minlength", primary, fields, n: parseInt(lenMatch[1]) };
  if (/>\s*0/.test(t) && primary) return { type: "positive", primary, fields };
  if (/(≥|>=)\s*0/.test(t) && primary) return { type: "nonnegative", primary, fields };
  if ((/≥|>=/).test(t) && fields.length >= 2) return { type: "compare_ge", primary: fields[0], right: fields[1], fields };
  if (rule.x === "Completeness" && primary) return { type: "completeness", primary, fields };
  return { type: "ai", primary, fields };
}

function buildColumnMap(columns) {
  const map = {};
  columns.forEach(c => { map[c.toUpperCase().trim()] = c; });
  return map;
}

function runRuleOnData(type, meta, rows, col, rightCol) {
  const failures = [];
  if (type === "completeness") {
    rows.forEach((row, i) => {
      const v = row[col];
      if (v == null || String(v).trim() === "") failures.push({ row: i + 1, value: v, col });
    });
  } else if (type === "uniqueness") {
    const buckets = {};
    rows.forEach((row, i) => {
      const v = row[col];
      if (v != null && String(v).trim() !== "") (buckets[String(v)] ||= []).push(i + 1);
    });
    Object.entries(buckets).forEach(([v, rs]) => {
      if (rs.length > 1) rs.forEach(r => failures.push({ row: r, value: v, col, note: `appears ${rs.length}×` }));
    });
  } else if (type === "positive") {
    rows.forEach((row, i) => {
      const n = parseFloat(row[col]); if (!isNaN(n) && n <= 0) failures.push({ row: i + 1, value: row[col], col });
    });
  } else if (type === "nonnegative") {
    rows.forEach((row, i) => {
      const n = parseFloat(row[col]); if (!isNaN(n) && n < 0) failures.push({ row: i + 1, value: row[col], col });
    });
  } else if (type === "minlength") {
    rows.forEach((row, i) => {
      const v = row[col]; if (v != null && String(v).trim().length < meta.n) failures.push({ row: i + 1, value: v, col });
    });
  } else if (type === "maxlength") {
    rows.forEach((row, i) => {
      const v = row[col]; if (v != null && String(v).trim().length > meta.n) failures.push({ row: i + 1, value: v, col });
    });
  } else if (type === "range") {
    rows.forEach((row, i) => {
      const n = parseFloat(row[col]);
      if (!isNaN(n) && (n < meta.min || n > meta.max)) failures.push({ row: i + 1, value: row[col], col });
    });
  } else if (type === "regex") {
    const re = new RegExp(meta.pattern);
    rows.forEach((row, i) => {
      const v = row[col]; if (v != null && String(v).trim() !== "" && !re.test(String(v))) failures.push({ row: i + 1, value: v, col });
    });
  } else if (type === "in_list") {
    const set = new Set((meta.values || []).map(String));
    rows.forEach((row, i) => {
      const v = row[col]; if (v != null && String(v).trim() !== "" && !set.has(String(v))) failures.push({ row: i + 1, value: v, col });
    });
  } else if (type === "compare_ge") {
    rows.forEach((row, i) => {
      const a = parseFloat(row[col]); const b = parseFloat(row[rightCol]);
      if (!isNaN(a) && !isNaN(b) && a < b) failures.push({ row: i + 1, value: `${row[col]} < ${row[rightCol]}`, col: `${col} vs ${rightCol}` });
    });
  } else if (type === "compare_le") {
    rows.forEach((row, i) => {
      const a = parseFloat(row[col]); const b = parseFloat(row[rightCol]);
      if (!isNaN(a) && !isNaN(b) && a > b) failures.push({ row: i + 1, value: `${row[col]} > ${row[rightCol]}`, col: `${col} vs ${rightCol}` });
    });
  }
  return failures;
}

function executeStaticRule(rule, data, colMap) {
  const cls = classifyStaticRule(rule);
  if (!cls.primary) return { status: "no-field" };
  const col = colMap[cls.primary];
  if (!col) return { status: "not-applicable", primary: cls.primary };

  if (cls.type === "ai") return { status: "ai-required", primary: cls.primary };
  if (cls.type === "compare_ge") {
    const rcol = colMap[cls.right];
    if (!rcol) return { status: "not-applicable", primary: cls.primary };
    const failures = runRuleOnData("compare_ge", cls, data.rows, col, rcol);
    return wrapResult(failures, data.rows.length, cls.primary);
  }
  const failures = runRuleOnData(cls.type, cls, data.rows, col);
  return wrapResult(failures, data.rows.length, cls.primary);
}

function wrapResult(failures, total, primary) {
  return {
    status: "executed",
    primary,
    total,
    failed: failures.length,
    passed: total - failures.length,
    pct: total ? +((1 - failures.length / total) * 100).toFixed(1) : 100,
    failures: failures.slice(0, 200)
  };
}

// -----------------------------------------------------------------------------
// Dynamic rule engine — uses column directly, not SAP field codes
// -----------------------------------------------------------------------------
function executeDynamicRule(rule, data) {
  const col = rule.column;
  if (!data.columns.includes(col)) return { status: "not-applicable", primary: col };
  if (rule.type === "ai") return { status: "ai-required", primary: col };
  const rightCol = rule.rightCol;
  if ((rule.type === "compare_ge" || rule.type === "compare_le") && !data.columns.includes(rightCol)) {
    return { status: "not-applicable", primary: col };
  }
  const failures = runRuleOnData(rule.type, rule, data.rows, col, rightCol);
  return wrapResult(failures, data.rows.length, col);
}

// -----------------------------------------------------------------------------
// Data profiling
// -----------------------------------------------------------------------------
function profileColumn(col, rows) {
  const values = rows.map(r => r[col]);
  const total = values.length;
  const nonNull = values.filter(v => v != null && String(v).trim() !== "");
  const nulls = total - nonNull.length;

  const asStr = nonNull.map(String);
  const unique = new Set(asStr).size;

  // Infer type
  const nums = nonNull.map(v => parseFloat(v));
  const allNumeric = nonNull.length > 0 && nums.every(n => !isNaN(n));

  const prof = {
    col,
    total,
    nulls,
    nullPct: total ? +((nulls / total) * 100).toFixed(1) : 0,
    nonNull: nonNull.length,
    unique,
    uniquePct: nonNull.length ? +((unique / nonNull.length) * 100).toFixed(1) : 0,
    samples: [...new Set(asStr)].slice(0, 4),
    type: allNumeric ? "numeric" : "text"
  };

  if (allNumeric && nums.length) {
    prof.min = Math.min(...nums);
    prof.max = Math.max(...nums);
    prof.hasNegative = nums.some(n => n < 0);
    prof.hasZero = nums.some(n => n === 0);
    prof.mean = +(nums.reduce((a, b) => a + b, 0) / nums.length).toFixed(2);
  } else if (asStr.length) {
    const lens = asStr.map(s => s.length);
    prof.minLen = Math.min(...lens);
    prof.maxLen = Math.max(...lens);
    prof.avgLen = Math.round(lens.reduce((a, b) => a + b, 0) / lens.length);
  }
  return prof;
}

// -----------------------------------------------------------------------------
// Machine Learning — unsupervised anomaly detection in pure JS
// All algorithms return findings with {row, col, value, score, reason}
// -----------------------------------------------------------------------------

// 1) Z-score anomalies: numeric values > thresholdσ from mean
function mlZScore(rows, col, threshold = 3) {
  const nums = rows.map((r, i) => ({ v: parseFloat(r[col]), i })).filter(x => !isNaN(x.v));
  if (nums.length < 10) return [];
  const mean = nums.reduce((a, b) => a + b.v, 0) / nums.length;
  const variance = nums.reduce((a, b) => a + (b.v - mean) ** 2, 0) / nums.length;
  const std = Math.sqrt(variance);
  if (std < 1e-9) return [];
  return nums
    .map(x => ({ ...x, z: (x.v - mean) / std }))
    .filter(x => Math.abs(x.z) > threshold)
    .map(x => ({
      algorithm: "zscore", row: x.i + 1, col, value: x.v,
      score: Math.min(1, Math.abs(x.z) / 6),
      reason: `${x.v} is ${x.z >= 0 ? "+" : ""}${x.z.toFixed(2)}σ from the mean (${mean.toFixed(2)}, σ=${std.toFixed(2)})`
    }));
}

// 2) IQR (Tukey) outliers
function mlIQR(rows, col, k = 1.5) {
  const nums = rows.map((r, i) => ({ v: parseFloat(r[col]), i })).filter(x => !isNaN(x.v));
  if (nums.length < 10) return [];
  const sorted = [...nums].sort((a, b) => a.v - b.v);
  const q = (p) => sorted[Math.floor(sorted.length * p)].v;
  const q1 = q(0.25), q3 = q(0.75);
  const iqr = q3 - q1;
  if (iqr < 1e-9) return [];
  const lo = q1 - k * iqr, hi = q3 + k * iqr;
  return nums
    .filter(x => x.v < lo || x.v > hi)
    .map(x => ({
      algorithm: "iqr", row: x.i + 1, col, value: x.v,
      score: Math.min(1, Math.max(Math.abs(x.v - lo), Math.abs(x.v - hi)) / (iqr * 4)),
      reason: x.v < lo
        ? `Below lower fence ${lo.toFixed(2)} (Q1 ${q1.toFixed(2)} - 1.5·IQR)`
        : `Above upper fence ${hi.toFixed(2)} (Q3 ${q3.toFixed(2)} + 1.5·IQR)`
    }));
}

// 3) Categorical rarity: values appearing < threshold share
function mlRarity(rows, col, threshold = 0.02) {
  const counts = {};
  rows.forEach((r, i) => {
    const v = r[col];
    if (v == null || String(v).trim() === "") return;
    const k = String(v).trim();
    (counts[k] ||= { count: 0, rows: [] }).count++;
    counts[k].rows.push(i + 1);
  });
  const total = Object.values(counts).reduce((a, b) => a + b.count, 0);
  if (total < 20) return [];
  const unique = Object.keys(counts).length;
  // Skip if column looks like an ID (too unique to have meaningful rarity)
  if (unique / total > 0.8) return [];
  return Object.entries(counts)
    .filter(([, info]) => info.count / total < threshold)
    .flatMap(([val, info]) => info.rows.map(r => ({
      algorithm: "rarity", row: r, col, value: val,
      score: 1 - info.count / total,
      reason: `"${val}" appears in ${info.count}/${total} rows (${(info.count / total * 100).toFixed(1)}%)`
    })));
}

// 4) Pattern deviation: infer dominant character pattern, flag deviations
function mlPattern(rows, col, dominanceThreshold = 0.7) {
  const toPattern = (s) => String(s).replace(/[a-z]/g, 'a').replace(/[A-Z]/g, 'A').replace(/\d/g, '9');
  const vals = rows.map((r, i) => ({ v: String(r[col] == null ? "" : r[col]).trim(), i }))
                   .filter(x => x.v !== "");
  if (vals.length < 10) return [];
  const patterns = {};
  vals.forEach(x => {
    const p = toPattern(x.v);
    (patterns[p] ||= { count: 0, rows: [] }).count++;
    patterns[p].rows.push({ row: x.i + 1, value: x.v });
  });
  const sorted = Object.entries(patterns).sort((a, b) => b[1].count - a[1].count);
  const [dominantPattern, dominantInfo] = sorted[0];
  const dominantShare = dominantInfo.count / vals.length;
  if (dominantShare < dominanceThreshold || dominantInfo.count < 8) return [];
  return sorted.slice(1).flatMap(([p, info]) => info.rows.map(({ row, value }) => ({
    algorithm: "pattern", row, col, value,
    score: 1 - info.count / vals.length,
    reason: `Pattern "${p}" — doesn't match the dominant "${dominantPattern}" (${(dominantShare * 100).toFixed(0)}% of rows)`,
    meta: { dominantPattern, dominantShare }
  })));
}

// 5) Fuzzy duplicates: trigram Jaccard similarity
function mlFuzzyDuplicates(rows, col, threshold = 0.75) {
  const trigrams = (s) => {
    const t = new Set();
    const str = "  " + String(s).toLowerCase() + "  ";
    for (let i = 0; i < str.length - 2; i++) t.add(str.substr(i, 3));
    return t;
  };
  const jaccard = (a, b) => {
    let inter = 0; a.forEach(x => { if (b.has(x)) inter++; });
    const u = a.size + b.size - inter;
    return u ? inter / u : 0;
  };
  const vals = rows.map((r, i) => ({ v: String(r[col] == null ? "" : r[col]).trim(), i }))
                   .filter(x => x.v !== "");
  if (vals.length < 10 || vals.length > 400) return []; // O(n²) — skip oversize
  const grams = vals.map(x => ({ ...x, g: trigrams(x.v) }));
  const flagged = new Set();
  const out = [];
  for (let i = 0; i < grams.length; i++) {
    for (let j = i + 1; j < grams.length; j++) {
      if (grams[i].v === grams[j].v) continue; // exact dups belong to uniqueness rule
      const sim = jaccard(grams[i].g, grams[j].g);
      if (sim >= threshold) {
        const k = `${grams[i].i}-${grams[j].i}`;
        if (flagged.has(k)) continue;
        flagged.add(k);
        out.push({
          algorithm: "fuzzy", row: grams[i].i + 1, col, value: grams[i].v,
          score: sim,
          reason: `Similar to row ${grams[j].i + 1} ("${grams[j].v}") — ${(sim * 100).toFixed(0)}% trigram match`
        });
      }
    }
  }
  return out;
}

// Orchestrator — runs all five on every column and groups by algorithm
function runMLAnalysis(data) {
  if (!data) return null;
  const { rows, columns } = data;
  const findings = { numeric: [], rare: [], pattern: [], fuzzy: [] };

  columns.forEach(col => {
    // Detect numeric vs text for this column
    const sample = rows.slice(0, 50).map(r => r[col]).filter(v => v != null && v !== "");
    const isNumeric = sample.length > 0 && sample.every(v => !isNaN(parseFloat(v)));

    if (isNumeric) {
      findings.numeric.push(...mlZScore(rows, col));
      findings.numeric.push(...mlIQR(rows, col));
    } else {
      findings.rare.push(...mlRarity(rows, col));
      findings.pattern.push(...mlPattern(rows, col));
      findings.fuzzy.push(...mlFuzzyDuplicates(rows, col));
    }
  });

  // De-dup numeric findings — z-score and IQR often overlap; keep the higher-confidence entry per (row, col)
  const dedupeKey = (f) => `${f.row}|${f.col}`;
  const merged = {};
  findings.numeric.forEach(f => {
    const k = dedupeKey(f);
    if (!merged[k] || f.score > merged[k].score) merged[k] = f;
  });
  findings.numeric = Object.values(merged).sort((a, b) => b.score - a.score);
  findings.rare.sort((a, b) => b.score - a.score);
  findings.pattern.sort((a, b) => b.score - a.score);
  findings.fuzzy.sort((a, b) => b.score - a.score);

  const total = findings.numeric.length + findings.rare.length + findings.pattern.length + findings.fuzzy.length;

  return {
    ranAt: new Date().toLocaleString(),
    total,
    findings,
    stats: {
      rowsAnalysed: rows.length,
      columnsAnalysed: columns.length,
      numericCols: columns.filter(c => {
        const sample = rows.slice(0, 50).map(r => r[c]).filter(v => v != null && v !== "");
        return sample.length > 0 && sample.every(v => !isNaN(parseFloat(v)));
      }).length
    }
  };
}

function suggestRulesFromProfile(profiles, rows) {
  const suggestions = [];
  let idCounter = Date.now();
  const mk = (r) => ({ id: `dyn-${++idCounter}`, source: "profile", ...r });

  profiles.forEach(p => {
    // --- Completeness ---------------------------------------------------
    // Any column with >=1 null gets a completeness rule. Skip columns that
    // are entirely null (nothing useful to assert) or entirely populated
    // where no evidence of the issue exists.
    if (p.nulls > 0 && p.nullPct < 95) {
      suggestions.push(mk({
        name: `${p.col} must be populated`,
        description: `Column ${p.col} contains ${p.nulls} null/empty value${p.nulls === 1 ? "" : "s"} out of ${p.total} (${p.nullPct}%)`,
        type: "completeness", column: p.col,
        severity: p.nullPct > 10 ? "High" : "Medium",
        dimension: "Completeness",
        reason: `${p.nullPct}% nulls observed`
      }));
    }

    // --- Uniqueness (two flavours) --------------------------------------
    // A) 100% unique + text + name hints at identifier: looks like a key.
    //    Numeric measurements that happen to be unique in a small sample are
    //    not keys, so we restrict this to text columns whose name suggests
    //    an identifier (ends in NR/ID/CODE/KEY, or is MATNR/KUNNR/LIFNR/etc).
    const keyHint = /^.*(NR|ID|CODE|KEY|NUM|NO)$|^MATNR|KUNNR|LIFNR|EQUNR|SAKNR|KOSTL|ARBPL|PLNNR|STLNR|INFNR|BISMT/i.test(p.col);
    if (p.type === "text" && p.unique === p.nonNull && p.nonNull >= 5 && keyHint) {
      suggestions.push(mk({
        name: `${p.col} must be unique`,
        description: `Column ${p.col} is 100% unique across ${p.nonNull} rows — looks like a key. Enforce uniqueness going forward.`,
        type: "uniqueness", column: p.col,
        severity: "High", dimension: "Uniqueness",
        reason: `Key-like column — all ${p.nonNull} values unique`
      }));
    }
    // B) High uniqueness (>70%) but duplicates exist — likely meant to be a key
    //    and has actual duplicate violations today.
    else if (p.type === "text" && p.uniquePct >= 70 && p.nonNull >= 5 && p.unique < p.nonNull) {
      const dupes = p.nonNull - p.unique;
      suggestions.push(mk({
        name: `${p.col} must be unique`,
        description: `Column ${p.col} is ${p.uniquePct}% unique with ${dupes} duplicate value${dupes === 1 ? "" : "s"} — likely intended as a key.`,
        type: "uniqueness", column: p.col,
        severity: "Critical", dimension: "Uniqueness",
        reason: `${dupes} duplicate${dupes === 1 ? "" : "s"} in likely-key column`
      }));
    }

    // --- Numeric: non-negative when negatives observed ------------------
    if (p.type === "numeric" && p.hasNegative) {
      suggestions.push(mk({
        name: `${p.col} must be non-negative`,
        description: `Column ${p.col} has negative value${p.min < 0 ? "s" : ""} (min = ${p.min}). Most master data quantities and prices should be ≥ 0.`,
        type: "nonnegative", column: p.col,
        severity: "High", dimension: "Accuracy",
        reason: `Negative value detected: ${p.min}`
      }));
    }

    // --- Numeric: positive (>0) when appropriate ------------------------
    // Columns that look like prices, quantities, lot sizes, etc. should typically
    // be > 0. Heuristic: numeric, hasZero, and column name hints at a quantity.
    if (p.type === "numeric" && !p.hasNegative && p.hasZero && p.nonNull >= 5) {
      const hint = /price|qty|quant|amount|weight|volume|stock|cost|stprs|verpr|ntgew|brgew|minbm|eisbe|minbe/i.test(p.col);
      if (hint) {
        suggestions.push(mk({
          name: `${p.col} must be greater than zero`,
          description: `Column ${p.col} has zero values and appears to be a quantity/price field. Most master data quantities should be > 0.`,
          type: "positive", column: p.col,
          severity: "High", dimension: "Accuracy",
          reason: `Zero values detected in quantity-like field`
        }));
      }
    }

    // --- Categorical: low cardinality → in_list suggestion --------------
    // If a text column has 2–8 distinct values across many rows, it's a
    // classic enum/code field — propose an in_list rule with observed values.
    if (p.type === "text" && p.nonNull >= 5 && p.unique >= 2 && p.unique <= 8 && p.uniquePct < 50 && rows) {
      const seen = new Set();
      rows.forEach(r => {
        const v = r[p.col];
        if (v != null && String(v).trim() !== "") seen.add(String(v).trim());
      });
      const values = [...seen].sort();
      suggestions.push(mk({
        name: `${p.col} must be one of the allowed values`,
        description: `Column ${p.col} has ${values.length} distinct values across ${p.nonNull} rows — looks like an enum. Only these values should appear: ${values.join(", ")}`,
        type: "in_list", column: p.col, values,
        severity: "Medium", dimension: "Validity",
        reason: `${values.length}-value enum detected`
      }));
    }

    // --- Text length patterns -------------------------------------------
    // High length variance — some values look malformed / truncated
    if (p.type === "text" && p.minLen != null && p.avgLen > 0 && p.minLen < p.avgLen / 3 && p.nonNull >= 5) {
      const minN = Math.max(3, Math.round(p.avgLen / 2));
      suggestions.push(mk({
        name: `${p.col} minimum length ≥ ${minN}`,
        description: `${p.col} values range from ${p.minLen} to ${p.maxLen} characters (avg ${p.avgLen}). Short values likely indicate truncation or bad data.`,
        type: "minlength", column: p.col, n: minN,
        severity: "Medium", dimension: "Accuracy",
        reason: `Length variance: min ${p.minLen} vs avg ${p.avgLen}`
      }));
    }

    // --- Pattern-based: consistent format in a key-ish column -----------
    // Text column that is mostly-unique (likely an identifier) AND has rows
    // — propose a pattern check. We don't infer the regex here; we route to
    // the AI pattern detector at validation time by suggesting a type="ai".
    if (p.type === "text" && p.uniquePct >= 80 && p.nonNull >= 8 && p.maxLen != null && p.maxLen >= 4) {
      const sampleValue = p.samples && p.samples[0] ? p.samples[0] : "";
      // Only if the sample looks like an identifier (has alphanumerics or separators)
      if (/^[A-Za-z0-9][A-Za-z0-9\-_.\/]*$/.test(sampleValue)) {
        suggestions.push(mk({
          name: `${p.col} format consistency`,
          description: `${p.col} looks like an identifier (e.g., "${sampleValue}"). Flag rows that don't match the dominant character pattern.`,
          type: "ai", column: p.col,
          severity: "Medium", dimension: "Validity",
          reason: `Identifier-like column · pattern check via AI agent`
        }));
      }
    }
  });

  // Sort: Critical > High > Medium, then by column name
  const sevOrder = { Critical: 0, High: 1, Medium: 2 };
  suggestions.sort((a, b) => (sevOrder[a.severity] - sevOrder[b.severity]) || a.column.localeCompare(b.column));

  return suggestions;
}

// -----------------------------------------------------------------------------
// Claude API (for NL rule builder, AI agent, AI rule evaluation)
// -----------------------------------------------------------------------------
async function askClaude(messages, systemPrompt) {
  const res = await fetch("https://api.anthropic.com/v1/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-20250514",
      max_tokens: 1000,
      system: systemPrompt,
      messages
    })
  });
  const data = await res.json();
  return data.content?.map(b => b.text || "").join("\n") || "";
}

async function nlToRule(text, columns) {
  const sys = `You convert natural-language data quality rules into a JSON rule object for an SAP master data tool.

Available columns in the loaded dataset: ${columns.join(", ")}

Rule types and their fields:
- "completeness": value must not be null/empty. Fields: column
- "uniqueness": values must be unique across rows. Fields: column
- "positive": numeric value > 0. Fields: column
- "nonnegative": numeric value >= 0. Fields: column
- "minlength": string length >= n. Fields: column, n (integer)
- "maxlength": string length <= n. Fields: column, n (integer)
- "range": numeric between min and max inclusive. Fields: column, min (number), max (number)
- "regex": value matches pattern. Fields: column, pattern (JS regex body, no slashes)
- "in_list": value is in allowed list. Fields: column, values (array of strings)
- "compare_ge": left column >= right column (numeric). Fields: column (left), rightCol (right)
- "compare_le": left column <= right column (numeric). Fields: column (left), rightCol (right)
- "ai": business-logic rule that can't be expressed as a simple check. Fields: column (primary)

Always include: name (short), description (one line), severity ("Critical"|"High"|"Medium"), dimension ("Completeness"|"Validity"|"Accuracy"|"Consistency"|"Uniqueness"|"Referential"|"AI-Assisted").

IMPORTANT:
- Match the closest column name from the provided list (case-insensitive).
- Output ONLY the JSON object. No markdown fences, no explanation.
- If the user's description is ambiguous or references a column not in the list, use the closest match or type "ai".`;

  const resp = await askClaude([{ role: "user", content: text }], sys);
  const m = resp.match(/\{[\s\S]*\}/);
  if (!m) throw new Error("Could not parse rule from LLM response");
  const obj = JSON.parse(m[0]);
  obj.id = `dyn-${Date.now()}`;
  obj.source = "nl";
  obj.original = text;
  return obj;
}

// -----------------------------------------------------------------------------
// Visual constants
// -----------------------------------------------------------------------------
const SEV_STYLES = {
  Critical: "text-red-800 bg-red-50 border-red-200",
  High:     "text-orange-800 bg-orange-50 border-orange-200",
  Medium:   "text-yellow-800 bg-yellow-50 border-yellow-200"
};
const SEV_DOT = {
  Critical: "bg-red-600",
  High:     "bg-orange-500",
  Medium:   "bg-yellow-500"
};
const DIM_STYLES = {
  "Completeness": "text-sky-800 bg-sky-50 border-sky-200",
  "Validity":     "text-violet-800 bg-violet-50 border-violet-200",
  "Accuracy":     "text-teal-800 bg-teal-50 border-teal-200",
  "Consistency":  "text-cyan-800 bg-cyan-50 border-cyan-200",
  "Uniqueness":   "text-pink-800 bg-pink-50 border-pink-200",
  "Referential":  "text-emerald-800 bg-emerald-50 border-emerald-200",
  "AI-Assisted":  "text-amber-800 bg-amber-50 border-amber-200"
};

// =============================================================================
// APP
// =============================================================================
export default function DataQAgent({ initialAuth = null }) {
  // Auth state seeds from MSAL (passed in via App.tsx wrapper).
  // The bridge's internal LoginPage is dead code — App.tsx gates rendering
  // on authentication, so this component never renders without a session.
  const [auth, setAuth] = useState(initialAuth);
  const [tab, setTab] = useState("home");
  const [data, setData] = useState(null);
  const [dynRules, setDynRules] = useState([]);
  const [selectedStatic, setSelectedStatic] = useState(new Set());
  const [selectedDynamic, setSelectedDynamic] = useState(new Set());
  const [results, setResults] = useState(null);
  const [running, setRunning] = useState(false);
  const [detailRule, setDetailRule] = useState(null);

  // Connector state: which connectors are configured, and their saved config blobs
  const [connectors, setConnectors] = useState({});  // { [id]: { configured: true, config: {...}, lastSync: "..." } }
  const [connectorDraft, setConnectorDraft] = useState(null); // open modal state: { id, config: {}, testing, testResult }

  // Users for the Security page (session-scoped). The signed-in user gets Admin access by default.
  const [users, setUsers] = useState(INITIAL_USERS);

  // ML Insights state — findings from the last analysis run
  const [mlResults, setMlResults] = useState(null);
  const [mlRunning, setMlRunning] = useState(false);

  // Job scheduler — session-scoped
  const [jobs, setJobs] = useState(INITIAL_JOBS);
  const [jobDraft, setJobDraft] = useState(null);      // open create/edit modal
  const [jobRunningId, setJobRunningId] = useState(null);

  // Repository config — session-scoped
  const [repoConfig, setRepoConfig] = useState(INITIAL_REPO_CONFIG);

  // Effective permissions of the signed-in user — looked up by email (case-insensitive),
  // falls back to Viewer-level (read-only) for unknown users to enforce least-privilege.
  // Admins/users.list-managers can promote them via the Admin → Security & Access screen.
  // IMPORTANT: every key consumed downstream (build, ml, validate, results, agent, jobs) must
  // be present in BOTH branches. A missing key resolves to `undefined`, which the
  // sidebar treats as falsy and grays out that nav item — i.e. the "ML tab is locked" bug.
  const myPermissions = useMemo(() => {
    if (!auth) return { build: false, ml: false, validate: false, results: false, agent: false, jobs: false };
    const email = (auth.email || "").toLowerCase().trim();
    const u = users.find(x => (x.email || "").toLowerCase().trim() === email);
    // Known user → use their stored permissions.
    // Unknown user (newly added to the tenant but not yet provisioned in DataQ) → Viewer.
    return u ? u.permissions : { build: false, ml: false, validate: false, results: true, agent: false, jobs: false };
  }, [auth, users]);

  // Chat
  const [chat, setChat] = useState([
    { role: "assistant", content: "Hi — I'm your data quality agent. Ask me about any of the 484 catalog rules, help you build a new rule from plain English, or explain a failed record from your last run." }
  ]);
  const [chatInput, setChatInput] = useState("");
  const [chatBusy, setChatBusy] = useState(false);

  // Catalog filters
  const [filters, setFilters] = useState({ domain: "All", severity: "All", dimension: "All", q: "" });
  const filteredStatic = useMemo(() => {
    const q = filters.q.trim().toLowerCase();
    return RULES.filter(r => {
      if (filters.domain !== "All" && r.d !== filters.domain) return false;
      if (filters.severity !== "All" && r.s !== filters.severity) return false;
      if (filters.dimension !== "All" && r.x !== filters.dimension) return false;
      if (q && !(r.t.toLowerCase().includes(q) || String(r.n).includes(q) || r.b.toLowerCase().includes(q))) return false;
      return true;
    });
  }, [filters]);

  const stats = useMemo(() => ({
    rules: RULES.length,
    domains: new Set(RULES.map(r => r.d)).size,
    dimensions: new Set(RULES.map(r => r.x)).size,
    critical: RULES.filter(r => r.s === "Critical").length,
    aiAssisted: RULES.filter(r => r.x === "AI-Assisted").length
  }), []);

  const domains = useMemo(() => ["All", ...Array.from(new Set(RULES.map(r => r.d)))], []);
  const dimensions = useMemo(() => ["All", ...Array.from(new Set(RULES.map(r => r.x)))], []);

  const profiles = useMemo(() => {
    if (!data) return [];
    return data.columns.map(c => profileColumn(c, data.rows));
  }, [data]);

  const applicableStatic = useMemo(() => {
    if (!data) return [];
    const colMap = buildColumnMap(data.columns);
    return RULES.filter(r => {
      const f = extractSapFields(r.t);
      return f.length && f.some(x => colMap[x]);
    });
  }, [data]);

  // --- Handlers ----------------------------------------------------
  function onFile(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    Papa.parse(file, {
      header: true, skipEmptyLines: true,
      complete: (res) => {
        setData({ rows: res.data, columns: res.meta.fields, name: file.name });
        setResults(null);
      }
    });
  }

  // Load the bundled sample dataset into the active data slot.
  // Does NOT navigate — callers (Home page) wrap this with their own setTab
  // call when they want navigation. Build/ML/Validate tabs that call this
  // already host the data inline, so they should stay where they are.
  function loadSample() {
    setData({ rows: SAMPLE_DATA, columns: Object.keys(SAMPLE_DATA[0]), name: "sample_material_master.csv" });
    setResults(null);
  }

  // Simulate pulling a table from a configured connector. In production this
  // would hit /api/connectors/{id}/tables/{name}?rows=... and return real data.
  // For the demo we derive a believable dataset from the table metadata + our
  // existing SAMPLE_DATA shape so rule suggestions stay meaningful.
  function loadFromConnector(connectorId, tableName) {
    const def = CONNECTORS.find(c => c.id === connectorId);
    const tables = CONNECTOR_TABLES[connectorId] || [];
    const t = tables.find(x => x.name === tableName);
    if (!def || !t) return;

    // For MM-domain tables we reuse SAMPLE_DATA (realistic material master).
    // For other domains we generate a small, believable synthetic dataset.
    let rows, columns;
    if (t.domain === "MM") {
      rows = SAMPLE_DATA;
      columns = Object.keys(SAMPLE_DATA[0]);
    } else if (t.domain === "Customer") {
      rows = [
        { KUNNR: "0001000001", NAME1: "Acme Corporation",    NAME2: "USA", LAND1: "US", REGIO: "CA", ORT01: "San Jose",       PSTLZ: "95131",  STRAS: "123 Main St",        TELF1: "+1-408-555-1212", KTOKD: "KUNA" },
        { KUNNR: "0001000002", NAME1: "Global Logistics",    NAME2: "",    LAND1: "US", REGIO: "IL", ORT01: "Chicago",        PSTLZ: "60601",  STRAS: "55 Wacker Dr",       TELF1: "+1-312-555-0199", KTOKD: "KUNA" },
        { KUNNR: "0001000003", NAME1: "Acme Corp",           NAME2: "USA", LAND1: "US", REGIO: "CA", ORT01: "San Jose",       PSTLZ: "95131",  STRAS: "123 Main Street",    TELF1: null,              KTOKD: "KUNA" },
        { KUNNR: "0001000004", NAME1: "Pacific Imports Ltd", NAME2: "JPN", LAND1: "JP", REGIO: "13", ORT01: "Tokyo",          PSTLZ: "100-0001", STRAS: "1-1-1 Chiyoda",    TELF1: "+81-3-5555-0100", KTOKD: "KUNA" },
        { KUNNR: "0001000005", NAME1: "X",                   NAME2: "",    LAND1: "US", REGIO: "NY", ORT01: "New York",       PSTLZ: "10001",  STRAS: "",                   TELF1: "+1-212-555-8900", KTOKD: "KUNA" },
        { KUNNR: "0001000006", NAME1: "BuildIt Construction", NAME2: "",   LAND1: "CA", REGIO: "ON", ORT01: "Toronto",        PSTLZ: "M5V 3L9", STRAS: "88 King St W",      TELF1: "+1-416-555-2001", KTOKD: "KUNA" },
        { KUNNR: "0001000007", NAME1: "Northern Supply Co",  NAME2: "",    LAND1: "US", REGIO: "MN", ORT01: "Minneapolis",    PSTLZ: "55401",  STRAS: "7 Marquette Ave",    TELF1: "+1-612-555-0055", KTOKD: "KUNA" },
        { KUNNR: "0001000008", NAME1: "Tech Innovators",     NAME2: "",    LAND1: "US", REGIO: "",   ORT01: "Austin",         PSTLZ: "78701",  STRAS: "100 Congress Ave",   TELF1: "+1-512-555-4040", KTOKD: "KUNA" },
        { KUNNR: "0001000009", NAME1: "Eurobuild GmbH",      NAME2: "DE",  LAND1: "DE", REGIO: "BY", ORT01: "München",        PSTLZ: "80331",  STRAS: "Marienplatz 1",      TELF1: "+49-89-5555-0000", KTOKD: "KUNA" },
        { KUNNR: "0001000010", NAME1: "Sunset Dealers",      NAME2: "",    LAND1: "US", REGIO: "FL", ORT01: "Miami",          PSTLZ: "33131",  STRAS: "200 Biscayne Blvd",  TELF1: "INVALID",          KTOKD: "KUNA" }
      ];
      columns = Object.keys(rows[0]);
    } else if (t.domain === "Vendor") {
      rows = [
        { LIFNR: "V00100001", NAME1: "ABC Manufacturing",     LAND1: "US", ORT01: "Detroit",    REGIO: "MI", PSTLZ: "48201", STCD1: "12-3456789", BANKL: "021000021", BANKN: "123456789", KTOKK: "LIEF" },
        { LIFNR: "V00100002", NAME1: "Precision Parts Inc",   LAND1: "US", ORT01: "Cleveland",  REGIO: "OH", PSTLZ: "44101", STCD1: "98-7654321", BANKL: "044000037", BANKN: "987654321", KTOKK: "LIEF" },
        { LIFNR: "V00100003", NAME1: "Global Steel Works",    LAND1: "DE", ORT01: "Hamburg",    REGIO: "HH", PSTLZ: "20095", STCD1: "",            BANKL: "20050000", BANKN: "",          KTOKK: "LIEF" },
        { LIFNR: "V00100004", NAME1: "Asia Components Ltd",   LAND1: "CN", ORT01: "Shanghai",   REGIO: "31", PSTLZ: "200000",STCD1: "9131-00001",  BANKL: "1001",      BANKN: "6228480000000000", KTOKK: "LIEF" },
        { LIFNR: "V00100005", NAME1: "FastShip Logistics",    LAND1: "US", ORT01: "Memphis",    REGIO: "TN", PSTLZ: "38101", STCD1: "45-6789012", BANKL: "084000026", BANKN: "555000111", KTOKK: "LIEF" },
        { LIFNR: "V00100006", NAME1: "",                       LAND1: "US", ORT01: "Atlanta",    REGIO: "GA", PSTLZ: "30301", STCD1: "58-1122334", BANKL: "061000052", BANKN: "888000222", KTOKK: "LIEF" },
        { LIFNR: "V00100007", NAME1: "Reliable Hardware",     LAND1: "US", ORT01: "Phoenix",    REGIO: "AZ", PSTLZ: "85001", STCD1: "86-2345678", BANKL: "122105155", BANKN: "777000333", KTOKK: "LIEF" },
        { LIFNR: "V00100008", NAME1: "Precision Parts Inc",   LAND1: "US", ORT01: "Cleveland",  REGIO: "OH", PSTLZ: "44101", STCD1: "98-7654321", BANKL: "044000037", BANKN: "987654321", KTOKK: "LIEF" }  // duplicate!
      ];
      columns = Object.keys(rows[0]);
    } else if (t.domain === "BOM") {
      rows = [
        { STLNR: "00000100", STLAL: "01", MATNR: "MAT-1001", POSNR: "0010", IDNRK: "MAT-2001", MENGE: 2,  MEINS: "EA", DATUV: "2024-01-01" },
        { STLNR: "00000100", STLAL: "01", MATNR: "MAT-1001", POSNR: "0020", IDNRK: "MAT-2002", MENGE: 4,  MEINS: "EA", DATUV: "2024-01-01" },
        { STLNR: "00000100", STLAL: "01", MATNR: "MAT-1001", POSNR: "0030", IDNRK: "MAT-2003", MENGE: 0,  MEINS: "EA", DATUV: "2024-01-01" },  // zero qty
        { STLNR: "00000101", STLAL: "01", MATNR: "MAT-1002", POSNR: "0010", IDNRK: "MAT-2010", MENGE: 1,  MEINS: "EA", DATUV: "2024-02-15" },
        { STLNR: "00000101", STLAL: "01", MATNR: "MAT-1002", POSNR: "0020", IDNRK: "",         MENGE: 2,  MEINS: "EA", DATUV: "2024-02-15" },  // null component
        { STLNR: "00000102", STLAL: "01", MATNR: "MAT-1003", POSNR: "0010", IDNRK: "MAT-2020", MENGE: -1, MEINS: "EA", DATUV: "2024-03-10" },  // negative
        { STLNR: "00000102", STLAL: "01", MATNR: "MAT-1003", POSNR: "0020", IDNRK: "MAT-2021", MENGE: 5,  MEINS: "KG", DATUV: "2024-03-10" },
        { STLNR: "00000103", STLAL: "01", MATNR: "MAT-1004", POSNR: "0010", IDNRK: "MAT-2030", MENGE: 3,  MEINS: "EA", DATUV: "2024-04-01" },
        { STLNR: "00000103", STLAL: "01", MATNR: "MAT-1004", POSNR: "0020", IDNRK: "MAT-2031", MENGE: 7,  MEINS: "EA", DATUV: "2024-04-01" }
      ];
      columns = Object.keys(rows[0]);
    } else {
      // Fallback: reuse SAMPLE_DATA so the flow still demos
      rows = SAMPLE_DATA;
      columns = Object.keys(SAMPLE_DATA[0]);
    }

    setData({ rows, columns, name: `${def.name} · ${tableName}`, connectorId, tableName });
    setResults(null);
  }

  function autoSelectApplicableStatic() {
    setSelectedStatic(new Set(applicableStatic.map(r => r.n)));
  }

  function addDynamicRule(rule) {
    setDynRules(prev => [...prev, rule]);
    setSelectedDynamic(prev => new Set([...prev, rule.id]));
  }

  function removeDynamicRule(id) {
    setDynRules(prev => prev.filter(r => r.id !== id));
    setSelectedDynamic(prev => { const s = new Set(prev); s.delete(id); return s; });
  }

  async function runValidation() {
    if (!data) return;
    setRunning(true);
    const colMap = buildColumnMap(data.columns);

    const staticResults = {};
    const staticPicks = RULES.filter(r => selectedStatic.has(r.n));
    for (const r of staticPicks) staticResults[r.n] = executeStaticRule(r, data, colMap);

    const dynResults = {};
    const dynPicks = dynRules.filter(r => selectedDynamic.has(r.id));
    for (const r of dynPicks) dynResults[r.id] = executeDynamicRule(r, data);

    // Summary across both
    const summary = { total: staticPicks.length + dynPicks.length, passed: 0, failed: 0, aiRequired: 0, notApplicable: 0 };
    [...staticPicks.map(r => ({ sev: r.s, res: staticResults[r.n] })),
     ...dynPicks.map(r => ({ sev: r.severity, res: dynResults[r.id] }))].forEach(({ res }) => {
      if (res.status === "executed") {
        if (res.failed > 0) summary.failed++; else summary.passed++;
      } else if (res.status === "ai-required") summary.aiRequired++;
      else summary.notApplicable++;
    });

    setResults({ staticResults, dynResults, summary, ranAt: new Date().toLocaleString() });
    setRunning(false);
    setTab("results");
  }

  // Connector handlers
  function openConnector(id) {
    const existing = connectors[id];
    setConnectorDraft({
      id,
      config: existing?.config ? { ...existing.config } : {},
      testing: false,
      testResult: null
    });
  }
  function updateConnectorField(key, value) {
    setConnectorDraft(d => ({ ...d, config: { ...d.config, [key]: value }, testResult: null }));
  }
  async function testConnector() {
    setConnectorDraft(d => ({ ...d, testing: true, testResult: null }));
    // Simulated connection test — in production this would hit the backend integration service
    await new Promise(r => setTimeout(r, 1100));
    const def = CONNECTORS.find(c => c.id === connectorDraft.id);
    const hasRequired = def.fields.filter(f => !f.optional).every(f => connectorDraft.config[f.key] && String(connectorDraft.config[f.key]).trim());
    setConnectorDraft(d => ({
      ...d,
      testing: false,
      testResult: hasRequired ? { ok: true, message: "Reached endpoint · handshake verified · 42 tables discovered" }
                               : { ok: false, message: "Missing required fields. Fill them in and retry." }
    }));
  }
  function saveConnector() {
    if (!connectorDraft) return;
    setConnectors(prev => ({
      ...prev,
      [connectorDraft.id]: {
        configured: true,
        config: connectorDraft.config,
        lastSync: new Date().toLocaleString()
      }
    }));
    setConnectorDraft(null);
  }
  function disconnectConnector(id) {
    setConnectors(prev => {
      const n = { ...prev }; delete n[id]; return n;
    });
  }

  // Security handlers
  function togglePermission(userId, feat) {
    setUsers(prev => prev.map(u => u.id === userId
      ? { ...u, permissions: { ...u.permissions, [feat]: !u.permissions[feat] } }
      : u));
  }
  function changeRole(userId, role) {
    setUsers(prev => prev.map(u => u.id === userId
      ? { ...u, role, permissions: { ...ROLES[role].defaults } }
      : u));
  }
  function addUser({ name, email, role }) {
    const initial = name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase() || "??";
    const u = {
      id: `u-${Date.now()}`, name, email, initial, role,
      permissions: { ...ROLES[role].defaults },
      lastActive: "Never"
    };
    setUsers(prev => [...prev, u]);
  }
  function removeUser(userId) {
    setUsers(prev => prev.filter(u => u.id !== userId));
  }

  // ML handler — runs all five algorithms on the loaded data
  async function runML() {
    if (!data) return;
    setMlRunning(true);
    // Yield to the UI so the button spinner shows before heavy O(n²) fuzzy work
    await new Promise(r => setTimeout(r, 50));
    const results = runMLAnalysis(data);
    setMlResults(results);
    setMlRunning(false);
  }
  // Reset ML results when data changes
  useEffect(() => { setMlResults(null); }, [data]);

  // Job scheduler handlers
  function openJobModal(job) {
    setJobDraft(job ? { ...job } : {
      id: null, name: "", description: "", type: "validation",
      schedule: "daily", time: "06:00", timezone: "America/New_York",
      source: "current", sourceLabel: "Current dataset",
      scope: "All applicable rules",
      status: "enabled"
    });
  }
  function saveJob(draft) {
    const isNew = !draft.id;
    const job = { ...draft };
    if (isNew) {
      job.id = `job-${Date.now()}`;
      job.createdAt = new Date().toISOString().slice(0, 10);
      job.lastRun = null;
      job.nextRun = nextRunLabel(job);
      setJobs(prev => [...prev, job]);
    } else {
      job.nextRun = nextRunLabel(job);
      setJobs(prev => prev.map(j => j.id === job.id ? job : j));
    }
    setJobDraft(null);
  }
  function toggleJob(id) {
    setJobs(prev => prev.map(j =>
      j.id === id ? { ...j, status: j.status === "enabled" ? "disabled" : "enabled" } : j
    ));
  }
  function deleteJob(id) {
    setJobs(prev => prev.filter(j => j.id !== id));
  }
  async function runJobNow(id) {
    setJobRunningId(id);
    await new Promise(r => setTimeout(r, 1400));
    // Simulate a successful run
    const def = CONNECTORS.find(c => c.id === jobs.find(j => j.id === id)?.source);
    setJobs(prev => prev.map(j => {
      if (j.id !== id) return j;
      const type = j.type;
      const lastRun = type === "ml"
        ? { status: "success", timestamp: "Just now", duration: "2m 48s", anomalies: Math.floor(Math.random() * 30) + 5, total: 72 }
        : type === "sync"
          ? { status: "success", timestamp: "Just now", duration: "24s", rows: Math.floor(Math.random() * 4000) + 500 }
          : { status: "success", timestamp: "Just now", duration: "1m 18s",
              passed: 82 + Math.floor(Math.random() * 12),
              failed: 5 + Math.floor(Math.random() * 10),
              total: 95 };
      return { ...j, lastRun };
    }));
    setJobRunningId(null);
  }
  function nextRunLabel(job) {
    if (job.schedule === "manual") return "Manual trigger only";
    if (job.schedule === "hourly") return "In the next hour";
    if (job.schedule === "daily")  return `Tomorrow at ${job.time || "06:00"}`;
    if (job.schedule === "weekly") return `Next week at ${job.time || "06:00"}`;
    if (job.schedule === "monthly")return `Next month at ${job.time || "06:00"}`;
    return "";
  }

  async function aiEvaluateRule(rule, kind) {
    if (!data) return;
    const sample = data.rows.slice(0, 10);
    const descr = kind === "static" ? rule.t : rule.description;
    const meta = kind === "static" ? `${rule.d} / ${rule.x} / ${rule.s}` : `Dynamic / ${rule.dimension} / ${rule.severity}`;
    const sys = `You are an SAP data-quality auditor. Given a rule and up to 10 sample rows, return JSON: {"violations":[{"row":N,"reason":"short"}],"notes":"brief overall comment"}. Return JSON only.`;
    const user = `Rule (${meta}): ${descr}\n\nSample rows (1-indexed):\n${sample.map((r, i) => `${i + 1}: ${JSON.stringify(r)}`).join("\n")}`;
    try {
      const resp = await askClaude([{ role: "user", content: user }], sys);
      const m = resp.match(/\{[\s\S]*\}/);
      const parsed = m ? JSON.parse(m[0]) : { violations: [], notes: resp };
      const newRes = {
        status: "ai-executed",
        primary: "AI",
        total: sample.length,
        failed: parsed.violations?.length || 0,
        passed: sample.length - (parsed.violations?.length || 0),
        pct: sample.length ? +((1 - (parsed.violations?.length || 0) / sample.length) * 100).toFixed(1) : 100,
        failures: (parsed.violations || []).map(v => ({ row: v.row, value: "—", col: "AI", note: v.reason })),
        aiNotes: parsed.notes
      };
      setResults(prev => {
        if (!prev) return prev;
        if (kind === "static") return { ...prev, staticResults: { ...prev.staticResults, [rule.n]: newRes } };
        return { ...prev, dynResults: { ...prev.dynResults, [rule.id]: newRes } };
      });
    } catch (e) { /* silent */ }
  }

  async function sendChat() {
    const text = chatInput.trim();
    if (!text || chatBusy) return;
    const next = [...chat, { role: "user", content: text }];
    setChat(next); setChatInput(""); setChatBusy(true);
    const sys = `You are DataQ Agent, an AI assistant embedded in an SAP master-data quality tool built by IDWTEAM. Be concise, practical, and SAP-literate. Reference specific SAP tables and fields when relevant.

Catalog: ${RULES.length} SAP master data quality rules across 10 domains (MM, Customer, Vendor, BOM, Work Center, Routing, GL Account, Cost Center, Equipment, Info Record). DQ dimensions: Completeness, Validity, Accuracy, Consistency, Uniqueness, Referential, AI-Assisted.
${data ? `Dataset: "${data.name}" with ${data.rows.length} rows and columns ${data.columns.join(", ")}.` : "No dataset loaded."}
Dynamic rules the user has built: ${dynRules.length}.
${results ? `Last run: ${results.summary.passed} passed, ${results.summary.failed} failed, ${results.summary.aiRequired} AI-required.` : ""}

Explain rules in plain English, propose new rules with SAP table/field references, and interpret failures pragmatically.`;
    try {
      const reply = await askClaude(next.map(m => ({ role: m.role, content: m.content })), sys);
      setChat([...next, { role: "assistant", content: reply }]);
    } catch {
      setChat([...next, { role: "assistant", content: "I couldn't reach the AI service just now. Please retry in a moment." }]);
    } finally { setChatBusy(false); }
  }

  // --- RENDER ------------------------------------------------------
  // NOTE: We intentionally do NOT render the bridge's internal LoginPage here.
  // Auth is handled exclusively by App.tsx, which gates BridgeApp behind the
  // real MSAL flow and only mounts us with a populated session via initialAuth.
  // The previous "if (!auth) return <LoginPage />" check caused a visible
  // double-login when session state desynced — a real Entra sign-in followed
  // by the bridge's demo LoginPage rendering on top of it.
  if (!auth) {
    // Defensive: if we ever land here something upstream went wrong; signal it
    // with a neutral loading state rather than rendering a competing login UI.
    return (
      <div className="min-h-screen flex items-center justify-center bg-app text-ink-mute text-sm">
        Restoring your session…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-app font-body text-ink">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=Geist:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

        :root {
          /* IDWTEAM brand palette — sampled from logo */
          --bg: #ffffff;
          --surface: #ffffff;
          --surface-2: #fafaf9;
          --ink: #0b0b0b;
          --ink-soft: #3f3f46;
          --ink-mute: #71717a;
          --border: #e4e4e7;
          --border-strong: #d4d4d8;
          --accent: #dc2814;
          --accent-dark: #b01e0a;
          --accent-soft: #fde8e3;
          --accent-tint: #fff6f3;
        }

        .font-body { font-family: 'Geist', ui-sans-serif, system-ui, sans-serif; }
        .font-display { font-family: 'Fraunces', Georgia, serif; font-optical-sizing: auto; letter-spacing: -0.02em; }
        .font-mono { font-family: 'JetBrains Mono', ui-monospace, monospace; }

        .bg-app { background-color: var(--bg); }
        .bg-surface { background-color: var(--surface); }
        .bg-surface-2 { background-color: var(--surface-2); }
        .bg-accent { background-color: var(--accent); }
        .bg-accent-dark { background-color: var(--accent-dark); }
        .bg-accent-soft { background-color: var(--accent-soft); }
        .bg-accent-tint { background-color: var(--accent-tint); }

        .text-ink { color: var(--ink); }
        .text-ink-soft { color: var(--ink-soft); }
        .text-ink-mute { color: var(--ink-mute); }
        .text-accent { color: var(--accent); }
        .text-accent-dark { color: var(--accent-dark); }

        .border-app { border-color: var(--border); }
        .border-app-strong { border-color: var(--border-strong); }
        .border-accent { border-color: var(--accent); }

        .hover\\:bg-accent-dark:hover { background-color: var(--accent-dark); }
        .hover\\:bg-accent-soft:hover { background-color: var(--accent-soft); }
        .hover\\:bg-surface-2:hover { background-color: var(--surface-2); }
        .hover\\:border-app-strong:hover { border-color: var(--border-strong); }
        .hover\\:text-accent:hover { color: var(--accent); }
        .hover\\:text-ink:hover { color: var(--ink); }
        .focus\\:border-accent:focus { border-color: var(--accent); }

        .paper {
          background-color: var(--surface);
          border: 1px solid var(--border);
          border-radius: 12px;
        }
        .paper-2 {
          background-color: var(--surface-2);
          border: 1px solid var(--border);
          border-radius: 12px;
        }
        .divider { border-color: var(--border); }

        .grain {
          position: relative;
        }
        .grain::before {
          content: ""; position: absolute; inset: 0; pointer-events: none;
          background-image: radial-gradient(circle at 10% 0%, rgba(15, 107, 92, 0.06), transparent 55%),
                            radial-gradient(circle at 90% 15%, rgba(183, 96, 26, 0.05), transparent 50%);
        }

        .tab-link {
          position: relative; padding: 6px 2px; color: var(--ink-mute);
          font-weight: 500; font-size: 14px; transition: color 0.15s;
        }
        .tab-link:hover { color: var(--ink-soft); }
        .tab-link.active { color: var(--ink); }
        .tab-link.active::after {
          content: ""; position: absolute; left: 0; right: 0; bottom: -10px;
          height: 2px; background: var(--accent); border-radius: 2px;
        }

        .scrollbar-thin::-webkit-scrollbar { width: 6px; height: 6px; }
        .scrollbar-thin::-webkit-scrollbar-thumb { background: var(--border-strong); border-radius: 4px; }
        .scrollbar-thin::-webkit-scrollbar-track { background: transparent; }

        .container-max { max-width: 1400px; }
        .text-10 { font-size: 10.5px; line-height: 1.4; }
        .text-xxs { font-size: 11px; line-height: 1.4; }
        .tracking-xwide { letter-spacing: 0.18em; }
        .min-w-search { min-width: 240px; }
        .min-h-card { min-height: 3.5em; }
        .clip-80 { max-width: 80%; }
        .clip-60 { max-width: 60%; }
        .chat-h { height: calc(100vh - 160px); }
        .scroll-260 { max-height: 260px; }
        .scroll-340 { max-height: 340px; }
        .scroll-70vh { max-height: 70vh; }
        .scroll-85vh { max-height: 85vh; }
        .leading-tight-x { line-height: 1.04; }
        .agent-grid { display: grid; grid-template-columns: 1fr 300px; gap: 1rem; }
        @media (max-width: 900px) { .agent-grid { grid-template-columns: 1fr; } }

        .line-clamp-2 {
          display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
        }

        .btn-primary {
          background: var(--accent); color: white; font-weight: 500;
          padding: 10px 16px; border-radius: 8px; display: inline-flex; align-items: center; gap: 8px;
          transition: background 0.15s; font-size: 14px;
        }
        .btn-primary:hover:not(:disabled) { background: var(--accent-dark); }
        .btn-primary:disabled { background: #d8d2bf; cursor: not-allowed; }
        .btn-secondary {
          background: var(--surface); color: var(--ink); font-weight: 500;
          padding: 10px 16px; border-radius: 8px; display: inline-flex; align-items: center; gap: 8px;
          border: 1px solid var(--border-strong); transition: background 0.15s; font-size: 14px;
        }
        .btn-secondary:hover { background: var(--surface-2); }
        .btn-ghost {
          color: var(--ink-soft); font-weight: 500; padding: 6px 10px; border-radius: 6px;
          font-size: 13px; display: inline-flex; align-items: center; gap: 6px;
          transition: color 0.15s, background 0.15s;
        }
        .btn-ghost:hover { color: var(--accent); background: var(--accent-tint); }

        .chip {
          display: inline-flex; align-items: center; gap: 4px;
          padding: 2px 8px; border: 1px solid; border-radius: 999px;
          font-size: 10.5px; font-weight: 500; letter-spacing: 0.04em; text-transform: uppercase;
        }

        .input-base {
          background: var(--surface); border: 1px solid var(--border-strong);
          border-radius: 8px; padding: 8px 12px; font-size: 14px; color: var(--ink);
          transition: border-color 0.15s;
        }
        .input-base:focus { outline: none; border-color: var(--accent); }

        @keyframes pulse-dot { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }
        .pulse-dot { animation: pulse-dot 2s ease-in-out infinite; }

        /* Left sidebar navigation */
        .sidebar {
          width: 248px; min-width: 248px; flex-shrink: 0;
          background: var(--surface);
          border-right: 1px solid var(--border);
          padding: 20px 14px 24px;
          position: sticky; top: 64px;
          height: calc(100vh - 64px);
          overflow-y: auto;
        }
        .sidebar-section-title {
          font-size: 10.5px; font-weight: 600; text-transform: uppercase;
          letter-spacing: 0.12em; color: var(--ink-mute);
          padding: 14px 12px 6px;
        }
        .sidebar-item {
          position: relative;
          display: flex; align-items: center; gap: 11px;
          width: 100%; padding: 9px 12px;
          border-radius: 8px; cursor: pointer;
          color: var(--ink-soft); font-size: 13.5px; font-weight: 500;
          transition: background 0.12s, color 0.12s;
          text-align: left; border: none; background: transparent;
        }
        .sidebar-item:hover { background: var(--surface-2); color: var(--ink); }
        .sidebar-item.active {
          background: var(--accent-tint);
          color: var(--accent-dark);
          font-weight: 600;
        }
        .sidebar-item.active::before {
          content: ""; position: absolute; left: -14px; top: 8px; bottom: 8px;
          width: 3px; background: var(--accent); border-radius: 0 2px 2px 0;
        }
        .sidebar-item.locked { color: var(--ink-mute); cursor: not-allowed; }
        .sidebar-item.locked:hover { background: transparent; }
        .sidebar-item-icon { flex-shrink: 0; opacity: 0.85; }
        .sidebar-item.active .sidebar-item-icon { opacity: 1; }
        .sidebar-group-header {
          display: flex; align-items: center; gap: 10px;
          width: 100%; padding: 9px 12px;
          background: transparent; border: none; cursor: pointer;
          color: var(--ink); font-size: 13.5px; font-weight: 600;
          border-radius: 8px; position: relative;
        }
        .sidebar-group-header:hover { background: var(--surface-2); }
        .sidebar-group-header.active { background: var(--accent-tint); color: var(--accent-dark); }
        .sidebar-group-header.active::before {
          content: ""; position: absolute; left: -14px; top: 8px; bottom: 8px;
          width: 3px; background: var(--accent); border-radius: 0 2px 2px 0;
        }
        .sidebar-group-items { padding-left: 26px; margin-top: 2px; }
        .sidebar-group-items .sidebar-item { font-size: 13px; padding: 7px 12px; font-weight: 500; }

        .app-main {
          background: var(--bg);
        }
        .main-inner {
          max-width: 1180px;
        }
      `}</style>

      {/* HEADER */}
      <header className="bg-surface border-b border-app sticky top-0 z-40">
        <div className="px-6 h-16 flex items-center justify-between">
          <button onClick={() => setTab("home")} className="flex items-center gap-4 hover:opacity-90 transition-opacity">
            <img src={IDWTEAM_LOGO} alt="IDWTEAM" className="h-8 w-auto" />
            <div className="h-8 w-px" style={{ background: "var(--border-strong)" }} />
            <div className="text-left">
              <div className="font-display text-lg leading-none">DataQ<span className="text-accent">.</span>Agent</div>
              <div className="text-10 uppercase tracking-xwide text-ink-mute mt-0.5">Master Data Quality</div>
            </div>
          </button>
          <div className="flex items-center gap-3 text-xs">
            {data ? (
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-soft border border-app">
                <span className="w-1.5 h-1.5 rounded-full bg-accent pulse-dot" />
                <span className="text-accent-dark font-medium">{data.rows.length} rows loaded</span>
              </div>
            ) : (
              <div className="px-3 py-1.5 rounded-full bg-surface-2 border border-app text-ink-mute">No data loaded</div>
            )}
            <UserMenu user={auth} onSignOut={async () => {
              try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const { signOut } = await import("@services/auth");
                await signOut();
              } catch (err) {
                console.warn("Sign-out call failed; clearing local session:", err);
              }
              setAuth(null);
            }} />
          </div>
        </div>
      </header>

      {/* BODY: sidebar + main */}
      <div className="flex">
        <Sidebar tab={tab} setTab={setTab} myPermissions={myPermissions} />
        <main className="flex-1 min-w-0 app-main">
          <div className="mx-auto main-inner px-8 py-10">
            {tab === "home" && <HomeTab stats={stats} onLoadSample={() => { loadSample(); setTab("build"); }} onGo={setTab} />}
            {tab === "admin" && (
              <AdminTab
                connectors={connectors}
                users={users}
                jobs={jobs}
                repoConfig={repoConfig}
                myPermissions={myPermissions}
                onGo={setTab}
              />
            )}
            {tab === "catalog" && (
              <CatalogTab
                filters={filters} setFilters={setFilters}
                domains={domains} dimensions={dimensions}
                rules={filteredStatic} onOpen={setDetailRule}
              />
            )}
            {tab === "build" && (
              myPermissions.build ? (
                <BuildTab
                  data={data} onLoadSample={loadSample} onFile={onFile}
                  profiles={profiles}
                  dynRules={dynRules} onAddDynamic={addDynamicRule} onRemoveDynamic={removeDynamicRule}
                  connectors={connectors} onLoadFromConnector={loadFromConnector}
                />
              ) : <AccessDenied feature="Build Rules" onGoHome={() => setTab("home")} />
            )}
            {tab === "connectors" && (
              <ConnectorsTab
                connectors={connectors}
                onOpen={openConnector}
                onDisconnect={disconnectConnector}
              />
            )}
            {tab === "security" && (
              <SecurityTab
                users={users}
                currentUserEmail={auth.email}
                onToggle={togglePermission}
                onRoleChange={changeRole}
                onAdd={addUser}
                onRemove={removeUser}
              />
            )}
            {tab === "ml" && (
              myPermissions.ml ? (
                <MLInsightsTab
                  data={data} onLoadSample={loadSample} onFile={onFile}
                  connectors={connectors} onLoadFromConnector={loadFromConnector}
                  results={mlResults} running={mlRunning} onRun={runML}
                />
              ) : <AccessDenied feature="ML Insights" onGoHome={() => setTab("home")} />
            )}
            {tab === "jobs" && (
              myPermissions.jobs ? (
                <JobsTab
                  jobs={jobs}
                  runningId={jobRunningId}
                  onCreate={() => openJobModal(null)}
                  onEdit={openJobModal}
                  onToggle={toggleJob}
                  onDelete={deleteJob}
                  onRunNow={runJobNow}
                />
              ) : <AccessDenied feature="Jobs" onGoHome={() => setTab("home")} />
            )}
            {tab === "dashboard" && (
              myPermissions.agent ? (
                <DashboardTab
                  jobs={jobs}
                  results={results}
                  mlResults={mlResults}
                  dynRulesCount={dynRules.length}
                />
              ) : <AccessDenied feature="Dashboard" onGoHome={() => setTab("home")} />
            )}
            {tab === "repository" && (
              <RepositoryTab
                config={repoConfig}
                onSave={setRepoConfig}
              />
            )}
            {tab === "validate" && (
              myPermissions.validate ? (
                <ValidateTab
                  data={data} onFile={onFile} onLoadSample={loadSample}
                  applicableStatic={applicableStatic}
                  dynRules={dynRules}
                  selectedStatic={selectedStatic} setSelectedStatic={setSelectedStatic}
                  selectedDynamic={selectedDynamic} setSelectedDynamic={setSelectedDynamic}
                  onAutoSelectStatic={autoSelectApplicableStatic}
                  onRun={runValidation} running={running}
                  onGoBuild={() => setTab("build")}
                />
              ) : <AccessDenied feature="Validate" onGoHome={() => setTab("home")} />
            )}
            {tab === "results" && (
              myPermissions.results ? (
                <ResultsTab
                  results={results} data={data} dynRules={dynRules}
                  onAiEvaluate={aiEvaluateRule} onOpenRule={setDetailRule}
                />
              ) : <AccessDenied feature="Results" onGoHome={() => setTab("home")} />
            )}
            {tab === "agent" && (
              myPermissions.agent ? (
                <AgentTab chat={chat} input={chatInput} setInput={setChatInput} onSend={sendChat} busy={chatBusy} />
              ) : <AccessDenied feature="AI Agent" onGoHome={() => setTab("home")} />
            )}
          </div>
        </main>
      </div>

      {detailRule && <RuleDetailModal rule={detailRule} onClose={() => setDetailRule(null)} />}
      {connectorDraft && (
        <ConnectorConfigModal
          draft={connectorDraft}
          onClose={() => setConnectorDraft(null)}
          onField={updateConnectorField}
          onTest={testConnector}
          onSave={saveConnector}
          isConfigured={!!connectors[connectorDraft.id]}
        />
      )}
      {jobDraft && (
        <JobModal
          draft={jobDraft}
          onClose={() => setJobDraft(null)}
          onSave={saveJob}
          connectors={connectors}
        />
      )}
    </div>
  );
}

// =============================================================================
// HOME
// =============================================================================
function HomeTab({ stats, onLoadSample, onGo }) {
  return (
    <div className="grain relative">
      <div className="max-w-4xl">
        <div className="chip bg-accent-soft text-accent-dark border-app mb-6">
          <Shield className="w-3 h-3" /> SAP Master Data · Rule-based + AI-assisted
        </div>
        <h1 className="font-display text-5xl md:text-6xl leading-tight-x mb-6">
          Catch data issues before they reach <em className="text-accent not-italic">production</em>.
        </h1>
        <p className="text-ink-soft text-lg leading-relaxed max-w-2xl mb-8">
          Browse 484 pre-built data quality rules across ten SAP master-data domains, let the profiler suggest rules from your data, or write rules in plain English. DataQ Agent runs everything through one engine — with an AI agent on standby for the business-logic checks.
        </p>
        <div className="flex flex-wrap gap-3 mb-16">
          <button onClick={onLoadSample} className="btn-primary">
            <FlaskConical className="w-4 h-4" /> Try with sample data
            <ArrowRight className="w-4 h-4" />
          </button>
          <button onClick={() => onGo("catalog")} className="btn-secondary">
            <BookOpen className="w-4 h-4" /> Browse the rule catalog
          </button>
          <button onClick={() => onGo("build")} className="btn-secondary">
            <Wand2 className="w-4 h-4" /> Build custom rules
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-16">
        <Stat label="Static rules" value={stats.rules} />
        <Stat label="SAP domains" value={stats.domains} />
        <Stat label="DQ dimensions" value={stats.dimensions} />
        <Stat label="Critical" value={stats.critical} emphasis="critical" />
        <Stat label="AI-assisted" value={stats.aiAssisted} emphasis="accent" />
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <Feature icon={BookOpen} title="Static rule catalog"
          body="484 production-grade rules across MM, Customer, Vendor, BOM, Routing, Work Center, GL Account, Cost Center, Equipment and Info Record — each tagged with severity, dimension, tables and method." />
        <Feature icon={Wand2} title="Dynamic rules from profiling"
          body="Upload your data and the profiler inspects every column — null rate, length variance, negatives, uniqueness — and suggests one-click rules grounded in what your data actually looks like." />
        <Feature icon={PenLine} title="Rules in plain English"
          body="Type &ldquo;material description must be at least 10 characters&rdquo; and the LLM converts it into a typed, executable rule. No JSON, no SQL — just write what you mean." />
      </div>
    </div>
  );
}

function Stat({ label, value, emphasis }) {
  const tone = emphasis === "critical" ? "text-red-800" : emphasis === "accent" ? "text-accent" : "text-ink";
  return (
    <div className="paper p-4">
      <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">{label}</div>
      <div className={`font-display text-3xl ${tone}`}>{value}</div>
    </div>
  );
}

function Feature({ icon: Icon, title, body }) {
  return (
    <div className="paper p-5">
      <div className="w-9 h-9 rounded-lg bg-accent-tint flex items-center justify-center mb-3">
        <Icon className="w-4 h-4 text-accent" />
      </div>
      <div className="font-display text-lg mb-1.5">{title}</div>
      <div className="text-sm text-ink-soft leading-relaxed">{body}</div>
    </div>
  );
}

// =============================================================================
// CATALOG
// =============================================================================
function CatalogTab({ filters, setFilters, domains, dimensions, rules, onOpen }) {
  // Total catalog size for the "Total Rules" KPI — always absolute.
  const totalCatalog = RULES.length;

  // Severity tile counts use the FULL catalog so the tiles always show absolute
  // totals (the user needs to see "95 Critical exist" even when only Medium is
  // currently selected — otherwise the tiles become unusable as a filter UI).
  const severityCounts = useMemo(() => {
    const c = { Critical: 0, High: 0, Medium: 0 };
    RULES.forEach(r => { if (c[r.s] !== undefined) c[r.s]++; });
    return c;
  }, []);

  // Domain and Dimension bars use the FILTERED rule set so the bars reflect the
  // current view. When the user clicks Critical, the bars re-compute to show
  // only Critical rules' breakdown by domain and dimension.
  const filteredCounts = useMemo(() => {
    const byDomain: Record<string, number> = {};
    const byDimension: Record<string, number> = {};
    rules.forEach(r => {
      byDomain[r.d] = (byDomain[r.d] || 0) + 1;
      byDimension[r.x] = (byDimension[r.x] || 0) + 1;
    });
    return { byDomain, byDimension };
  }, [rules]);

  // Backwards-compatible shape for the rest of the render — `counts.bySeverity`
  // stays absolute (for KPI tiles), `counts.byDomain` / `counts.byDimension`
  // are filtered (for bars).
  const counts = {
    bySeverity: severityCounts,
    byDomain: filteredCounts.byDomain,
    byDimension: filteredCounts.byDimension
  };

  // KPI tile click toggles the severity filter (clicking the active one clears it)
  const onTileClick = (sev) => {
    setFilters({ ...filters, severity: filters.severity === sev ? "All" : sev });
  };

  // Bar segment click toggles a domain or dimension filter
  const onBarClick = (kind, value) => {
    if (kind === "domain") {
      setFilters({ ...filters, domain: filters.domain === value ? "All" : value });
    } else {
      setFilters({ ...filters, dimension: filters.dimension === value ? "All" : value });
    }
  };

  // (Filtered rules are grouped inline at render time — see the rendering loop below.
  // We deliberately do NOT memoize the grouping here because some browsers were
  // serving a stale closure when filters changed.)

  const hasFilters = filters.q || filters.domain !== "All" || filters.severity !== "All" || filters.dimension !== "All";
  const sortedDomains = Object.entries(counts.byDomain).sort((a, b) => b[1] - a[1]);
  const sortedDimensions = Object.entries(counts.byDimension).sort((a, b) => b[1] - a[1]);
  // Guard: when filtered set is empty, Math.max of an empty list is -Infinity.
  // Use 1 as a floor so the bar widths don't go NaN. The empty-state UI will
  // already be showing a "no rules match" message in this case.
  const maxDomain = Math.max(1, ...Object.values(counts.byDomain));
  const maxDim = Math.max(1, ...Object.values(counts.byDimension));

  return (
    <div>
      {/* Header */}
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-display text-4xl mb-1">Rule Catalog</h2>
          <p className="text-sm text-ink-mute">
            {hasFilters ? `${rules.length} matching rules · ${totalCatalog} total` : `${totalCatalog} SAP master data quality rules`}
          </p>
        </div>
      </div>

      {/* KPI tiles — click to filter by severity */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <KpiTile
          label="Total Rules"
          value={totalCatalog}
          icon={<Layers className="w-4 h-4" />}
          color="ink"
          active={false}
          onClick={() => setFilters({ q: "", domain: "All", severity: "All", dimension: "All" })}
          subtitle={hasFilters ? "Click to clear filters" : "Across 10 SAP domains"}
        />
        <KpiTile
          label="Critical"
          value={counts.bySeverity.Critical}
          icon={<AlertTriangle className="w-4 h-4" />}
          color="critical"
          active={filters.severity === "Critical"}
          onClick={() => onTileClick("Critical")}
          subtitle={`${((counts.bySeverity.Critical / totalCatalog) * 100).toFixed(0)}% of catalog`}
        />
        <KpiTile
          label="High"
          value={counts.bySeverity.High}
          icon={<TrendingUp className="w-4 h-4" />}
          color="high"
          active={filters.severity === "High"}
          onClick={() => onTileClick("High")}
          subtitle={`${((counts.bySeverity.High / totalCatalog) * 100).toFixed(0)}% of catalog`}
        />
        <KpiTile
          label="Medium"
          value={counts.bySeverity.Medium}
          icon={<Info className="w-4 h-4" />}
          color="medium"
          active={filters.severity === "Medium"}
          onClick={() => onTileClick("Medium")}
          subtitle={`${((counts.bySeverity.Medium / totalCatalog) * 100).toFixed(0)}% of catalog`}
        />
      </div>

      {/* Bar charts — rules per domain and per dimension */}
      <div className="grid md:grid-cols-2 gap-4 mb-6">
        <div className="paper p-5">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs font-semibold text-ink-soft uppercase tracking-wider">Rules by Domain</div>
            {filters.domain !== "All" && (
              <button onClick={() => setFilters({ ...filters, domain: "All" })} className="text-10 text-ink-mute hover:text-ink underline">
                Clear ({filters.domain})
              </button>
            )}
          </div>
          <div className="space-y-2">
            {sortedDomains.length === 0 ? (
              <div className="text-10 text-ink-mute italic py-2">No rules in current view</div>
            ) : sortedDomains.map(([dom, n]) => {
              const isActive = filters.domain === dom;
              const widthPct = (n / maxDomain) * 100;
              return (
                <button
                  key={dom}
                  onClick={() => onBarClick("domain", dom)}
                  className="w-full text-left group"
                  style={{ display: 'block' }}
                >
                  <div className="flex items-center justify-between mb-1">
                    <span className={`text-xs font-medium ${isActive ? "text-accent-dark" : "text-ink-soft group-hover:text-ink"}`}>
                      {dom}
                    </span>
                    <span className={`text-10 font-mono ${isActive ? "text-accent-dark" : "text-ink-mute"}`}>{n}</span>
                  </div>
                  <div className="h-1.5 bg-surface-2 rounded-full overflow-hidden">
                    <div
                      className={isActive ? "h-full bg-accent" : "h-full bg-ink-mute group-hover:bg-ink-soft"}
                      style={{ width: `${widthPct}%`, transition: 'width 0.3s, background 0.15s' }}
                    />
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        <div className="paper p-5">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs font-semibold text-ink-soft uppercase tracking-wider">Rules by Dimension</div>
            {filters.dimension !== "All" && (
              <button onClick={() => setFilters({ ...filters, dimension: "All" })} className="text-10 text-ink-mute hover:text-ink underline">
                Clear ({filters.dimension})
              </button>
            )}
          </div>
          <div className="space-y-2">
            {sortedDimensions.length === 0 ? (
              <div className="text-10 text-ink-mute italic py-2">No rules in current view</div>
            ) : sortedDimensions.map(([dim, n]) => {
              const isActive = filters.dimension === dim;
              const widthPct = (n / maxDim) * 100;
              return (
                <button
                  key={dim}
                  onClick={() => onBarClick("dimension", dim)}
                  className="w-full text-left group"
                  style={{ display: 'block' }}
                >
                  <div className="flex items-center justify-between mb-1">
                    <span className={`text-xs font-medium ${isActive ? "text-accent-dark" : "text-ink-soft group-hover:text-ink"}`}>
                      {dim}
                    </span>
                    <span className={`text-10 font-mono ${isActive ? "text-accent-dark" : "text-ink-mute"}`}>{n}</span>
                  </div>
                  <div className="h-1.5 bg-surface-2 rounded-full overflow-hidden">
                    <div
                      className={isActive ? "h-full bg-accent" : "h-full bg-ink-mute group-hover:bg-ink-soft"}
                      style={{ width: `${widthPct}%`, transition: 'width 0.3s, background 0.15s' }}
                    />
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Search + clear */}
      <div className="flex flex-wrap gap-3 mb-4 items-center">
        <div className="relative flex-1 min-w-search">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-mute" />
          <input
            value={filters.q} onChange={e => setFilters({ ...filters, q: e.target.value })}
            placeholder="Search rule text, fields, or tables..."
            className="input-base w-full pl-9"
          />
        </div>
        {hasFilters && (
          <button onClick={() => setFilters({ domain: "All", severity: "All", dimension: "All", q: "" })}
            className="btn-ghost"><X className="w-3 h-3" /> Clear all filters</button>
        )}
      </div>

      {/* Active filter chips */}
      {hasFilters && (
        <div className="flex flex-wrap gap-2 mb-4 items-center">
          <span className="text-10 uppercase tracking-wider text-ink-mute">Active:</span>
          {filters.severity !== "All" && (
            <FilterChip label={`Severity: ${filters.severity}`} onRemove={() => setFilters({ ...filters, severity: "All" })} />
          )}
          {filters.domain !== "All" && (
            <FilterChip label={`Domain: ${filters.domain}`} onRemove={() => setFilters({ ...filters, domain: "All" })} />
          )}
          {filters.dimension !== "All" && (
            <FilterChip label={`Dimension: ${filters.dimension}`} onRemove={() => setFilters({ ...filters, dimension: "All" })} />
          )}
          {filters.q && (
            <FilterChip label={`Search: "${filters.q}"`} onRemove={() => setFilters({ ...filters, q: "" })} />
          )}
        </div>
      )}

      {/* Grouped rule list — keyed on filter signature to force remount on filter change */}
      {rules.length === 0 ? (
        <div className="paper py-20 text-center">
          <Search className="w-8 h-8 text-ink-mute mx-auto mb-3 opacity-50" />
          <div className="text-ink-mute mb-1">No rules match your filters</div>
          <button onClick={() => setFilters({ domain: "All", severity: "All", dimension: "All", q: "" })}
            className="text-xs text-accent hover:text-accent-dark underline mt-2">
            Clear all filters
          </button>
        </div>
      ) : (
        <div
          key={`${filters.severity}|${filters.domain}|${filters.dimension}|${filters.q}|${rules.length}`}
          className="space-y-5 scroll-70vh overflow-y-auto scrollbar-thin pr-2"
        >
          {["Critical", "High", "Medium"].map(sev => {
            // Inline filter from `rules` prop — do NOT rely on the `grouped` memo,
            // which had a stale-closure issue in some browsers after filter changes.
            const sevRules = rules.filter(r => r.s === sev);
            if (sevRules.length === 0) return null;
            return (
              <div key={sev}>
                <div className="flex items-center gap-2 mb-2 sticky top-0 bg-app z-10 py-1">
                  <span className={`w-2 h-2 rounded-full ${SEV_DOT[sev]}`} />
                  <span className="text-xs font-semibold uppercase tracking-wider text-ink">{sev}</span>
                  <span className="text-10 text-ink-mute font-mono">({sevRules.length})</span>
                  <div className="flex-1 h-px bg-app ml-2" />
                </div>
                <div className="space-y-1.5">
                  {sevRules.map(r => <RuleRow key={r.n} rule={r} onOpen={onOpen} />)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// KPI tile for the catalog dashboard. color: 'ink' | 'critical' | 'high' | 'medium'
function KpiTile({ label, value, icon, color, active, onClick, subtitle }) {
  const palette = {
    ink:      { bg: 'var(--surface)', border: 'var(--border)' },
    critical: { bg: '#fef2f2', border: '#fecaca' },
    high:     { bg: '#fff7ed', border: '#fed7aa' },
    medium:   { bg: '#fefce8', border: '#fde68a' }
  }[color];
  const activePalette = {
    ink:      { bg: 'var(--ink)', text: '#fff' },
    critical: { bg: '#dc2626',    text: '#fff' },
    high:     { bg: '#ea580c',    text: '#fff' },
    medium:   { bg: '#ca8a04',    text: '#fff' }
  }[color];
  return (
    <button
      onClick={onClick}
      className="text-left transition-all hover:shadow-sm"
      style={{
        background: active ? activePalette.bg : palette.bg,
        border: `1px solid ${active ? activePalette.bg : palette.border}`,
        borderRadius: '10px',
        padding: '14px 16px',
        cursor: 'pointer',
        color: active ? activePalette.text : 'inherit'
      }}
    >
      <div className="flex items-center justify-between mb-2">
        <div className="text-10 uppercase tracking-wider font-semibold" style={{ opacity: active ? 0.85 : 0.7 }}>
          {label}
        </div>
        <div style={{ opacity: active ? 1 : 0.5 }}>{icon}</div>
      </div>
      <div className="font-display text-3xl leading-none mb-1">{value}</div>
      <div className="text-10" style={{ opacity: active ? 0.85 : 0.55 }}>{subtitle}</div>
    </button>
  );
}

// Removable filter chip used at the top of the catalog list
function FilterChip({ label, onRemove }) {
  return (
    <button
      onClick={onRemove}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-tint border border-accent-soft text-accent-dark hover:bg-accent-soft transition-colors"
      style={{ fontSize: '0.6875rem', fontWeight: 500 }}
    >
      {label}
      <X className="w-3 h-3" />
    </button>
  );
}

// Compact rule row for the grouped catalog list (replaces the old RuleCard grid)
function RuleRow({ rule, onOpen }) {
  return (
    <button
      onClick={() => onOpen(rule)}
      className="w-full paper hover:bg-surface-2 hover:border-app-strong px-4 py-3 text-left transition-colors group flex items-start gap-3"
    >
      <span className="font-mono text-10 text-ink-mute flex-shrink-0 mt-0.5" style={{ minWidth: '32px' }}>
        #{String(rule.n).padStart(3, "0")}
      </span>
      <div className="flex-1 min-w-0">
        <div className="text-sm leading-snug group-hover:text-accent-dark mb-1.5 truncate">{rule.t}</div>
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-10 px-1.5 py-0.5 rounded bg-surface-2 border border-app text-ink-soft font-medium">
            {rule.d}
          </span>
          <span className={`text-10 px-1.5 py-0.5 rounded border ${DIM_STYLES[rule.x]}`}>
            {rule.x}
          </span>
          <span className="font-mono text-10 text-ink-mute truncate">{rule.b}</span>
        </div>
      </div>
      <ChevronRight className="w-4 h-4 text-ink-mute group-hover:text-accent flex-shrink-0 mt-1 transition-colors" />
    </button>
  );
}

// RuleCard: kept as alias to RuleRow for any legacy callers in the bridge.
const RuleCard = RuleRow;

function FilterSelect({ label, value, options, onChange }) {
  return (
    <div className="relative">
      <select value={value} onChange={e => onChange(e.target.value)} className="input-base appearance-none pr-9 cursor-pointer">
        {options.map(o => <option key={o} value={o}>{label}: {o}</option>)}
      </select>
      <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
    </div>
  );
}

// =============================================================================
// STEPPER — reusable numbered-step indicator with subtitles + click-to-jump
// =============================================================================
function Stepper({ steps, current, onJump }) {
  // steps: [{ key, label, status: "complete"|"current"|"upcoming"|"locked", subtitle? }]
  return (
    <div className="paper p-4 mb-5">
      <div className="flex items-center gap-1.5 sm:gap-2">
        {steps.map((s, i) => {
          const isClickable = (s.status === "complete" || s.status === "current") && onJump;
          const isLast = i === steps.length - 1;
          return (
            <React.Fragment key={s.key}>
              <button
                disabled={!isClickable}
                onClick={() => isClickable && onJump(s.key)}
                className="flex items-center gap-2.5 flex-1 min-w-0 group"
                style={{
                  background: 'transparent', border: 'none',
                  cursor: isClickable ? 'pointer' : 'default',
                  textAlign: 'left',
                  padding: '4px 8px',
                  borderRadius: '8px'
                }}
              >
                <div
                  className="flex-shrink-0 flex items-center justify-center font-semibold transition-all"
                  style={{
                    width: '28px', height: '28px', borderRadius: '50%',
                    fontSize: '0.8125rem',
                    background: s.status === "complete" ? 'var(--accent)'
                              : s.status === "current"  ? 'var(--ink)'
                              : 'var(--surface-2)',
                    color: s.status === "upcoming" || s.status === "locked" ? 'var(--ink-mute)' : '#fff',
                    border: s.status === "current" ? '2px solid var(--accent)' : '1px solid var(--border)'
                  }}
                >
                  {s.status === "complete" ? <Check className="w-3.5 h-3.5" /> : (i + 1)}
                </div>
                <div className="min-w-0 flex-1 hidden sm:block">
                  <div
                    className="truncate"
                    style={{
                      fontSize: '0.8125rem',
                      fontWeight: s.status === "current" ? 600 : 500,
                      color: s.status === "upcoming" || s.status === "locked" ? 'var(--ink-mute)'
                           : s.status === "current" ? 'var(--ink)' : 'var(--ink-soft)'
                    }}
                  >
                    {s.label}
                  </div>
                  {s.subtitle && (
                    <div className="truncate text-10" style={{ color: 'var(--ink-mute)' }}>
                      {s.subtitle}
                    </div>
                  )}
                </div>
              </button>
              {!isLast && (
                <div className="flex-shrink-0" style={{
                  width: '20px', height: '1px',
                  background: s.status === "complete" ? 'var(--accent)' : 'var(--border)'
                }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

// =============================================================================
// DATA SOURCE STEPPER FLOW — Step 1 (source) + Step 2 (object) + step3Content
// Used by ML Insights and Build Rules to share the same source-picking UX.
// =============================================================================
function DataSourceStepperFlow({
  data, connectors,
  onFile, onLoadSample, onLoadFromConnector,
  currentStep, setCurrentStep,
  step3Content, step3Label, step3Subtitle
}) {
  const step1Status = data ? "complete" : (currentStep === "source" ? "current" : "upcoming");
  const step2Status = !data ? "locked"
                    : currentStep === "object" ? "current"
                    : (data ? "complete" : "upcoming");
  const step3Status = !data ? "locked"
                    : currentStep === "analyze" ? "current"
                    : "upcoming";

  const sourceLabel = data
    ? (data.connectorId
        ? `${CONNECTORS.find(c => c.id === data.connectorId)?.name || data.connectorId}`
        : (data.name || "Loaded dataset"))
    : "Pick where your data lives";
  const objectLabel = data
    ? (data.tableName ? `Table: ${data.tableName} · ${data.rows.length.toLocaleString()} rows`
                       : `${data.rows.length.toLocaleString()} rows · ${data.columns.length} columns`)
    : "Choose a table or file";

  const steps = [
    { key: "source",  label: "Choose data source", status: step1Status, subtitle: sourceLabel },
    { key: "object",  label: "Select object",      status: step2Status, subtitle: objectLabel },
    { key: "analyze", label: step3Label,           status: step3Status, subtitle: step3Subtitle }
  ];

  return (
    <>
      {/* Show full stepper only when picking source/object — collapse to one-line breadcrumb on analyze */}
      {currentStep !== "analyze" && (
        <Stepper steps={steps} current={currentStep} onJump={setCurrentStep} />
      )}

      {currentStep === "source" && (
        <Step1SourcePicker
          connectors={connectors}
          onFile={(e) => { onFile(e); setCurrentStep("analyze"); }}
          onLoadSample={() => { onLoadSample(); setCurrentStep("analyze"); }}
          onPickConnector={() => setCurrentStep("object")}
        />
      )}

      {currentStep === "object" && (
        <Step2ObjectPicker
          connectors={connectors}
          onLoadFromConnector={(id, table) => {
            onLoadFromConnector(id, table);
            setCurrentStep("analyze");
          }}
          onBack={() => setCurrentStep("source")}
        />
      )}

      {currentStep === "analyze" && data && (
        <>
          {/* Compact breadcrumb — one line, leaves room for action below */}
          <div className="flex items-center justify-between mb-4 px-1">
            <div className="flex items-center gap-2 text-xs text-ink-mute min-w-0 flex-1">
              <CheckCircle2 className="w-3.5 h-3.5 text-accent flex-shrink-0" />
              <button onClick={() => setCurrentStep("source")} className="text-ink-mute hover:text-ink underline-offset-2 hover:underline truncate" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 'inherit' }}>
                {sourceLabel}
              </button>
              {data.tableName && (
                <>
                  <ChevronRight className="w-3 h-3 flex-shrink-0" />
                  <span className="font-mono text-ink-soft truncate">{data.tableName}</span>
                </>
              )}
              <span className="text-ink-mute">·</span>
              <span className="font-mono">{data.rows.length.toLocaleString()} rows</span>
              <span className="text-ink-mute">·</span>
              <span className="font-mono">{data.columns.length} cols</span>
            </div>
            <button onClick={() => setCurrentStep("source")} className="btn-ghost flex-shrink-0">
              <RefreshCw className="w-3 h-3" /> Change source
            </button>
          </div>

          {step3Content}
        </>
      )}
    </>
  );
}

// =============================================================================
// STEP 1 — Pick the source (connector / file / sample)
// =============================================================================
function Step1SourcePicker({ connectors, onFile, onLoadSample, onPickConnector }) {
  const configuredConnectors = Object.entries(connectors).filter(([, v]) => v?.configured);

  return (
    <div>
      <div className="mb-4">
        <h3 className="font-display text-xl mb-1">Where is your data?</h3>
        <p className="text-xs text-ink-mute">Pick a configured connector for live data, upload a CSV, or use the bundled sample.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-3 mb-4">
        {/* Connector tile */}
        <button
          onClick={onPickConnector}
          disabled={configuredConnectors.length === 0}
          className="paper text-left p-4 hover:border-accent disabled:opacity-50 disabled:cursor-not-allowed transition-colors group"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 rounded-lg bg-accent-tint flex items-center justify-center group-hover:bg-accent-soft transition-colors">
              <Plug className="w-5 h-5 text-accent" />
            </div>
            {configuredConnectors.length > 0 ? (
              <span className="chip bg-emerald-50 border-emerald-200 text-emerald-800">
                <Check className="w-3 h-3" /> {configuredConnectors.length} connected
              </span>
            ) : (
              <span className="chip bg-surface-2 text-ink-mute">None configured</span>
            )}
          </div>
          <div className="font-medium mb-1">Live connector</div>
          <div className="text-xs text-ink-soft mb-3 leading-relaxed">
            Pull live tables from SAP S/4HANA, ECC, Kinaxis, JDE, Oracle, or Databricks.
          </div>
          {configuredConnectors.length > 0 ? (
            <div className="flex items-center gap-1 text-10 text-accent-dark font-medium">
              Select object <ArrowRight className="w-3 h-3" />
            </div>
          ) : (
            <div className="text-10 text-ink-mute italic">Configure under Admin → Connectors first</div>
          )}
        </button>

        {/* File upload tile */}
        <label className="paper text-left p-4 hover:border-accent cursor-pointer transition-colors group">
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 rounded-lg bg-accent-tint flex items-center justify-center group-hover:bg-accent-soft transition-colors">
              <Upload className="w-5 h-5 text-accent" />
            </div>
            <span className="chip bg-surface-2 text-ink-mute">CSV</span>
          </div>
          <div className="font-medium mb-1">Upload a file</div>
          <div className="text-xs text-ink-soft mb-3 leading-relaxed">
            Drop a CSV with a header row. Processed in-browser; never leaves this session.
          </div>
          <div className="flex items-center gap-1 text-10 text-accent-dark font-medium">
            Choose file <ArrowRight className="w-3 h-3" />
          </div>
          <input type="file" accept=".csv,text/csv" className="hidden" onChange={onFile} />
        </label>

        {/* Sample tile */}
        <button
          onClick={onLoadSample}
          className="paper text-left p-4 hover:border-accent transition-colors group"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 rounded-lg bg-accent-tint flex items-center justify-center group-hover:bg-accent-soft transition-colors">
              <FlaskConical className="w-5 h-5 text-accent" />
            </div>
            <span className="chip bg-amber-50 border-amber-200 text-amber-800">Demo</span>
          </div>
          <div className="font-medium mb-1">Sample dataset</div>
          <div className="text-xs text-ink-soft mb-3 leading-relaxed">
            Bundled SAP material master extract. Instant load, ideal for evaluating the platform.
          </div>
          <div className="flex items-center gap-1 text-10 text-accent-dark font-medium">
            Load sample <ArrowRight className="w-3 h-3" />
          </div>
        </button>
      </div>

      <div className="paper-2 p-4 text-xs text-ink-soft flex items-start gap-2">
        <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-accent" />
        <span>Connectors require Admin configuration with credentials managed by IT. Once configured, individual users pick tables here without touching credentials.</span>
      </div>
    </div>
  );
}

// =============================================================================
// STEP 2 — Object/table picker for the chosen connector
// =============================================================================
function Step2ObjectPicker({ connectors, onLoadFromConnector, onBack }) {
  const configured = Object.entries(connectors).filter(([, v]) => v?.configured);
  const [activeConn, setActiveConn] = useState(configured[0]?.[0] || null);
  const [domainFilter, setDomainFilter] = useState("All");

  const tables = activeConn ? (CONNECTOR_TABLES[activeConn] || []) : [];
  const filteredTables = domainFilter === "All" ? tables : tables.filter(t => t.domain === domainFilter);
  const def = activeConn ? CONNECTORS.find(c => c.id === activeConn) : null;

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <button onClick={onBack} className="btn-ghost"><ArrowLeft className="w-3 h-3" /> Back</button>
        <div>
          <h3 className="font-display text-xl mb-0.5">Pick a table</h3>
          <p className="text-xs text-ink-mute">Choose the SAP object you want to analyze.</p>
        </div>
      </div>

      {/* Connector switcher tabs */}
      {configured.length > 1 && (
        <div className="flex gap-2 mb-4 flex-wrap">
          {configured.map(([id]) => {
            const c = CONNECTORS.find(x => x.id === id);
            const Icon = c?.icon || Server;
            const isActive = activeConn === id;
            return (
              <button
                key={id}
                onClick={() => { setActiveConn(id); setDomainFilter("All"); }}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg border transition-colors"
                style={{
                  borderColor: isActive ? 'var(--accent)' : 'var(--border)',
                  background: isActive ? 'var(--accent-tint)' : 'var(--surface)',
                  color: isActive ? 'var(--accent-dark)' : 'var(--ink-soft)',
                  fontSize: '0.8125rem',
                  fontWeight: isActive ? 600 : 500
                }}
              >
                <div className="w-5 h-5 rounded flex items-center justify-center"
                     style={{ backgroundColor: c?.tone || "#71717a" }}>
                  <Icon className="w-3 h-3 text-white" strokeWidth={2} />
                </div>
                {c?.name}
                <span className="text-10 text-ink-mute font-mono">({(CONNECTOR_TABLES[id] || []).length})</span>
              </button>
            );
          })}
        </div>
      )}

      {/* Connector header for single-connector case */}
      {def && configured.length <= 1 && (
        <div className="paper p-4 mb-4 flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: def.tone }}>
            {(() => { const Icon = def.icon || Server; return <Icon className="w-5 h-5 text-white" strokeWidth={2} />; })()}
          </div>
          <div className="flex-1">
            <div className="font-medium">{def.name}</div>
            <div className="text-10 text-ink-mute">{tables.length} tables · {def.category}</div>
          </div>
          <span className="chip bg-emerald-50 border-emerald-200 text-emerald-800">
            <Check className="w-3 h-3" /> Connected
          </span>
        </div>
      )}

      {/* Domain filter */}
      <div className="flex items-center gap-1.5 mb-3 flex-wrap">
        <span className="text-10 uppercase tracking-xwide text-ink-mute mr-1">Filter by domain:</span>
        {["All", ...new Set(tables.map(t => t.domain))].map(d => (
          <button
            key={d}
            onClick={() => setDomainFilter(d)}
            className={`chip ${domainFilter === d ? "text-white border-accent" : "bg-surface text-ink-soft border-app hover:border-app-strong"}`}
            style={domainFilter === d ? { backgroundColor: "var(--accent)", borderColor: "var(--accent)" } : undefined}
          >
            {d} <span className="opacity-60">({d === "All" ? tables.length : tables.filter(t => t.domain === d).length})</span>
          </button>
        ))}
      </div>

      {/* Tables grid */}
      {filteredTables.length === 0 ? (
        <div className="paper p-10 text-center">
          <TableIcon className="w-7 h-7 mx-auto text-ink-mute mb-2 opacity-50" />
          <div className="text-sm text-ink-mute">No {domainFilter} tables in this connector.</div>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {filteredTables.map(t => (
            <button
              key={t.name}
              onClick={() => onLoadFromConnector(activeConn, t.name)}
              className="paper p-3 text-left hover:border-accent hover:bg-accent-tint transition-colors group"
            >
              <div className="flex items-start gap-2.5">
                <div className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0 bg-accent-tint group-hover:bg-accent-soft transition-colors">
                  <TableIcon className="w-4 h-4 text-accent-dark" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="font-mono text-xs text-accent-dark font-semibold">{t.name}</span>
                    <span className="chip bg-surface-2 text-ink-soft border-app">{t.domain}</span>
                  </div>
                  <div className="text-11 text-ink-soft leading-snug mb-1.5">{t.description}</div>
                  <div className="text-10 text-ink-mute font-mono">{t.rows.toLocaleString()} rows</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// =============================================================================
// DATA SOURCE PICKER — lets user load from a configured connector OR upload CSV
// =============================================================================
function DataSourcePicker({ connectors, onFile, onLoadSample, onLoadFromConnector }) {
  const configured = Object.entries(connectors).filter(([, v]) => v?.configured);
  const [expandedConnector, setExpandedConnector] = useState(configured[0]?.[0] || null);
  const [domainFilter, setDomainFilter] = useState("All");

  return (
    <div className="grid lg:grid-cols-3 gap-4">
      {/* LEFT (spans 2): Connected sources */}
      <div className="lg:col-span-2 paper p-5">
        <div className="flex items-center gap-2 mb-4">
          <Plug className="w-4 h-4 text-accent" />
          <div className="font-medium">Load from a configured connector</div>
          {configured.length > 0 && (
            <span className="chip bg-accent-soft text-accent-dark" style={{ borderColor: "transparent" }}>
              {configured.length} connected
            </span>
          )}
        </div>

        {configured.length === 0 ? (
          <div className="text-center py-10">
            <Plug className="w-8 h-8 mx-auto text-ink-mute mb-2" />
            <div className="text-sm text-ink-soft mb-3">No connectors configured yet.</div>
            <div className="text-xs text-ink-mute max-w-sm mx-auto">
              Go to Admin → Connectors to connect SAP ECC, S/4HANA, Kinaxis, JDE, Oracle, or your data lake. Once connected, you can pick tables here directly.
            </div>
          </div>
        ) : (
          <div className="space-y-2">
            {configured.map(([id]) => {
              const def = CONNECTORS.find(c => c.id === id);
              const tables = CONNECTOR_TABLES[id] || [];
              const isOpen = expandedConnector === id;
              const filtered = domainFilter === "All" ? tables : tables.filter(t => t.domain === domainFilter);
              const Icon = def?.icon || Server;
              return (
                <div key={id} className="rounded-lg border border-app overflow-hidden">
                  <button
                    onClick={() => setExpandedConnector(isOpen ? null : id)}
                    className="w-full flex items-center gap-3 p-3 hover:bg-surface-2 transition-colors"
                  >
                    <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                         style={{ backgroundColor: def?.tone || "#71717a" }}>
                      <Icon className="w-4 h-4 text-white" strokeWidth={2} />
                    </div>
                    <div className="flex-1 min-w-0 text-left">
                      <div className="text-sm font-medium">{def?.name}</div>
                      <div className="text-10 text-ink-mute mt-0.5">
                        {tables.length} tables available · {def?.category}
                      </div>
                    </div>
                    <ChevronDown className={`w-4 h-4 text-ink-mute transition-transform ${isOpen ? "rotate-180" : ""}`} />
                  </button>
                  {isOpen && (
                    <div className="border-t divider bg-surface-2 p-3">
                      {/* Domain filter */}
                      <div className="flex items-center gap-1.5 mb-3 flex-wrap">
                        <span className="text-10 uppercase tracking-xwide text-ink-mute mr-1">Filter:</span>
                        {["All", ...new Set(tables.map(t => t.domain))].map(d => (
                          <button key={d}
                            onClick={() => setDomainFilter(d)}
                            className={`chip ${domainFilter === d ? "text-white border-accent" : "bg-surface text-ink-soft border-app hover:border-app-strong"}`}
                            style={domainFilter === d ? { backgroundColor: "var(--accent)", borderColor: "var(--accent)" } : undefined}>
                            {d}
                          </button>
                        ))}
                      </div>
                      {filtered.length === 0 ? (
                        <div className="text-center py-6 text-xs text-ink-mute">No {domainFilter} tables in this connector.</div>
                      ) : (
                        <div className="grid sm:grid-cols-2 gap-2">
                          {filtered.map(t => (
                            <button
                              key={t.name}
                              onClick={() => onLoadFromConnector(id, t.name)}
                              className="paper p-3 text-left hover:border-app-strong hover:bg-surface transition-colors"
                            >
                              <div className="flex items-start gap-2.5">
                                <div className="w-7 h-7 rounded flex items-center justify-center flex-shrink-0 bg-accent-tint">
                                  <TableIcon className="w-3.5 h-3.5 text-accent-dark" />
                                </div>
                                <div className="flex-1 min-w-0">
                                  <div className="flex items-center gap-2 mb-0.5">
                                    <span className="font-mono text-xs text-accent-dark">{t.name}</span>
                                    <span className="chip bg-surface-2 text-ink-soft border-app">{t.domain}</span>
                                  </div>
                                  <div className="text-11 text-ink-soft leading-snug">{t.description}</div>
                                  <div className="text-10 text-ink-mute font-mono mt-1">{t.rows.toLocaleString()} rows</div>
                                </div>
                              </div>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* RIGHT: CSV upload + sample */}
      <div className="paper p-5">
        <div className="flex items-center gap-2 mb-4">
          <FileSpreadsheet className="w-4 h-4 text-accent" />
          <div className="font-medium">Or upload a CSV file</div>
        </div>
        <label className="block border-2 border-dashed border-app-strong hover:border-accent rounded-lg p-6 text-center cursor-pointer transition-colors">
          <Upload className="w-7 h-7 mx-auto text-ink-mute mb-2" />
          <div className="text-sm font-medium mb-1">Click to upload</div>
          <div className="text-10 text-ink-mute">Header row required · CSV format</div>
          <input type="file" accept=".csv,text/csv" className="hidden" onChange={onFile} />
        </label>

        <div className="text-center my-4 text-10 uppercase tracking-xwide text-ink-mute">or</div>

        <button onClick={onLoadSample} className="btn-secondary w-full justify-center">
          <FlaskConical className="w-4 h-4" /> Load sample Material Master
        </button>

        <div className="mt-5 pt-5 border-t border-app">
          <div className="flex items-start gap-2 text-xs text-ink-mute leading-relaxed">
            <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-accent" />
            <span>Uploads are processed in your browser. For production, configure a connector instead — the backend streams extracts securely through your VNet.</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// Slim source strip that appears above the profile once data is loaded
function LoadedSourceStrip({ data, connectors, onFile, onLoadSample, onLoadFromConnector }) {
  const [expanded, setExpanded] = useState(false);
  const sourceIsConnector = !!data.connectorId;
  const def = sourceIsConnector ? CONNECTORS.find(c => c.id === data.connectorId) : null;
  const Icon = def?.icon || FileSpreadsheet;

  return (
    <div className="paper mb-5 overflow-hidden">
      <div className="flex items-center gap-3 p-4">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
             style={{ backgroundColor: def?.tone || "#71717a" }}>
          <Icon className="w-5 h-5 text-white" strokeWidth={2} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <span className="text-10 uppercase tracking-xwide text-ink-mute">
              {sourceIsConnector ? "Loaded from connector" : "Loaded from file"}
            </span>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <span className="font-mono text-sm text-accent-dark">{data.name}</span>
            <span className="text-xs text-ink-mute">·</span>
            <span className="text-xs text-ink-soft"><span className="font-medium text-ink">{data.rows.length.toLocaleString()}</span> rows</span>
            <span className="text-xs text-ink-mute">·</span>
            <span className="text-xs text-ink-soft"><span className="font-medium text-ink">{data.columns.length}</span> columns</span>
          </div>
        </div>
        <button onClick={() => setExpanded(e => !e)} className="btn-secondary">
          <RefreshCw className="w-3.5 h-3.5" /> Switch source
        </button>
      </div>
      {expanded && (
        <div className="border-t divider bg-surface-2 p-4">
          <DataSourcePicker
            connectors={connectors}
            onFile={(e) => { onFile(e); setExpanded(false); }}
            onLoadSample={() => { onLoadSample(); setExpanded(false); }}
            onLoadFromConnector={(id, t) => { onLoadFromConnector(id, t); setExpanded(false); }}
          />
        </div>
      )}
    </div>
  );
}

// =============================================================================
// BUILD — profile + NL rule builder + dynamic rules list
// =============================================================================
function BuildTab({ data, onLoadSample, onFile, profiles, dynRules, onAddDynamic, onRemoveDynamic,
                   connectors, onLoadFromConnector }) {
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSugs, setSelectedSugs] = useState(new Set());
  const [nlText, setNlText] = useState("");
  const [nlBusy, setNlBusy] = useState(false);
  const [nlPreview, setNlPreview] = useState(null);
  const [nlError, setNlError] = useState("");

  // Auto-populate suggestions whenever the profile changes (new data loaded)
  useEffect(() => {
    if (profiles && profiles.length > 0 && data?.rows?.length > 0) {
      const s = suggestRulesFromProfile(profiles, data.rows);
      setSuggestions(s);
      setSelectedSugs(new Set());        // reset selection on new data
    } else {
      setSuggestions([]);
      setSelectedSugs(new Set());
    }
  }, [profiles, data]);

  function doSuggest() {
    const s = suggestRulesFromProfile(profiles, data?.rows || []);
    setSuggestions(s);
    setSelectedSugs(new Set());
  }

  function toggleSug(id) {
    setSelectedSugs(prev => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  }
  function addSelected() {
    const selectedList = suggestions.filter(s => selectedSugs.has(s.id)
      && !dynRules.some(r => r.column === s.column && r.type === s.type));
    selectedList.forEach(onAddDynamic);
    setSelectedSugs(new Set());
  }

  async function doNl() {
    if (!nlText.trim() || nlBusy || !data) return;
    setNlBusy(true); setNlError(""); setNlPreview(null);
    try {
      const rule = await nlToRule(nlText, data.columns);
      setNlPreview(rule);
    } catch (e) {
      setNlError("Couldn't parse that into a rule. Try rewording — mention a specific column and what the value should be.");
    } finally { setNlBusy(false); }
  }

  function acceptNl() {
    if (!nlPreview) return;
    onAddDynamic(nlPreview);
    setNlPreview(null);
    setNlText("");
  }

  // -----------------------------------------------------------------------------
  // Inner tab state — which section is active.
  // Tabs: connect | profile | suggest | nl | manual
  //
  // When no data is loaded, only the Connect tab is enabled (others would be
  // empty/meaningless). Once data lands, we auto-switch to Profile so the user
  // sees their column stats immediately.
  // -----------------------------------------------------------------------------
  const [innerTab, setInnerTab] = useState("connect");

  // Auto-jump to Profile the first time data loads (from Connect or elsewhere).
  useEffect(() => {
    if (data && innerTab === "connect") {
      setInnerTab("profile");
    }
    // Intentionally not depending on innerTab to avoid bouncing back if the
    // user navigates back to Connect to swap data sources.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.name]);

  // Counts for tab badges so users can see activity without clicking through
  const addableSuggestionCount = suggestions.filter(
    s => !dynRules.some(r => r.column === s.column && r.type === s.type)
  ).length;

  // -----------------------------------------------------------------------------
  // Tab definitions (label, icon, badge, enabled-when-data-only?)
  // -----------------------------------------------------------------------------
  const TABS = [
    { id: "connect", label: "Connect",      icon: Plug,        badge: null,                          requiresData: false },
    { id: "profile", label: "Profile",      icon: BarChart3,   badge: data ? profiles.length : null, requiresData: true  },
    { id: "suggest", label: "Suggest",      icon: Lightbulb,   badge: addableSuggestionCount || null, requiresData: true  },
    { id: "nl",      label: "NL Builder",   icon: PenLine,     badge: null,                          requiresData: true  },
    { id: "manual",  label: "Manual Rules", icon: Layers,      badge: dynRules.length || null,       requiresData: false }
  ];

  // -----------------------------------------------------------------------------
  // Empty state — no data loaded yet. Show only the Connect tab content,
  // since profiling/suggesting/etc. all need a dataset to act on.
  // -----------------------------------------------------------------------------
  if (!data) {
    return (
      <div>
        <div className="mb-6">
          <h2 className="font-display text-4xl mb-1">Build Rules</h2>
          <p className="text-sm text-ink-mute">
            Start by connecting a data source. Once data is loaded you can profile it,
            see suggested rules, write rules in plain English, or manage rules manually.
          </p>
        </div>

        {/* Tab strip — most tabs disabled until data is loaded */}
        <BuildInnerTabs tabs={TABS} active={innerTab} onChange={setInnerTab} dataLoaded={false} />

        {/* Only Connect tab body shows here, regardless of state, since others have no data */}
        <div className="mt-5">
          <DataSourcePicker
            connectors={connectors}
            onFile={onFile}
            onLoadSample={onLoadSample}
            onLoadFromConnector={onLoadFromConnector}
          />
        </div>
      </div>
    );
  }

  // -----------------------------------------------------------------------------
  // Data-loaded state — full tab UI, all tabs enabled, body switches by innerTab.
  // -----------------------------------------------------------------------------
  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-display text-4xl mb-1">Build Rules</h2>
          <p className="text-sm text-ink-mute">Profile your data, accept suggestions, write rules in plain English, or build them manually.</p>
        </div>
        <div className="text-sm text-ink-soft">
          <span className="font-medium text-ink">{dynRules.length}</span> dynamic rule{dynRules.length === 1 ? "" : "s"}
        </div>
      </div>

      {/* Loaded source strip — always visible above tabs so users know what data is active */}
      <LoadedSourceStrip
        data={data}
        connectors={connectors}
        onFile={onFile}
        onLoadSample={onLoadSample}
        onLoadFromConnector={onLoadFromConnector}
      />

      {/* Tab strip */}
      <BuildInnerTabs tabs={TABS} active={innerTab} onChange={setInnerTab} dataLoaded={true} />

      {/* Tab body */}
      <div className="mt-5">
        {/* CONNECT tab — show the full picker even when data is loaded, so users can
            swap to a different connector or upload a different file */}
        {innerTab === "connect" && (
          <DataSourcePicker
            connectors={connectors}
            onFile={onFile}
            onLoadSample={onLoadSample}
            onLoadFromConnector={onLoadFromConnector}
          />
        )}

        {/* PROFILE tab — column stats table */}
        {innerTab === "profile" && (
          <div className="paper overflow-hidden">
            <div className="px-5 py-3.5 border-b divider flex items-center justify-between">
              <div className="flex items-center gap-2">
                <BarChart3 className="w-4 h-4 text-accent" />
                <div className="font-medium">Column profile</div>
                <span className="text-xs text-ink-mute">· {profiles.length} columns in {data.name}</span>
              </div>
              <button onClick={doSuggest} className="btn-ghost">
                <RefreshCw className="w-3.5 h-3.5" /> Refresh suggestions
              </button>
            </div>
            <div className="overflow-x-auto scrollbar-thin">
              <table className="w-full text-sm">
                <thead className="bg-surface-2 text-xxs uppercase tracking-wider text-ink-mute">
                  <tr>
                    <th className="text-left px-4 py-2 font-medium">Column</th>
                    <th className="text-left px-4 py-2 font-medium">Type</th>
                    <th className="text-right px-4 py-2 font-medium">Nulls</th>
                    <th className="text-right px-4 py-2 font-medium">Unique</th>
                    <th className="text-left px-4 py-2 font-medium">Range / Length</th>
                    <th className="text-left px-4 py-2 font-medium">Samples</th>
                  </tr>
                </thead>
                <tbody>
                  {profiles.map(p => (
                    <tr key={p.col} className="border-t divider">
                      <td className="px-4 py-2 font-mono text-xs text-accent-dark">{p.col}</td>
                      <td className="px-4 py-2 text-xs text-ink-soft">{p.type}</td>
                      <td className="px-4 py-2 text-right">
                        <span className={`text-xs ${p.nullPct > 0 ? "text-orange-700 font-medium" : "text-ink-mute"}`}>
                          {p.nulls > 0 ? `${p.nulls} (${p.nullPct}%)` : "0"}
                        </span>
                      </td>
                      <td className="px-4 py-2 text-right text-xs">
                        <span className="text-ink-soft">{p.unique}</span>
                        <span className="text-ink-mute"> / {p.nonNull}</span>
                      </td>
                      <td className="px-4 py-2 text-xs text-ink-soft font-mono">
                        {p.type === "numeric" ? (
                          <span>{p.min} – {p.max} <span className="text-ink-mute">(μ {p.mean})</span></span>
                        ) : (
                          p.minLen != null ? <span>{p.minLen}–{p.maxLen} chars <span className="text-ink-mute">(μ {p.avgLen})</span></span> : "—"
                        )}
                      </td>
                      <td className="px-4 py-2 text-xs text-ink-soft">
                        <span className="font-mono truncate inline-block clip-80">
                          {p.samples.slice(0, 3).map(s => s.length > 20 ? s.slice(0, 20) + "…" : s).join(" · ")}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* SUGGEST tab — auto-generated rule suggestions */}
        {innerTab === "suggest" && (
          <div className="paper p-5">
            <div className="flex items-center gap-2 mb-4 flex-wrap">
              <Lightbulb className="w-4 h-4 text-accent" />
              <div className="font-medium">Suggested rules <span className="text-ink-mute text-xs font-normal">· auto-generated from your data profile</span></div>
              {suggestions.length > 0 && (
                <span className="ml-2 chip bg-accent-soft text-accent-dark" style={{ borderColor: "transparent" }}>
                  {suggestions.length} suggestion{suggestions.length === 1 ? "" : "s"}
                </span>
              )}
            </div>

            {suggestions.length === 0 ? (
              <div className="text-center py-8 text-ink-mute text-sm">
                No suggestions surfaced for this dataset. Your data either has no obvious quality patterns to assert, or the profile doesn&rsquo;t match the current heuristics.
                <div className="text-10 mt-2 italic">Try the NL Builder tab to describe a rule yourself.</div>
              </div>
            ) : (() => {
              const addableIds = suggestions
                .filter(s => !dynRules.some(r => r.column === s.column && r.type === s.type))
                .map(s => s.id);
              const selectedAddableCount = addableIds.filter(id => selectedSugs.has(id)).length;
              const allAddableSelected = addableIds.length > 0 && selectedAddableCount === addableIds.length;
              const someSelected = selectedAddableCount > 0;

              const toggleAll = () => {
                if (allAddableSelected) setSelectedSugs(new Set());
                else setSelectedSugs(new Set(addableIds));
              };

              return (
                <>
                  <div className="flex items-center gap-3 mb-3 pb-3 border-b divider">
                    <button onClick={toggleAll}
                      className="flex items-center gap-2 text-xs text-ink-soft hover:text-accent-dark px-2 py-1 rounded transition-colors"
                      disabled={addableIds.length === 0}
                      title={addableIds.length === 0 ? "All suggestions already added" : "Select all addable suggestions"}>
                      {allAddableSelected
                        ? <CheckSquare className="w-4 h-4 text-accent" />
                        : <Square className="w-4 h-4" />}
                      <span className="font-medium">
                        {allAddableSelected ? "Deselect all" : `Select all ${addableIds.length}`}
                      </span>
                    </button>
                    <div className="text-xs text-ink-mute">
                      {someSelected ? <span><span className="font-medium text-ink">{selectedAddableCount}</span> selected</span> : "none selected"}
                    </div>
                    <div className="ml-auto flex items-center gap-2">
                      {someSelected && (
                        <button onClick={() => setSelectedSugs(new Set())} className="btn-ghost">
                          <X className="w-3 h-3" /> Clear
                        </button>
                      )}
                      <button onClick={addSelected} disabled={!someSelected} className="btn-primary">
                        <Plus className="w-3.5 h-3.5" /> Add selected {someSelected ? `(${selectedAddableCount})` : ""}
                      </button>
                    </div>
                  </div>

                  <div className="space-y-2">
                    {suggestions.map(s => {
                      const added = dynRules.some(r => r.id === s.id || (r.column === s.column && r.type === s.type));
                      const checked = selectedSugs.has(s.id);
                      return (
                        <label key={s.id}
                          className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                            added ? "border-app bg-surface-2 opacity-60" :
                            checked ? "border-accent bg-accent-tint" :
                            "border-app bg-surface-2 hover:border-app-strong"
                          }`}>
                          <input type="checkbox"
                            checked={checked}
                            disabled={added}
                            onChange={() => toggleSug(s.id)}
                            className="mt-1 accent-red-600 flex-shrink-0"
                          />
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1 flex-wrap">
                              <span className="font-mono text-xs text-accent-dark">{s.column}</span>
                              <span className={`chip ${SEV_STYLES[s.severity]}`}>{s.severity}</span>
                              <span className={`chip ${DIM_STYLES[s.dimension]}`}>{s.dimension}</span>
                              <span className="chip bg-surface text-ink-soft border-app">{s.type}</span>
                              {added && (
                                <span className="chip bg-accent-soft text-accent-dark" style={{ borderColor: "transparent" }}>
                                  <Check className="w-3 h-3" /> already added
                                </span>
                              )}
                            </div>
                            <div className="text-sm">{s.name}</div>
                            <div className="text-xs text-ink-mute mt-0.5 italic">{s.reason}</div>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                </>
              );
            })()}
          </div>
        )}

        {/* NL BUILDER tab — type a rule in plain English, parse, preview, accept */}
        {innerTab === "nl" && (
          <div className="paper p-5">
            <div className="flex items-center gap-2 mb-3">
              <PenLine className="w-4 h-4 text-accent" />
              <div className="font-medium">Describe a rule in plain English</div>
            </div>
            <p className="text-xs text-ink-soft mb-3">
              Examples: &ldquo;MAKTX must be at least 10 characters&rdquo; · &ldquo;STPRS should be greater than 0 for every row&rdquo; · &ldquo;MATNR must be unique&rdquo; · &ldquo;BRGEW must be greater than or equal to NTGEW&rdquo;
            </p>
            <div className="flex items-start gap-2 mb-3">
              <input
                value={nlText} onChange={e => setNlText(e.target.value)}
                onKeyDown={e => { if (e.key === "Enter") doNl(); }}
                placeholder="Type your rule..."
                className="input-base flex-1"
              />
              <button onClick={doNl} disabled={nlBusy || !nlText.trim()} className="btn-primary">
                {nlBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Wand2 className="w-4 h-4" />}
                {nlBusy ? "Parsing..." : "Generate"}
              </button>
            </div>
            {nlError && <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{nlError}</div>}
            {nlPreview && (
              <div className="rounded-lg border border-app bg-accent-tint p-4">
                <div className="text-xs text-ink-mute uppercase tracking-wider mb-2">Parsed rule</div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-mono text-xs text-accent-dark">{nlPreview.column}</span>
                  <span className={`chip ${SEV_STYLES[nlPreview.severity]}`}>{nlPreview.severity}</span>
                  <span className={`chip ${DIM_STYLES[nlPreview.dimension]}`}>{nlPreview.dimension}</span>
                  <span className="chip bg-surface text-ink-soft border-app">{nlPreview.type}</span>
                </div>
                <div className="text-sm mb-1 font-medium">{nlPreview.name}</div>
                <div className="text-xs text-ink-soft mb-3">{nlPreview.description}</div>
                <div className="flex items-center gap-2">
                  <button onClick={acceptNl} className="btn-primary"><Check className="w-3.5 h-3.5" /> Add rule</button>
                  <button onClick={() => setNlPreview(null)} className="btn-ghost">Discard</button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* MANUAL RULES tab — accumulated dynamic rules with delete */}
        {innerTab === "manual" && (
          <div className="paper p-5">
            <div className="flex items-center gap-2 mb-4">
              <Layers className="w-4 h-4 text-accent" />
              <div className="font-medium">Your dynamic rules</div>
              <span className="text-xs text-ink-mute">· saved for this session</span>
            </div>
            {dynRules.length === 0 ? (
              <div className="text-center py-10 text-ink-mute text-sm">
                No dynamic rules yet. Accept suggestions in the Suggest tab or describe one in NL Builder.
              </div>
            ) : (
              <div className="space-y-2">
                {dynRules.map(r => (
                  <div key={r.id} className="flex items-center gap-3 p-3 rounded-lg border border-app">
                    <span className={`chip ${SEV_STYLES[r.severity]}`}>{r.severity}</span>
                    <span className={`chip ${DIM_STYLES[r.dimension]}`}>{r.dimension}</span>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm truncate">{r.name}</div>
                      <div className="text-xs text-ink-mute">
                        <span className="font-mono text-accent-dark">{r.column}</span>
                        {r.rightCol && <span className="font-mono"> ↔ {r.rightCol}</span>}
                        <span> · {r.type}</span>
                        {r.source === "nl" && <span> · from NL</span>}
                        {r.source === "profile" && <span> · from profile</span>}
                      </div>
                    </div>
                    <button onClick={() => onRemoveDynamic(r.id)} className="text-ink-mute hover:text-red-700 p-1">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// -----------------------------------------------------------------------------
// BuildInnerTabs — small horizontal tab strip used inside BuildTab.
// Tabs that require data are visually disabled (lower opacity, not clickable)
// when no data is loaded yet, so the user is naturally pulled to Connect first.
// -----------------------------------------------------------------------------
function BuildInnerTabs({ tabs, active, onChange, dataLoaded }) {
  return (
    <div className="flex items-center gap-1 border-b border-app overflow-x-auto scrollbar-thin">
      {tabs.map(t => {
        const Icon = t.icon;
        const isActive = active === t.id;
        const isDisabled = t.requiresData && !dataLoaded;
        return (
          <button
            key={t.id}
            onClick={isDisabled ? undefined : () => onChange(t.id)}
            disabled={isDisabled}
            title={isDisabled ? "Connect a data source first" : t.label}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm border-b-2 -mb-px transition-colors flex-shrink-0 ${
              isActive
                ? "border-accent text-accent-dark font-medium"
                : isDisabled
                  ? "border-transparent text-ink-mute opacity-50 cursor-not-allowed"
                  : "border-transparent text-ink-soft hover:text-ink hover:border-app-strong"
            }`}
          >
            <Icon className="w-4 h-4" />
            <span>{t.label}</span>
            {t.badge != null && (
              <span className={`text-10 font-mono px-1.5 py-0.5 rounded ${
                isActive ? "bg-accent-soft text-accent-dark" : "bg-surface-2 text-ink-mute"
              }`}>
                {t.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

// =============================================================================
// VALIDATE
// =============================================================================
function ValidateTab({ data, onFile, onLoadSample, applicableStatic, dynRules, selectedStatic, setSelectedStatic, selectedDynamic, setSelectedDynamic, onAutoSelectStatic, onRun, running, onGoBuild }) {
  const [rulesSection, setRulesSection] = useState("static");
  const totalSelected = selectedStatic.size + selectedDynamic.size;

  return (
    <div>
      <h2 className="font-display text-4xl mb-6">Validate Data</h2>

      <div className="grid md:grid-cols-2 gap-4 mb-5">
        {/* Data */}
        <div className="paper p-5">
          <div className="flex items-center gap-2 mb-4">
            <Upload className="w-4 h-4 text-accent" />
            <div className="font-medium">1 · Load data</div>
          </div>
          <label className="block border-2 border-dashed border-app-strong hover:border-accent rounded-lg p-6 text-center cursor-pointer transition-colors">
            <FileSpreadsheet className="w-6 h-6 mx-auto text-ink-mute mb-2" />
            <div className="text-sm">Click to upload CSV</div>
            <div className="text-xs text-ink-mute mt-1">Header row required.</div>
            <input type="file" accept=".csv,text/csv" className="hidden" onChange={onFile} />
          </label>
          <div className="text-center my-3 text-xxs uppercase tracking-wider text-ink-mute">or</div>
          <button onClick={onLoadSample} className="btn-secondary w-full justify-center">
            <FlaskConical className="w-4 h-4" /> Load sample Material Master
          </button>

          {data && (
            <div className="mt-4 bg-accent-tint border border-app rounded-lg p-3">
              <div className="flex items-center gap-2 text-xs mb-2">
                <CheckCircle2 className="w-4 h-4 text-accent" />
                <span className="font-mono text-accent-dark">{data.name}</span>
              </div>
              <div className="text-xs text-ink-soft">
                <span className="font-medium text-ink">{data.rows.length}</span> rows ·
                <span className="font-medium text-ink ml-1">{data.columns.length}</span> columns
              </div>
            </div>
          )}
        </div>

        {/* Rule picker */}
        <div className="paper p-5">
          <div className="flex items-center gap-2 mb-4">
            <Filter className="w-4 h-4 text-accent" />
            <div className="font-medium">2 · Pick rules</div>
          </div>
          {!data ? (
            <div className="text-sm text-ink-mute text-center py-8">Load data to see applicable rules.</div>
          ) : (
            <>
              <div className="flex items-center gap-1 mb-3 text-xs border-b border-app">
                <button onClick={() => setRulesSection("static")}
                  className={`px-3 py-2 border-b-2 -mb-px ${rulesSection === "static" ? "border-accent text-accent-dark font-medium" : "border-transparent text-ink-mute"}`}>
                  Static catalog <span className="text-ink-mute">({applicableStatic.length})</span>
                </button>
                <button onClick={() => setRulesSection("dynamic")}
                  className={`px-3 py-2 border-b-2 -mb-px ${rulesSection === "dynamic" ? "border-accent text-accent-dark font-medium" : "border-transparent text-ink-mute"}`}>
                  Dynamic rules <span className="text-ink-mute">({dynRules.length})</span>
                </button>
                {rulesSection === "static" && applicableStatic.length > 0 && (
                  <button onClick={onAutoSelectStatic} className="ml-auto btn-ghost">
                    <Zap className="w-3 h-3" /> Select all applicable
                  </button>
                )}
                {rulesSection === "dynamic" && dynRules.length > 0 && (
                  <button onClick={() => setSelectedDynamic(new Set(dynRules.map(r => r.id)))} className="ml-auto btn-ghost">
                    <Zap className="w-3 h-3" /> Select all
                  </button>
                )}
              </div>

              {rulesSection === "static" ? (
                <div className="scroll-260 overflow-y-auto scrollbar-thin space-y-1 pr-1">
                  {applicableStatic.slice(0, 200).map(r => (
                    <RulePickRow key={r.n} id={r.n} checked={selectedStatic.has(r.n)}
                      onToggle={() => {
                        const s = new Set(selectedStatic);
                        s.has(r.n) ? s.delete(r.n) : s.add(r.n); setSelectedStatic(s);
                      }}
                      primary={<span className="font-mono text-xxs text-ink-mute">#{r.n}</span>}
                      severity={r.s} dimension={r.x} text={r.t}
                    />
                  ))}
                  {applicableStatic.length > 200 && <div className="text-xxs text-ink-mute text-center py-2">Showing first 200 of {applicableStatic.length}.</div>}
                </div>
              ) : dynRules.length === 0 ? (
                <div className="text-center py-8">
                  <div className="text-sm text-ink-mute mb-3">No dynamic rules yet.</div>
                  <button onClick={onGoBuild} className="btn-secondary"><Wand2 className="w-4 h-4" /> Build rules</button>
                </div>
              ) : (
                <div className="scroll-260 overflow-y-auto scrollbar-thin space-y-1 pr-1">
                  {dynRules.map(r => (
                    <RulePickRow key={r.id} id={r.id} checked={selectedDynamic.has(r.id)}
                      onToggle={() => {
                        const s = new Set(selectedDynamic);
                        s.has(r.id) ? s.delete(r.id) : s.add(r.id); setSelectedDynamic(s);
                      }}
                      primary={<span className="text-xxs text-accent-dark font-medium">{r.source === "nl" ? "NL" : r.source === "profile" ? "Auto" : "Custom"}</span>}
                      severity={r.severity} dimension={r.dimension} text={r.name}
                    />
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="paper p-4 flex items-center justify-between">
        <div className="text-sm text-ink-soft">
          <span className="font-medium text-ink">{totalSelected}</span> rule{totalSelected === 1 ? "" : "s"} selected
          {data && <> against <span className="font-medium text-ink">{data.rows.length}</span> records</>}
          <span className="text-ink-mute"> · {selectedStatic.size} static + {selectedDynamic.size} dynamic</span>
        </div>
        <button disabled={!data || totalSelected === 0 || running} onClick={onRun} className="btn-primary">
          {running ? <><Loader2 className="w-4 h-4 animate-spin" /> Running...</> : <><Play className="w-4 h-4" /> Run Validation</>}
        </button>
      </div>
    </div>
  );
}

function RulePickRow({ id, checked, onToggle, primary, severity, dimension, text }) {
  return (
    <label className={`flex items-start gap-2 p-2 rounded border cursor-pointer transition-colors ${checked ? "border-accent bg-accent-tint" : "border-app hover:border-app-strong"}`}>
      <input type="checkbox" checked={checked} onChange={onToggle} className="mt-0.5 accent-teal-700" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 mb-0.5">
          {primary}
          <span className={`chip ${SEV_STYLES[severity]}`}>{severity}</span>
          <span className="text-xxs text-ink-mute">{dimension}</span>
        </div>
        <div className="text-xs leading-snug line-clamp-2">{text}</div>
      </div>
    </label>
  );
}

// =============================================================================
// RESULTS
// =============================================================================
function ResultsTab({ results, data, dynRules, onAiEvaluate, onOpenRule }) {
  if (!results) {
    return (
      <div className="text-center py-20">
        <TrendingUp className="w-10 h-10 mx-auto text-ink-mute mb-3" />
        <div className="text-ink-soft">No validation run yet.</div>
        <div className="text-xs text-ink-mute mt-1">Load data and run rules from the Validate tab.</div>
      </div>
    );
  }
  const { summary, staticResults, dynResults } = results;

  const staticRows = Object.entries(staticResults || {}).map(([n, res]) => ({
    kind: "static", rule: RULES.find(r => r.n == n), res
  })).filter(x => x.rule);
  const dynRows = Object.entries(dynResults || {}).map(([id, res]) => ({
    kind: "dynamic", rule: dynRules.find(r => r.id === id), res
  })).filter(x => x.rule);

  const all = [...staticRows, ...dynRows];
  const failed = all.filter(x => (x.res.status === "executed" || x.res.status === "ai-executed") && x.res.failed > 0);
  const passed = all.filter(x => (x.res.status === "executed" || x.res.status === "ai-executed") && x.res.failed === 0);
  const aiReq = all.filter(x => x.res.status === "ai-required");
  const notApp = all.filter(x => x.res.status === "not-applicable" || x.res.status === "no-field");

  return (
    <div>
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="font-display text-4xl mb-1">Validation Results</h2>
          <p className="text-xs text-ink-mute font-mono">Ran {results.ranAt} · {data?.name}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        <Stat label="Rules run" value={summary.total} />
        <Stat label="Passed" value={summary.passed} emphasis="accent" />
        <Stat label="Failed" value={summary.failed} emphasis="critical" />
        <Stat label="AI required" value={summary.aiRequired} />
        <Stat label="Not applicable" value={summary.notApplicable} />
      </div>

      <div className="space-y-4">
        {failed.length > 0 && (
          <Section title={`Failed (${failed.length})`} icon={XCircle} tone="critical">
            <div className="space-y-2">{failed.map(x => <ResultRow key={`${x.kind}-${x.rule.n || x.rule.id}`} item={x} onOpenRule={onOpenRule} />)}</div>
          </Section>
        )}
        {aiReq.length > 0 && (
          <Section title={`AI evaluation available (${aiReq.length})`} icon={Sparkles} tone="accent">
            <div className="space-y-2">
              {aiReq.map(x => (
                <div key={`${x.kind}-${x.rule.n || x.rule.id}`} className="flex items-center gap-3 p-3 rounded-lg border border-app bg-accent-tint">
                  <div className="flex-1 min-w-0">
                    <div className="text-xxs text-ink-mute mb-0.5 font-mono">
                      {x.kind === "static" ? `#${x.rule.n} · ${x.rule.d} · ${x.rule.x}` : `Dynamic · ${x.rule.dimension}`}
                    </div>
                    <div className="text-sm leading-snug">{x.kind === "static" ? x.rule.t : x.rule.name}</div>
                  </div>
                  <button onClick={() => onAiEvaluate(x.rule, x.kind)} className="btn-secondary">
                    <Bot className="w-3.5 h-3.5" /> Ask AI
                  </button>
                </div>
              ))}
            </div>
          </Section>
        )}
        {passed.length > 0 && (
          <Section title={`Passed (${passed.length})`} icon={CheckCircle2} tone="accent">
            <div className="space-y-1">
              {passed.map(x => (
                <div key={`${x.kind}-${x.rule.n || x.rule.id}`} className="flex items-center gap-3 py-1.5 text-sm">
                  <CheckCircle2 className="w-4 h-4 text-accent flex-shrink-0" />
                  <span className="font-mono text-10 text-ink-mute w-12">{x.kind === "static" ? `#${x.rule.n}` : "dyn"}</span>
                  <span className="text-ink-soft truncate flex-1">{x.kind === "static" ? x.rule.t : x.rule.name}</span>
                  <span className="text-xs text-accent font-mono">{x.res.pct}%</span>
                </div>
              ))}
            </div>
          </Section>
        )}
        {notApp.length > 0 && (
          <Section title={`Not applicable (${notApp.length})`} icon={Info} tone="mute">
            <div className="text-xs text-ink-mute">
              Columns referenced but not present in the dataset:
              <div className="mt-2 flex flex-wrap gap-1">
                {[...new Set(notApp.map(x => x.res.primary).filter(Boolean))].slice(0, 40).map(f => (
                  <span key={f} className="font-mono text-10 bg-surface-2 border border-app rounded px-1.5 py-0.5">{f}</span>
                ))}
              </div>
            </div>
          </Section>
        )}
      </div>
    </div>
  );
}

function Section({ title, icon: Icon, tone, children }) {
  const [open, setOpen] = useState(true);
  const toneClass = tone === "critical" ? "text-red-800" : tone === "accent" ? "text-accent-dark" : "text-ink-mute";
  return (
    <div className="paper overflow-hidden">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-5 py-3.5 hover:bg-surface-2 transition-colors">
        <Icon className={`w-4 h-4 ${toneClass}`} />
        <div className={`font-medium ${toneClass}`}>{title}</div>
        <ChevronDown className={`w-4 h-4 text-ink-mute ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-5 pb-5">{children}</div>}
    </div>
  );
}

function ResultRow({ item, onOpenRule }) {
  const [expanded, setExpanded] = useState(false);
  const { kind, rule, res } = item;
  const sev = kind === "static" ? rule.s : rule.severity;
  const label = kind === "static" ? rule.t : rule.name;
  const idLabel = kind === "static" ? `#${rule.n}` : "dyn";
  return (
    <div className="rounded-lg border border-app">
      <div className="flex items-center gap-3 p-3">
        <button onClick={() => setExpanded(!expanded)} className="text-ink-mute hover:text-ink">
          <ChevronRight className={`w-4 h-4 transition-transform ${expanded ? "rotate-90" : ""}`} />
        </button>
        <span className={`w-2 h-2 rounded-full ${SEV_DOT[sev]} flex-shrink-0`} />
        <span className="font-mono text-10 text-ink-mute w-12 flex-shrink-0">{idLabel}</span>
        <button onClick={() => kind === "static" && onOpenRule(rule)} className="flex-1 text-left text-sm truncate hover:text-accent-dark">{label}</button>
        <div className="text-right">
          <div className="text-sm font-medium text-red-800">{res.failed} failed</div>
          <div className="text-10 text-ink-mute font-mono">{res.pct}% pass · {res.total} rows</div>
        </div>
      </div>
      {expanded && (
        <div className="border-t divider bg-surface-2 p-3">
          {res.aiNotes && <div className="text-xs text-accent-dark mb-2 italic">AI: {res.aiNotes}</div>}
          <div className="overflow-x-auto scrollbar-thin">
            <table className="text-xs w-full">
              <thead>
                <tr className="text-ink-mute border-b border-app">
                  <th className="text-left py-1.5 pr-3 font-mono">Row</th>
                  <th className="text-left py-1.5 pr-3 font-mono">Column</th>
                  <th className="text-left py-1.5 pr-3 font-mono">Value</th>
                  <th className="text-left py-1.5 font-mono">Note</th>
                </tr>
              </thead>
              <tbody>
                {res.failures.slice(0, 20).map((f, i) => (
                  <tr key={i} className="border-b border-app">
                    <td className="py-1.5 pr-3 font-mono text-ink-soft">{f.row}</td>
                    <td className="py-1.5 pr-3 font-mono text-accent-dark">{f.col}</td>
                    <td className="py-1.5 pr-3 font-mono text-red-800">{f.value === null || f.value === "" ? "∅" : String(f.value).slice(0, 50)}</td>
                    <td className="py-1.5 text-ink-soft">{f.note || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {res.failures.length > 20 && <div className="text-center text-xs text-ink-mute mt-2">+ {res.failures.length - 20} more</div>}
          </div>
        </div>
      )}
    </div>
  );
}

// =============================================================================
// AI AGENT
// =============================================================================
function AgentTab({ chat, input, setInput, onSend, busy }) {
  const scrollRef = useRef(null);
  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [chat]);

  const starters = [
    "Explain rule #8 — uniqueness of BISMT",
    "Which rules fire most often in automotive migrations?",
    "Propose 5 rules for Vendor bank master data",
    "What does MRP type DISMM = PD mean for DQ checks?"
  ];

  return (
    <div className="agent-grid chat-h">
      <div className="paper flex flex-col overflow-hidden">
        <div className="flex items-center gap-2 px-5 py-3 border-b border-app">
          <Sparkles className="w-4 h-4 text-accent" />
          <div className="font-medium">DataQ Agent</div>
          <div className="text-xs text-ink-mute ml-2">Claude Sonnet · SAP-grounded</div>
        </div>
        <div ref={scrollRef} className="flex-1 overflow-y-auto scrollbar-thin p-5 space-y-4">
          {chat.map((m, i) => (
            <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
              <div className={`clip-80 rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${m.role === "user" ? "bg-accent text-white" : "bg-surface-2 text-ink border border-app"}`}>
                <div style={{ whiteSpace: "pre-wrap" }}>{m.content}</div>
              </div>
            </div>
          ))}
          {busy && <div className="flex items-center gap-2 text-xs text-ink-mute"><Loader2 className="w-3 h-3 animate-spin" /> Thinking...</div>}
        </div>
        <div className="p-3 border-t border-app">
          <div className="flex items-end gap-2">
            <textarea
              value={input} onChange={e => setInput(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); } }}
              rows={1}
              placeholder="Ask about a rule, propose new checks, explain a failure..."
              className="input-base flex-1 resize-none"
            />
            <button onClick={onSend} disabled={busy || !input.trim()} className="btn-primary h-10 w-10 p-0 justify-center">
              <Send className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        <div className="paper p-4">
          <div className="text-xxs uppercase tracking-xwide text-ink-mute mb-3">Try asking</div>
          <div className="space-y-1.5">
            {starters.map(s => (
              <button key={s} onClick={() => setInput(s)}
                className="w-full text-left text-xs text-ink-soft hover:text-accent-dark hover:bg-accent-tint rounded-md px-2.5 py-2 leading-snug transition-colors">
                {s}
              </button>
            ))}
          </div>
        </div>
        <div className="paper p-4 text-xs text-ink-soft leading-relaxed">
          <Info className="w-3.5 h-3.5 inline mr-1.5 -mt-0.5 text-accent" />
          The agent is grounded on your rule catalog and any loaded dataset. It can explain rules, propose new ones, interpret failed records, and suggest SAP-specific remediation.
        </div>
      </div>
    </div>
  );
}

// =============================================================================
// LEFT SIDEBAR NAV
// =============================================================================
function Sidebar({ tab, setTab, myPermissions }) {
  const [adminOpen, setAdminOpen] = useState(true);
  const [agentOpen, setAgentOpen] = useState(true);

  const item = (id, label, Icon, locked = false) => {
    const active = tab === id;
    const cls = `sidebar-item${active ? " active" : ""}${locked ? " locked" : ""}`;
    return (
      <button key={id} className={cls} onClick={() => { if (!locked) setTab(id); }} disabled={locked} title={locked ? "You don't have access to this feature" : undefined}>
        <Icon className="w-4 h-4 sidebar-item-icon" strokeWidth={active ? 2.25 : 2} />
        <span className="flex-1 truncate">{label}</span>
        {locked && <Lock className="w-3 h-3 text-ink-mute" />}
      </button>
    );
  };

  return (
    <aside className="sidebar scrollbar-thin">
      {/* ADMIN group — header acts as a nav link to the admin landing page */}
      <button
        className={`sidebar-group-header${tab === "admin" ? " active" : ""}`}
        onClick={() => { setTab("admin"); setAdminOpen(true); }}
        onDoubleClick={() => setAdminOpen(o => !o)}
      >
        <ShieldCheck className="w-4 h-4 text-ink-soft" strokeWidth={2.25} />
        <span className="flex-1 text-left">Admin</span>
        <span
          role="button" tabIndex={0}
          onClick={(e) => { e.stopPropagation(); setAdminOpen(o => !o); }}
          className="p-0.5 rounded hover:bg-surface-2"
          title={adminOpen ? "Collapse" : "Expand"}
        >
          <ChevronDown className={`w-3.5 h-3.5 text-ink-mute transition-transform ${adminOpen ? "" : "-rotate-90"}`} />
        </span>
      </button>
      {adminOpen && (
        <div className="sidebar-group-items">
          {item("connectors", "Connectors", Plug)}
          {item("security",   "Security",   ShieldCheck)}
          {item("jobs",       "Jobs",       Clock, !myPermissions.jobs)}
          {item("repository", "Repository", Database)}
        </div>
      )}

      {/* CATALOG */}
      <div className="sidebar-section-title">Rule Library</div>
      {item("catalog", "Catalog", BookOpen)}

      {/* MACHINE LEARNING */}
      <div className="sidebar-section-title">Machine Learning</div>
      {item("ml", "ML Insights", Brain, !myPermissions.ml)}

      {/* AI AGENT group */}
      <div className="sidebar-section-title">Workflows</div>
      <button className="sidebar-group-header" onClick={() => setAgentOpen(o => !o)}>
        <Sparkles className="w-4 h-4 text-ink-soft" strokeWidth={2.25} />
        <span className="flex-1 text-left">AI Agent</span>
        <ChevronDown className={`w-3.5 h-3.5 text-ink-mute transition-transform ${agentOpen ? "" : "-rotate-90"}`} />
      </button>
      {agentOpen && (
        <div className="sidebar-group-items">
          {item("dashboard", "Dashboard",  LayoutDashboard, !myPermissions.agent)}
          {item("build",     "Build Rules", Wand2,       !myPermissions.build)}
          {item("validate",  "Validate",    Play,        !myPermissions.validate)}
          {item("results",   "Results",     TrendingUp,  !myPermissions.results)}
          {item("agent",     "Chat",        Bot,         !myPermissions.agent)}
        </div>
      )}
    </aside>
  );
}

// =============================================================================
// ACCESS DENIED (shown when a user navigates to a feature they can't access)
// =============================================================================
function AccessDenied({ feature, onGoHome }) {
  return (
    <div className="paper p-10 text-center max-w-xl mx-auto mt-8">
      <div className="w-14 h-14 rounded-full bg-surface-2 border border-app flex items-center justify-center mx-auto mb-4">
        <Lock className="w-6 h-6 text-ink-mute" />
      </div>
      <h2 className="font-display text-2xl mb-2">Access restricted</h2>
      <p className="text-sm text-ink-soft max-w-sm mx-auto mb-6">
        Your account does not have permission to access <span className="font-medium text-ink">{feature}</span>. Contact an administrator to request access.
      </p>
      <button onClick={onGoHome} className="btn-secondary">
        <Home className="w-4 h-4" /> Back to overview
      </button>
    </div>
  );
}

// =============================================================================
// SECURITY TAB — user / role / permission matrix
// =============================================================================
function SecurityTab({ users, currentUserEmail, onToggle, onRoleChange, onAdd, onRemove }) {
  const [adding, setAdding] = useState(false);
  const [draftName, setDraftName] = useState("");
  const [draftEmail, setDraftEmail] = useState("");
  const [draftRole, setDraftRole] = useState("Data Steward");

  const counts = useMemo(() => {
    const byRole = {};
    Object.keys(ROLES).forEach(r => { byRole[r] = users.filter(u => u.role === r).length; });
    return byRole;
  }, [users]);

  function submit() {
    if (!draftName.trim() || !draftEmail.trim()) return;
    onAdd({ name: draftName.trim(), email: draftEmail.trim(), role: draftRole });
    setDraftName(""); setDraftEmail(""); setDraftRole("Data Steward"); setAdding(false);
  }

  return (
    <div>
      <div className="flex items-end justify-between mb-2">
        <div>
          <h2 className="font-display text-4xl mb-1">Security &amp; Access</h2>
          <p className="text-sm text-ink-mute">Manage users, roles, and feature-level permissions for your workspace.</p>
        </div>
        <button onClick={() => setAdding(a => !a)} className="btn-primary">
          <UserPlus className="w-4 h-4" /> Invite user
        </button>
      </div>

      {/* Stat summary */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 my-6">
        <div className="paper p-4">
          <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">Total users</div>
          <div className="font-display text-3xl">{users.length}</div>
        </div>
        {Object.entries(ROLES).map(([role, def]) => (
          <div key={role} className="paper p-4">
            <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">{role}</div>
            <div className="font-display text-3xl" style={{ color: def.tone }}>{counts[role] || 0}</div>
          </div>
        ))}
      </div>

      {/* Roles explainer */}
      <div className="paper p-5 mb-5">
        <div className="flex items-center gap-2 mb-3">
          <Layers className="w-4 h-4 text-accent" />
          <div className="font-medium">Roles &amp; default permissions</div>
          <span className="text-xs text-ink-mute">· assigning a role resets that user&rsquo;s permissions to the role default</span>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {Object.entries(ROLES).map(([role, def]) => (
            <div key={role} className="rounded-lg border p-3" style={{ borderColor: def.br, background: def.bg }}>
              <div className="flex items-center justify-between mb-2">
                <div className="text-sm font-medium" style={{ color: def.tone }}>{role}</div>
                <div className="text-10 font-mono text-ink-mute">{counts[role] || 0} user{counts[role] === 1 ? "" : "s"}</div>
              </div>
              <div className="flex flex-wrap gap-1">
                {FEATURES.map(f => {
                  const has = def.defaults[f.key];
                  return (
                    <span key={f.key} className="text-10 font-mono px-1.5 py-0.5 rounded border"
                      style={{ background: has ? "#ffffff" : "transparent", color: has ? def.tone : "var(--ink-mute)", borderColor: has ? def.br : "var(--border)", opacity: has ? 1 : 0.55, textDecoration: has ? "none" : "line-through" }}>
                      {f.label}
                    </span>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Invite row */}
      {adding && (
        <div className="paper p-4 mb-5 flex items-end gap-3 flex-wrap">
          <div className="flex-1" style={{ minWidth: "160px" }}>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Full name</label>
            <input value={draftName} onChange={e => setDraftName(e.target.value)} placeholder="Alex Kumar" className="input-base w-full" />
          </div>
          <div className="flex-1" style={{ minWidth: "200px" }}>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Work email</label>
            <input value={draftEmail} onChange={e => setDraftEmail(e.target.value)} placeholder="alex.k@company.com" className="input-base w-full font-mono text-xs" />
          </div>
          <div>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Role</label>
            <div className="relative">
              <select value={draftRole} onChange={e => setDraftRole(e.target.value)} className="input-base appearance-none pr-9 cursor-pointer">
                {Object.keys(ROLES).map(r => <option key={r} value={r}>{r}</option>)}
              </select>
              <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
            </div>
          </div>
          <button onClick={submit} disabled={!draftName.trim() || !draftEmail.trim()} className="btn-primary"><Check className="w-4 h-4" /> Add</button>
          <button onClick={() => setAdding(false)} className="btn-ghost"><X className="w-3.5 h-3.5" /> Cancel</button>
        </div>
      )}

      {/* Users / permissions matrix */}
      <div className="paper overflow-hidden">
        <div className="px-5 py-3.5 border-b divider flex items-center gap-2">
          <Users className="w-4 h-4 text-accent" />
          <div className="font-medium">Users &amp; permissions</div>
          <span className="text-xs text-ink-mute">· toggle feature access per user</span>
        </div>
        <div className="overflow-x-auto scrollbar-thin">
          <table className="w-full text-sm">
            <thead className="bg-surface-2 text-xxs uppercase tracking-wider text-ink-mute">
              <tr>
                <th className="text-left px-5 py-3 font-medium">User</th>
                <th className="text-left px-4 py-3 font-medium">Role</th>
                {FEATURES.map(f => (
                  <th key={f.key} className="px-4 py-3 font-medium text-center">
                    <div className="flex items-center justify-center gap-1.5">
                      <f.icon className="w-3.5 h-3.5" />
                      <span>{f.label}</span>
                    </div>
                  </th>
                ))}
                <th className="text-left px-4 py-3 font-medium">Last active</th>
                <th className="px-2 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => {
                const isMe = u.email === currentUserEmail;
                const roleDef = ROLES[u.role];
                return (
                  <tr key={u.id} className="border-t divider hover:bg-surface-2 transition-colors">
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-accent-tint text-accent-dark font-medium text-xs flex items-center justify-center border border-app">
                          {u.initial}
                        </div>
                        <div>
                          <div className="text-sm font-medium flex items-center gap-1.5">
                            {u.name}
                            {isMe && <span className="text-10 uppercase tracking-xwide text-accent-dark bg-accent-soft px-1.5 rounded">you</span>}
                          </div>
                          <div className="text-10 font-mono text-ink-mute">{u.email}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="relative inline-block">
                        <select
                          value={u.role}
                          onChange={e => onRoleChange(u.id, e.target.value)}
                          disabled={isMe}
                          className="appearance-none bg-transparent border rounded px-2 pr-7 py-1 text-xs font-medium cursor-pointer disabled:cursor-not-allowed"
                          style={{ color: roleDef.tone, borderColor: roleDef.br, background: roleDef.bg }}
                        >
                          {Object.keys(ROLES).map(r => <option key={r} value={r}>{r}</option>)}
                        </select>
                        <ChevronDown className="w-3 h-3 absolute right-1.5 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: roleDef.tone }} />
                      </div>
                    </td>
                    {FEATURES.map(f => (
                      <td key={f.key} className="px-4 py-3 text-center">
                        <button
                          onClick={() => !isMe && onToggle(u.id, f.key)}
                          disabled={isMe}
                          className={`relative inline-flex w-9 h-5 rounded-full transition-colors ${u.permissions[f.key] ? "bg-accent" : "bg-ink-mute"} ${isMe ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
                          style={{ backgroundColor: u.permissions[f.key] ? "var(--accent)" : "#cbd5e1" }}
                          title={isMe ? "You cannot modify your own permissions" : (u.permissions[f.key] ? "Click to revoke" : "Click to grant")}
                        >
                          <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-transform shadow-sm ${u.permissions[f.key] ? "translate-x-4" : "translate-x-0.5"}`} />
                        </button>
                      </td>
                    ))}
                    <td className="px-4 py-3 text-xs text-ink-mute font-mono">{u.lastActive}</td>
                    <td className="px-2 py-3">
                      {!isMe && (
                        <button onClick={() => onRemove(u.id)} className="text-ink-mute hover:text-red-700 p-1" title="Remove user">
                          <Trash2 className="w-3.5 h-3.5" />
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="px-5 py-3 bg-surface-2 border-t border-app text-xs text-ink-mute">
          {users.length} user{users.length === 1 ? "" : "s"} · {FEATURES.length} feature permissions · Changes apply immediately to the current session
        </div>
      </div>

      <div className="paper-2 p-4 mt-6 flex items-start gap-3">
        <Info className="w-4 h-4 text-accent mt-0.5 flex-shrink-0" />
        <div className="text-xs text-ink-soft leading-relaxed">
          Permission changes are session-scoped in this prototype. In production, DataQ Agent syncs roles with Azure AD groups so access is governed by your identity provider. Users without access to a feature see it locked in the sidebar and are redirected if they attempt direct navigation.
        </div>
      </div>
    </div>
  );
}
// =============================================================================
// ML INSIGHTS — stepper-driven flow with anomaly detection + master-detail results
// =============================================================================

// =============================================================================
// ML INSIGHTS TAB — unsupervised anomaly detection on the loaded dataset
// =============================================================================
function MLInsightsTab({ data, onLoadSample, onFile, connectors, onLoadFromConnector, results, running, onRun }) {
  // Stepper state — drives which step is currently visible
  const [currentStep, setCurrentStep] = useState(data ? "analyze" : "source");

  // If data was loaded externally and we're still on "source", advance to analyze
  useEffect(() => {
    if (data && currentStep !== "object") {
      setCurrentStep("analyze");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // The Step 3 content for ML — algorithm cards + run button + results
  // Only constructed when data is present (we're on step 3) to avoid null access
  const step3 = data ? (
    <>
      {!results && !running && (
        <>
          {/* Hero CTA — prominent Run Analysis at top */}
          <div className="paper p-6 mb-5" style={{
            background: 'linear-gradient(135deg, var(--accent-tint) 0%, var(--surface) 100%)',
            border: '1px solid var(--border)'
          }}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex items-start gap-4 flex-1 min-w-0">
                <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center flex-shrink-0">
                  <Brain className="w-6 h-6 text-white" strokeWidth={2} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-display text-2xl mb-1">Run anomaly detection</h3>
                  <p className="text-sm text-ink-soft leading-relaxed">
                    Scan <span className="font-semibold text-ink">{data.rows.length.toLocaleString()}</span> rows across <span className="font-semibold text-ink">{data.columns.length}</span> columns using five unsupervised techniques. All processing in-browser; data never leaves this session.
                  </p>
                </div>
              </div>
              <button onClick={onRun} disabled={running} className="btn-primary flex-shrink-0" style={{ padding: '10px 20px', fontSize: '0.9375rem' }}>
                <Brain className="w-4 h-4" /> Run analysis
              </button>
            </div>
          </div>

          {/* Algorithm cards — technical depth for prospects */}
          <div className="mb-3">
            <div className="text-xs font-semibold text-ink-soft uppercase tracking-wider mb-3">
              What we run · five unsupervised algorithms
            </div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            <AlgorithmCard icon={Activity} tone="#0369a1"
              name="Z-score anomalies" family="Statistical · numeric"
              body="Flag values more than 3σ from the column mean. Catches absurd prices, impossible weights, extreme quantities." />
            <AlgorithmCard icon={BarChart3} tone="#0f766e"
              name="IQR outliers" family="Statistical · numeric"
              body="Tukey fences: values outside Q1 − 1.5·IQR or Q3 + 1.5·IQR. Robust to skew, doesn't need normal distributions." />
            <AlgorithmCard icon={Shuffle} tone="#7c3aed"
              name="Categorical rarity" family="Frequency · categorical"
              body="Values appearing in under 2% of rows. Surfaces typos, misclassifications, and legacy values nobody cleaned up." />
            <AlgorithmCard icon={Fingerprint} tone="#c2410c"
              name="Pattern deviation" family="Structural · identifiers"
              body="Infer the dominant character pattern (e.g., A-9999). Flag records that don't match. Catches malformed IDs." />
            <AlgorithmCard icon={GitCompare} tone="#be185d"
              name="Fuzzy duplicates" family="Similarity · text"
              body="Trigram Jaccard similarity finds near-duplicates that exact-match uniqueness rules miss. 'Acme Inc' vs 'Acme, Inc.'" />
            <AlgorithmCard icon={Brain} tone="#52525b"
              name="Coming soon" family="Multivariate · clustering"
              body="Isolation Forest and k-means outliers — planned for the next release. Runs entirely client-side on up to 50k rows." dim />
          </div>
        </>
      )}

      {running && (
        <div className="paper-2 p-12 flex flex-col items-center justify-center gap-3 text-ink-soft">
          <div className="w-14 h-14 rounded-2xl bg-accent-tint flex items-center justify-center">
            <Loader2 className="w-7 h-7 animate-spin text-accent" />
          </div>
          <div className="text-base font-medium text-ink">Scanning your data</div>
          <div className="text-xs text-ink-mute">Running five algorithms on {data.rows.length.toLocaleString()} rows across {data.columns.length} columns…</div>
        </div>
      )}

      {results && !running && (
        <>
          {/* Headline result */}
          <div className="paper p-5 mb-4" style={{
            borderLeft: results.total > 0 ? '4px solid var(--accent)' : '4px solid #16a34a'
          }}>
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Analysis complete</div>
                {results.total > 0 ? (
                  <div className="font-display text-3xl">
                    <span className="text-accent">{results.total}</span>
                    <span className="text-ink-soft"> issues found</span>
                  </div>
                ) : (
                  <div className="font-display text-3xl text-ink">
                    No issues detected
                  </div>
                )}
                <div className="text-xs text-ink-mute mt-1">
                  Across {results.stats.rowsAnalysed.toLocaleString()} rows · {results.stats.columnsAnalysed} columns
                </div>
              </div>
              <button onClick={onRun} disabled={running} className="btn-secondary">
                <RefreshCw className="w-3.5 h-3.5" /> Re-run
              </button>
            </div>
          </div>

          <MLResultsView results={results} />
        </>
      )}
    </>
  ) : null;

  return (
    <div>
      <div className="mb-5">
        <h2 className="font-display text-4xl mb-1">ML Insights</h2>
        <p className="text-sm text-ink-mute">Pick a data source, choose an object, then run the unsupervised anomaly detection suite.</p>
      </div>

      <DataSourceStepperFlow
        data={data}
        connectors={connectors}
        onFile={onFile}
        onLoadSample={onLoadSample}
        onLoadFromConnector={onLoadFromConnector}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        step3Content={step3}
        step3Label="Run anomaly detection"
        step3Subtitle={results ? `${results.total} findings` : "Five algorithms"}
      />
    </div>
  );
}

function AlgorithmCard({ icon: Icon, tone, name, family, body, dim }) {
  return (
    <div className="paper p-4" style={dim ? { opacity: 0.55 } : undefined}>
      <div className="flex items-center gap-2.5 mb-2">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: tone }}>
          <Icon className="w-4 h-4 text-white" strokeWidth={2.25} />
        </div>
        <div>
          <div className="text-sm font-medium leading-tight">{name}</div>
          <div className="text-10 uppercase tracking-xwide text-ink-mute mt-0.5">{family}</div>
        </div>
      </div>
      <div className="text-xs text-ink-soft leading-relaxed">{body}</div>
    </div>
  );
}

function MLResultsView({ results }) {
  const sections = [
    { key: "numeric", title: "Suspicious values",   tone: "#0f766e", icon: BarChart3,    family: "Numeric outliers",        algorithms: "Z-score · IQR" },
    { key: "rare",    title: "Rare entries",        tone: "#7c3aed", icon: Shuffle,      family: "Uncommon categories",     algorithms: "Frequency analysis" },
    { key: "pattern", title: "Bad formatting",      tone: "#c2410c", icon: Fingerprint,  family: "Malformed identifiers",   algorithms: "Pattern inference" },
    { key: "fuzzy",   title: "Possible duplicates", tone: "#be185d", icon: GitCompare,   family: "Near-matching records",   algorithms: "Trigram Jaccard" }
  ];

  // ------------------------------------------------------------------------
  // PASS / FAIL CALCULATIONS
  // A row is "flagged" if any algorithm produced a finding for that row.
  // (One row × one column may have multiple findings — we collapse to row-level.)
  // ------------------------------------------------------------------------
  const flaggedRows = useMemo(() => {
    const s = new Set();
    [...results.findings.numeric, ...results.findings.rare,
     ...results.findings.pattern, ...results.findings.fuzzy]
      .forEach(f => s.add(f.row));
    return s;
  }, [results]);
  const flaggedCount = flaggedRows.size;
  const cleanRowCount = Math.max(0, results.stats.rowsAnalysed - flaggedCount);
  const passRate = results.stats.rowsAnalysed > 0
    ? (cleanRowCount / results.stats.rowsAnalysed) * 100
    : 100;
  const passRateColor = passRate >= 95 ? '#16a34a' : passRate >= 80 ? '#ca8a04' : '#dc2626';
  const passRateBg    = passRate >= 95 ? '#f0fdf4' : passRate >= 80 ? '#fefce8' : '#fef2f2';
  const passRateBorder = passRate >= 95 ? '#bbf7d0' : passRate >= 80 ? '#fde68a' : '#fecaca';

  // Per-category clean count for tile subtitles
  const categoryRowsClean = (key) => {
    const flaggedInCategory = new Set(results.findings[key].map(f => f.row));
    return Math.max(0, results.stats.rowsAnalysed - flaggedInCategory.size);
  };

  // Clean columns under both definitions
  const columnStats = results.columnStats || [];
  const strictClean = columnStats.filter(c => c.total === 0);
  const thresholdClean = columnStats.filter(c => c.total > 0 && c.failureRate < 0.01);
  const totalCleanish = strictClean.length + thresholdClean.length;

  // Pick the first non-empty category (or 'clean' if everything is clean)
  const firstNonEmpty = sections.find(s => results.findings[s.key].length > 0);
  const [activeKey, setActiveKey] = useState(firstNonEmpty ? firstNonEmpty.key : "clean");
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("count");
  const [cleanTab, setCleanTab] = useState("strict"); // strict | threshold

  // Filter findings within active category by search text
  const activeSection = sections.find(s => s.key === activeKey);
  const allActiveFindings = activeSection ? (results.findings[activeKey] || []) : [];
  const filteredFindings = useMemo(() => {
    if (!search.trim()) return allActiveFindings;
    const q = search.trim().toLowerCase();
    return allActiveFindings.filter(f =>
      String(f.col).toLowerCase().includes(q) ||
      String(f.value || "").toLowerCase().includes(q) ||
      String(f.reason || "").toLowerCase().includes(q)
    );
  }, [allActiveFindings, search]);

  // Group filtered findings by column
  const groupedByCol = useMemo(() => {
    const m = {};
    filteredFindings.forEach(f => (m[f.col] ||= []).push(f));
    let entries = Object.entries(m);
    if (sortBy === "count") {
      entries.sort((a, b) => b[1].length - a[1].length);
    } else if (sortBy === "alpha") {
      entries.sort((a, b) => a[0].localeCompare(b[0]));
    } else if (sortBy === "severity") {
      entries.sort((a, b) => {
        const aMax = Math.max(...a[1].map(x => Math.abs(x.score || 0)));
        const bMax = Math.max(...b[1].map(x => Math.abs(x.score || 0)));
        return bMax - aMax;
      });
    }
    return entries;
  }, [filteredFindings, sortBy]);

  // CSV export of currently filtered findings
  function exportCsv() {
    if (filteredFindings.length === 0) return;
    const header = ["Category","Column","Row","Value","Score","Reason"];
    const rows = filteredFindings.map(f => [
      activeSection.title,
      f.col,
      f.row,
      String(f.value === null || f.value === "" ? "" : f.value).replace(/"/g, '""'),
      f.score === undefined ? "" : f.score,
      String(f.reason || "").replace(/"/g, '""')
    ]);
    const csv = [header, ...rows].map(r => r.map(c => `"${c}"`).join(",")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `dataq-${activeKey}-findings.csv`;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  }

  return (
    <>
      {/* ============================================================
          HEADLINE PASS RATE BAND — top of the screen
          ============================================================ */}
      <div className="paper p-5 mb-4" style={{
        background: `linear-gradient(135deg, ${passRateBg} 0%, var(--surface) 60%)`,
        borderLeft: `4px solid ${passRateColor}`
      }}>
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: passRateColor }}>
              {passRate >= 95
                ? <CheckCircle2 className="w-7 h-7 text-white" strokeWidth={2.5} />
                : <AlertTriangle className="w-7 h-7 text-white" strokeWidth={2.5} />
              }
            </div>
            <div>
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Overall data quality</div>
              <div className="font-display text-4xl leading-none" style={{ color: passRateColor }}>
                {passRate.toFixed(1)}<span className="text-2xl">%</span> <span className="text-ink-soft text-2xl font-display">pass rate</span>
              </div>
              <div className="text-xs text-ink-soft mt-1">
                <span className="font-semibold text-ink">{cleanRowCount.toLocaleString()}</span> of <span className="font-semibold text-ink">{results.stats.rowsAnalysed.toLocaleString()}</span> rows clean ·
                <span className="font-semibold" style={{ color: passRate >= 95 ? '#16a34a' : passRateColor, marginLeft: '6px' }}>
                  {flaggedCount.toLocaleString()} flagged
                </span>
              </div>
            </div>
          </div>
          <div className="text-right" style={{ minWidth: '160px' }}>
            <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Column health</div>
            <div className="text-sm">
              <span className="font-semibold text-ink">{strictClean.length}</span>
              <span className="text-ink-mute"> of {results.stats.columnsAnalysed} columns</span>
            </div>
            <div className="text-xs text-ink-mute mt-0.5">100% clean</div>
            {thresholdClean.length > 0 && (
              <div className="text-10 mt-1" style={{ color: '#ca8a04' }}>
                + {thresholdClean.length} below 1% threshold
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ============================================================
          COUNT TILES — pass/fail split per category
          ============================================================ */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {sections.map(s => {
          const isActive = s.key === activeKey;
          const failedRows = new Set(results.findings[s.key].map(f => f.row)).size;
          const cleanRows = Math.max(0, results.stats.rowsAnalysed - failedRows);
          const findingCount = results.findings[s.key].length;
          return (
            <button
              key={s.key}
              onClick={() => { setActiveKey(s.key); setSearch(""); }}
              className="paper p-4 text-left transition-all hover:shadow-sm"
              style={{
                borderColor: isActive ? s.tone : 'var(--border)',
                borderWidth: isActive ? '2px' : '1px',
                background: 'var(--surface)',
                cursor: findingCount === 0 ? 'default' : 'pointer',
                opacity: findingCount === 0 ? 0.55 : 1
              }}
              disabled={findingCount === 0}
            >
              <div className="flex items-center gap-1.5 mb-1.5">
                <s.icon className="w-3 h-3" style={{ color: s.tone }} />
                <div className="text-10 uppercase tracking-xwide" style={{ color: isActive ? s.tone : 'var(--ink-mute)', fontWeight: isActive ? 600 : 400 }}>
                  {s.title}
                </div>
              </div>
              <div className="font-display text-3xl" style={{ color: s.tone }}>{findingCount}</div>
              <div className="text-10 text-ink-mute mt-1 leading-relaxed">
                <span style={{ color: s.tone, fontWeight: 600 }}>{failedRows.toLocaleString()}</span> rows flagged ·
                <span style={{ color: '#16a34a', fontWeight: 600, marginLeft: '4px' }}>{cleanRows.toLocaleString()}</span> clean
              </div>
            </button>
          );
        })}
      </div>

      <div className="text-xs text-ink-mute font-mono mb-4">
        Ran {results.ranAt} · {results.stats.rowsAnalysed.toLocaleString()} rows · {results.stats.columnsAnalysed} columns ({results.stats.numericCols} numeric)
      </div>

      {/* ============================================================
          MASTER-DETAIL: sidebar (Clean + 4 categories) + detail pane
          ============================================================ */}
      <div className="grid lg:grid-cols-[260px_1fr] gap-4">
        {/* LEFT: Sidebar */}
        <div className="paper p-2 lg:sticky lg:top-4 lg:self-start" style={{ height: 'fit-content' }}>
          {/* CLEAN COLUMNS — green-tinted entry above the issue categories */}
          <div className="text-10 uppercase tracking-wider font-semibold text-ink-mute px-2 py-2">
            Health
          </div>
          <div className="space-y-1 mb-2">
            <button
              onClick={() => { setActiveKey("clean"); setSearch(""); }}
              className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-colors text-left"
              style={{
                background: activeKey === "clean" ? '#f0fdf4' : 'transparent',
                borderLeft: activeKey === "clean" ? `3px solid #16a34a` : '3px solid transparent',
                cursor: 'pointer'
              }}
            >
              <div className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#16a34a' }}>
                <CheckCircle2 className="w-3 h-3 text-white" strokeWidth={2.5} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium leading-tight truncate" style={{ color: activeKey === "clean" ? '#15803d' : 'var(--ink)' }}>
                  Clean columns
                </div>
                <div className="text-10 text-ink-mute mt-0.5">No issues detected</div>
              </div>
              <span
                className="font-mono text-10 px-1.5 py-0.5 rounded flex-shrink-0"
                style={{
                  background: activeKey === "clean" ? '#16a34a' : 'var(--surface-2)',
                  color: activeKey === "clean" ? '#fff' : 'var(--ink-soft)',
                  fontWeight: 600
                }}
              >
                {totalCleanish}
              </span>
            </button>
          </div>

          <div className="border-t border-app pt-2 mt-2">
            <div className="text-10 uppercase tracking-wider font-semibold text-ink-mute px-2 py-2">
              Issues found
            </div>
          </div>
          <div className="space-y-1">
            {sections.map(s => {
              const count = results.findings[s.key].length;
              const isActive = s.key === activeKey;
              return (
                <button
                  key={s.key}
                  onClick={() => { setActiveKey(s.key); setSearch(""); }}
                  disabled={count === 0}
                  className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg transition-colors text-left"
                  style={{
                    background: isActive ? 'var(--surface-2)' : 'transparent',
                    borderLeft: isActive ? `3px solid ${s.tone}` : '3px solid transparent',
                    cursor: count === 0 ? 'not-allowed' : 'pointer',
                    opacity: count === 0 ? 0.4 : 1
                  }}
                >
                  <div className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: s.tone }}>
                    <s.icon className="w-3 h-3 text-white" strokeWidth={2.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-xs font-medium leading-tight truncate" style={{ color: isActive ? s.tone : 'var(--ink)' }}>
                      {s.title}
                    </div>
                    <div className="text-10 text-ink-mute mt-0.5">{s.algorithms}</div>
                  </div>
                  <span
                    className="font-mono text-10 px-1.5 py-0.5 rounded flex-shrink-0"
                    style={{
                      background: isActive ? s.tone : 'var(--surface-2)',
                      color: isActive ? '#fff' : 'var(--ink-soft)',
                      fontWeight: 600
                    }}
                  >
                    {count}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="border-t border-app mt-2 pt-2 px-2">
            <div className="text-10 text-ink-mute mb-1">Total findings</div>
            <div className="font-mono text-sm font-semibold text-ink mb-2">{results.total.toLocaleString()}</div>
          </div>
        </div>

        {/* RIGHT: Detail pane */}
        <div className="min-w-0">
          {activeKey === "clean" ? (
            /* CLEAN COLUMNS PANE */
            <CleanColumnsPane
              strictClean={strictClean}
              thresholdClean={thresholdClean}
              activeTab={cleanTab}
              setActiveTab={setCleanTab}
              rowsAnalysed={results.stats.rowsAnalysed}
            />
          ) : results.total === 0 ? (
            <div className="paper p-8 text-center text-ink-soft">
              <CheckCircle2 className="w-8 h-8 mx-auto text-accent mb-3" />
              <div className="text-sm">No anomalies surfaced at default thresholds. Your data looks clean across all five detectors.</div>
            </div>
          ) : (
            <>
              {/* Toolbar */}
              <div className="paper p-3 mb-3 flex items-center gap-2 flex-wrap">
                <div className="flex items-center gap-1.5 mr-2">
                  <activeSection.icon className="w-4 h-4" style={{ color: activeSection.tone }} />
                  <div className="text-sm font-medium" style={{ color: activeSection.tone }}>{activeSection.title}</div>
                  <span className="text-10 text-ink-mute font-mono">
                    {filteredFindings.length === allActiveFindings.length
                      ? `${allActiveFindings.length} findings`
                      : `${filteredFindings.length} of ${allActiveFindings.length}`
                    }
                  </span>
                </div>
                <div className="flex-1" />
                <div className="relative" style={{ minWidth: '180px' }}>
                  <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-ink-mute" />
                  <input
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Filter column or value..."
                    className="input-base w-full pl-8"
                    style={{ fontSize: '0.75rem', padding: '6px 10px 6px 28px' }}
                  />
                </div>
                <select
                  value={sortBy}
                  onChange={e => setSortBy(e.target.value)}
                  className="input-base"
                  style={{ fontSize: '0.75rem', padding: '6px 10px', cursor: 'pointer' }}
                >
                  <option value="count">Most findings</option>
                  <option value="severity">Highest severity</option>
                  <option value="alpha">Column A→Z</option>
                </select>
                <button onClick={exportCsv} className="btn-ghost" disabled={filteredFindings.length === 0}>
                  <FileText className="w-3 h-3" /> Export CSV
                </button>
              </div>

              {/* Findings groups */}
              {filteredFindings.length === 0 ? (
                <div className="paper p-10 text-center">
                  <Search className="w-7 h-7 mx-auto text-ink-mute opacity-50 mb-2" />
                  <div className="text-sm text-ink-mute">No findings match {`"${search}"`}</div>
                  <button onClick={() => setSearch("")} className="text-xs text-accent hover:text-accent-dark underline mt-2">
                    Clear search
                  </button>
                </div>
              ) : (
                <div className="space-y-2">
                  {groupedByCol.map(([col, items]) => (
                    <ColumnFindingsCompact key={col} col={col} items={items} tone={activeSection.tone} />
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

// =============================================================================
// CLEAN COLUMNS PANE — shows columns with zero findings (strict) + < 1% (threshold)
// =============================================================================
function CleanColumnsPane({ strictClean, thresholdClean, activeTab, setActiveTab, rowsAnalysed }) {
  const list = activeTab === "strict" ? strictClean : thresholdClean;
  return (
    <>
      <div className="paper p-3 mb-3 flex items-center gap-2 flex-wrap">
        <CheckCircle2 className="w-4 h-4" style={{ color: '#16a34a' }} />
        <div className="text-sm font-medium" style={{ color: '#15803d' }}>Clean columns</div>
        <span className="text-10 text-ink-mute font-mono">{list.length} columns</span>
        <div className="flex-1" />
        {/* Strict / Threshold tabs */}
        <div className="inline-flex rounded-lg overflow-hidden" style={{ border: '1px solid var(--border)' }}>
          <button
            onClick={() => setActiveTab("strict")}
            style={{
              padding: '6px 12px', fontSize: '0.75rem', fontWeight: 500,
              background: activeTab === "strict" ? '#16a34a' : 'var(--surface)',
              color: activeTab === "strict" ? '#fff' : 'var(--ink-soft)',
              border: 'none', cursor: 'pointer',
              borderRight: '1px solid var(--border)'
            }}
          >
            Strict ({strictClean.length})
          </button>
          <button
            onClick={() => setActiveTab("threshold")}
            style={{
              padding: '6px 12px', fontSize: '0.75rem', fontWeight: 500,
              background: activeTab === "threshold" ? '#ca8a04' : 'var(--surface)',
              color: activeTab === "threshold" ? '#fff' : 'var(--ink-soft)',
              border: 'none', cursor: 'pointer'
            }}
          >
            Below 1% ({thresholdClean.length})
          </button>
        </div>
      </div>

      <div className="paper p-4 mb-3" style={{
        background: activeTab === "strict" ? '#f0fdf4' : '#fefce8',
        borderColor: activeTab === "strict" ? '#bbf7d0' : '#fde68a'
      }}>
        <div className="text-xs leading-relaxed" style={{ color: activeTab === "strict" ? '#166534' : '#854d0e' }}>
          {activeTab === "strict" ? (
            <>
              <strong>Strict pass.</strong> These columns had <strong>zero findings</strong> across all five algorithms. {rowsAnalysed.toLocaleString()} values per column passed every check.
            </>
          ) : (
            <>
              <strong>Below threshold.</strong> These columns had findings but at a rate below 1% of rows — generally acceptable for production but worth a periodic review.
            </>
          )}
        </div>
      </div>

      {list.length === 0 ? (
        <div className="paper p-10 text-center">
          <Info className="w-7 h-7 mx-auto text-ink-mute opacity-50 mb-2" />
          <div className="text-sm text-ink-mute">
            {activeTab === "strict"
              ? "No columns are 100% clean — all columns have at least one finding."
              : "No columns are between 1% and 0% — they're either fully clean or have substantial findings."
            }
          </div>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-2">
          {list.map(c => (
            <div key={c.col} className="paper p-3 flex items-start gap-3" style={{
              borderLeft: `3px solid ${activeTab === "strict" ? '#16a34a' : '#ca8a04'}`
            }}>
              <div className="w-7 h-7 rounded flex items-center justify-center flex-shrink-0" style={{
                background: activeTab === "strict" ? '#dcfce7' : '#fef9c3'
              }}>
                <CheckCircle2 className="w-3.5 h-3.5" style={{ color: activeTab === "strict" ? '#16a34a' : '#ca8a04' }} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-mono text-xs font-semibold" style={{ color: activeTab === "strict" ? '#15803d' : '#854d0e' }}>
                  {c.col}
                </div>
                <div className="text-10 text-ink-mute mt-0.5">
                  {c.type === "numeric" ? "Numeric" : "Text"} · {rowsAnalysed.toLocaleString()} values
                </div>
                {activeTab === "strict" ? (
                  <div className="text-10 mt-1.5" style={{ color: '#16a34a' }}>
                    No anomalies detected by any algorithm
                  </div>
                ) : (
                  <div className="text-10 mt-1.5" style={{ color: '#ca8a04' }}>
                    {c.total} finding{c.total === 1 ? "" : "s"} · {(c.failureRate * 100).toFixed(2)}% failure rate
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

// Compact accordion for one column's findings — collapsed by default, paginates inside
function ColumnFindingsCompact({ col, items, tone }) {
  const [open, setOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const shown = items.slice(0, pageSize);
  const hasMore = items.length > pageSize;
  const samplePreview = items.slice(0, 3).map(f => f.value === null || f.value === "" ? "∅" : String(f.value).slice(0, 18)).join(", ");

  return (
    <div className="paper overflow-hidden">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-surface-2 transition-colors text-left"
      >
        <span
          className="font-mono text-xs px-2 py-0.5 rounded flex-shrink-0"
          style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', color: tone, fontWeight: 600 }}
        >
          {col}
        </span>
        <span className="font-mono text-10 text-ink-mute flex-shrink-0">{items.length} issue{items.length === 1 ? "" : "s"}</span>
        {!open && (
          <span className="text-11 text-ink-mute truncate flex-1 min-w-0">
            e.g. {samplePreview}
          </span>
        )}
        <ChevronDown className={`w-4 h-4 text-ink-mute transition-transform flex-shrink-0 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="border-t divider px-4 py-3">
          <div className="overflow-x-auto scrollbar-thin">
            <table className="w-full text-xs">
              <thead>
                <tr className="text-ink-mute border-b border-app">
                  <th className="text-left py-1.5 pr-3 font-mono font-normal">Row</th>
                  <th className="text-left py-1.5 pr-3 font-mono font-normal">Value</th>
                  <th className="text-left py-1.5 pr-3 font-mono font-normal">Score</th>
                  <th className="text-left py-1.5 font-mono font-normal">Why flagged</th>
                </tr>
              </thead>
              <tbody>
                {shown.map((f, i) => (
                  <tr key={i} className="border-b border-app">
                    <td className="py-1.5 pr-3 font-mono text-ink-soft">{f.row}</td>
                    <td className="py-1.5 pr-3 font-mono" style={{ color: tone }}>
                      {f.value === null || f.value === "" ? "∅" : String(f.value).slice(0, 50)}
                    </td>
                    <td className="py-1.5 pr-3 font-mono text-ink-soft">{f.score !== undefined ? f.score.toFixed(2) : "—"}</td>
                    <td className="py-1.5 text-ink-soft leading-snug">{f.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {hasMore && (
            <button onClick={() => setPageSize(s => s + 50)} className="btn-ghost mt-3">
              <Plus className="w-3 h-3" /> Show 50 more ({items.length - pageSize} remaining)
            </button>
          )}
          {!hasMore && items.length > 10 && (
            <div className="text-10 text-ink-mute mt-2 italic">Showing all {items.length} findings</div>
          )}
        </div>
      )}
    </div>
  );
}

// =============================================================================
// JOBS — scheduled validations / ML scans / connector syncs
// =============================================================================
function JobsTab({ jobs, runningId, onCreate, onEdit, onToggle, onDelete, onRunNow }) {
  const [filter, setFilter] = useState("All");
  const filters = ["All", "Daily", "Hourly", "Weekly", "Monthly", "Disabled"];
  const visible = useMemo(() => {
    if (filter === "All") return jobs;
    if (filter === "Disabled") return jobs.filter(j => j.status === "disabled");
    return jobs.filter(j => SCHEDULE_LABELS[j.schedule] === filter);
  }, [jobs, filter]);

  const counts = {
    total: jobs.length,
    enabled: jobs.filter(j => j.status === "enabled").length,
    running: jobs.filter(j => j.lastRun?.status === "running").length,
    failed: jobs.filter(j => j.lastRun?.status === "failed").length
  };

  return (
    <div>
      <div className="flex items-end justify-between mb-2">
        <div>
          <h2 className="font-display text-4xl mb-1">Scheduled Jobs</h2>
          <p className="text-sm text-ink-mute">Automate validations, ML scans, and connector syncs on a daily, hourly, weekly, or monthly cadence.</p>
        </div>
        <button onClick={onCreate} className="btn-primary">
          <Plus className="w-4 h-4" /> Schedule job
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 my-6">
        <div className="paper p-4">
          <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">Total jobs</div>
          <div className="font-display text-3xl">{counts.total}</div>
        </div>
        <div className="paper p-4">
          <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">Enabled</div>
          <div className="font-display text-3xl" style={{ color: "var(--accent)" }}>{counts.enabled}</div>
        </div>
        <div className="paper p-4">
          <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">Running now</div>
          <div className="font-display text-3xl text-sky-700">{counts.running}</div>
        </div>
        <div className="paper p-4">
          <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">Last run failed</div>
          <div className="font-display text-3xl text-red-700">{counts.failed}</div>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-5">
        {filters.map(f => (
          <button key={f} onClick={() => setFilter(f)}
            className={`chip ${filter === f ? "text-white border-accent" : "bg-surface text-ink-soft border-app hover:border-app-strong"}`}
            style={filter === f ? { backgroundColor: "var(--accent)", borderColor: "var(--accent)" } : undefined}>
            {f}
          </button>
        ))}
      </div>

      <div className="paper overflow-hidden">
        <div className="overflow-x-auto scrollbar-thin">
          <table className="w-full text-sm">
            <thead className="bg-surface-2 text-xxs uppercase tracking-wider text-ink-mute">
              <tr>
                <th className="text-left px-5 py-3 font-medium">Job</th>
                <th className="text-left px-4 py-3 font-medium">Type</th>
                <th className="text-left px-4 py-3 font-medium">Schedule</th>
                <th className="text-left px-4 py-3 font-medium">Source</th>
                <th className="text-left px-4 py-3 font-medium">Last run</th>
                <th className="text-left px-4 py-3 font-medium">Next run</th>
                <th className="text-center px-3 py-3 font-medium">Status</th>
                <th className="px-2 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {visible.map(j => (
                <JobRow key={j.id} job={j} running={runningId === j.id}
                  onEdit={() => onEdit(j)}
                  onToggle={() => onToggle(j.id)}
                  onDelete={() => onDelete(j.id)}
                  onRunNow={() => onRunNow(j.id)} />
              ))}
              {visible.length === 0 && (
                <tr><td colSpan={8} className="text-center py-8 text-ink-mute text-sm">No jobs match the current filter.</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="px-5 py-3 bg-surface-2 border-t border-app text-xs text-ink-mute">
          {jobs.length} job{jobs.length === 1 ? "" : "s"} · Toggle a job to pause/resume · Click any row to edit the schedule
        </div>
      </div>

      <div className="paper-2 p-4 mt-6 flex items-start gap-3">
        <Info className="w-4 h-4 text-accent mt-0.5 flex-shrink-0" />
        <div className="text-xs text-ink-soft leading-relaxed">
          Jobs are scheduled in this prototype for demonstration. In production, jobs are persisted, run via a queue on the DataQ Agent backend, and deliver results to email/Slack with failure alerting. The <span className="font-medium text-ink">Run now</span> button triggers an immediate execution regardless of schedule.
        </div>
      </div>
    </div>
  );
}

function JobRow({ job, running, onEdit, onToggle, onDelete, onRunNow }) {
  const type = JOB_TYPES[job.type];
  const Icon = type.icon;
  const enabled = job.status === "enabled";
  const lr = job.lastRun;
  const runStatus = running ? "running" : lr?.status;

  return (
    <tr className="border-t divider hover:bg-surface-2 transition-colors">
      <td className="px-5 py-3">
        <button onClick={onEdit} className="text-left">
          <div className="text-sm font-medium hover:text-accent">{job.name}</div>
          <div className="text-xs text-ink-mute mt-0.5">{job.description}</div>
        </button>
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0" style={{ backgroundColor: type.tone }}>
            <Icon className="w-3 h-3 text-white" strokeWidth={2.5} />
          </div>
          <span className="text-xs" style={{ color: type.tone }}>{type.label}</span>
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="text-xs font-medium">{SCHEDULE_LABELS[job.schedule]}</div>
        {job.time && <div className="text-10 font-mono text-ink-mute">{job.time} {job.timezone ? `· ${job.timezone.split("/").pop()}` : ""}</div>}
      </td>
      <td className="px-4 py-3">
        <div className="text-xs">{job.sourceLabel}</div>
        <div className="text-10 text-ink-mute">{job.scope}</div>
      </td>
      <td className="px-4 py-3">
        {running ? (
          <div className="flex items-center gap-1.5 text-xs text-sky-700">
            <Loader2 className="w-3.5 h-3.5 animate-spin" /> Running now...
          </div>
        ) : runStatus === "running" ? (
          <div className="flex items-center gap-1.5 text-xs text-sky-700">
            <Loader2 className="w-3.5 h-3.5 animate-spin" /> {lr.progress}% complete
          </div>
        ) : runStatus === "success" ? (
          <div>
            <div className="flex items-center gap-1.5 text-xs text-green-700">
              <CircleCheck className="w-3.5 h-3.5" /> {lr.timestamp}
            </div>
            <div className="text-10 font-mono text-ink-mute mt-0.5">
              {lr.duration}
              {lr.passed !== undefined && <> · {lr.passed}/{lr.total} passed</>}
              {lr.anomalies !== undefined && <> · {lr.anomalies} anomalies</>}
              {lr.rows !== undefined && <> · {lr.rows.toLocaleString()} rows</>}
            </div>
          </div>
        ) : runStatus === "failed" ? (
          <div>
            <div className="flex items-center gap-1.5 text-xs text-red-700">
              <XCircle className="w-3.5 h-3.5" /> {lr.timestamp}
            </div>
            <div className="text-10 text-red-700 mt-0.5 italic">{lr.error}</div>
          </div>
        ) : (
          <span className="text-xs text-ink-mute">Never run</span>
        )}
      </td>
      <td className="px-4 py-3 text-xs text-ink-soft">
        <div className="flex items-center gap-1.5">
          <Calendar className="w-3 h-3 text-ink-mute" />
          {job.nextRun}
        </div>
      </td>
      <td className="px-3 py-3 text-center">
        <button onClick={onToggle} disabled={running}
          className={`relative inline-flex w-9 h-5 rounded-full transition-colors ${running ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
          style={{ backgroundColor: enabled ? "var(--accent)" : "#cbd5e1" }}
          title={enabled ? "Click to pause" : "Click to enable"}>
          <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white transition-transform shadow-sm ${enabled ? "translate-x-4" : "translate-x-0.5"}`} />
        </button>
      </td>
      <td className="px-2 py-3">
        <div className="flex items-center gap-1">
          <button onClick={onRunNow} disabled={running || !enabled}
            className="text-ink-mute hover:text-accent-dark p-1 disabled:opacity-30 disabled:cursor-not-allowed"
            title="Run now">
            <PlayCircle className="w-4 h-4" />
          </button>
          <button onClick={onDelete} className="text-ink-mute hover:text-red-700 p-1" title="Delete">
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      </td>
    </tr>
  );
}

function JobModal({ draft, onClose, onSave, connectors }) {
  const [d, setD] = useState(draft);
  const isNew = !d.id;
  const field = (k, v) => setD(s => ({ ...s, [k]: v }));

  function handleSourceChange(v) {
    const def = CONNECTORS.find(c => c.id === v);
    setD(s => ({ ...s, source: v, sourceLabel: def ? def.name : v === "current" ? "Current dataset" : v }));
  }

  const sourceOptions = [
    { value: "current", label: "Current dataset (uploaded CSV)" },
    ...CONNECTORS.map(c => ({ value: c.id, label: `${c.name}${connectors[c.id] ? "" : " (not connected)"}` }))
  ];

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-surface border border-app rounded-2xl max-w-2xl w-full scroll-85vh overflow-y-auto scrollbar-thin">
        <div className="sticky top-0 bg-surface border-b border-app px-6 py-4 flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <Clock className="w-4 h-4 text-accent" />
              <span className="text-10 uppercase tracking-xwide text-ink-mute">{isNew ? "New scheduled job" : "Edit job"}</span>
            </div>
            <div className="font-display text-xl">{d.name || "Untitled job"}</div>
          </div>
          <button onClick={onClose} className="text-ink-mute hover:text-ink"><X className="w-5 h-5" /></button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Job name</label>
            <input value={d.name} onChange={e => field("name", e.target.value)}
              placeholder="e.g. Daily MM master validation"
              className="input-base w-full" />
          </div>
          <div>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Description</label>
            <input value={d.description} onChange={e => field("description", e.target.value)}
              placeholder="What this job does, in one sentence"
              className="input-base w-full" />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Job type</label>
              <div className="relative">
                <select value={d.type} onChange={e => field("type", e.target.value)} className="input-base w-full appearance-none pr-9 cursor-pointer">
                  {Object.entries(JOB_TYPES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
                <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
              </div>
              <div className="text-10 text-ink-mute mt-1">{JOB_TYPES[d.type]?.description}</div>
            </div>
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Data source</label>
              <div className="relative">
                <select value={d.source} onChange={e => handleSourceChange(e.target.value)} className="input-base w-full appearance-none pr-9 cursor-pointer">
                  {sourceOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
                <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
              </div>
            </div>
          </div>

          <div>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Scope</label>
            <input value={d.scope} onChange={e => field("scope", e.target.value)}
              placeholder="e.g. MM domain · 95 rules"
              className="input-base w-full font-mono text-xs" />
          </div>

          <div className="rounded-lg border border-app bg-accent-tint p-4">
            <div className="flex items-center gap-2 mb-3">
              <Clock className="w-4 h-4 text-accent" />
              <div className="font-medium text-sm">Schedule</div>
            </div>
            <div className="grid grid-cols-5 gap-2 mb-3">
              {Object.entries(SCHEDULE_LABELS).map(([k, label]) => (
                <button key={k} onClick={() => field("schedule", k)}
                  className={`py-2 px-2 rounded-md text-xs font-medium transition-colors border ${
                    d.schedule === k
                      ? "text-white border-accent"
                      : "bg-surface text-ink-soft border-app hover:border-app-strong"
                  }`}
                  style={d.schedule === k ? { backgroundColor: "var(--accent)" } : undefined}>
                  {label}
                </button>
              ))}
            </div>
            {d.schedule !== "manual" && (
              <div className="grid grid-cols-2 gap-3 mt-2">
                <div>
                  <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">
                    {d.schedule === "hourly" ? "Minute past the hour" : "Time of day"}
                  </label>
                  <input value={d.time} onChange={e => field("time", e.target.value)}
                    placeholder={d.schedule === "hourly" ? ":00" : "06:00"}
                    className="input-base w-full font-mono text-xs" />
                </div>
                <div>
                  <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Timezone</label>
                  <div className="relative">
                    <select value={d.timezone} onChange={e => field("timezone", e.target.value)} className="input-base w-full appearance-none pr-9 cursor-pointer">
                      <option value="UTC">UTC</option>
                      <option value="America/New_York">America/New_York (EST)</option>
                      <option value="America/Chicago">America/Chicago (CST)</option>
                      <option value="America/Los_Angeles">America/Los_Angeles (PST)</option>
                      <option value="Europe/London">Europe/London</option>
                      <option value="Europe/Paris">Europe/Paris</option>
                      <option value="Asia/Kolkata">Asia/Kolkata (IST)</option>
                      <option value="Asia/Tokyo">Asia/Tokyo</option>
                    </select>
                    <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="flex items-center gap-3 pt-2">
            <input type="checkbox" checked={d.status === "enabled"}
              onChange={e => field("status", e.target.checked ? "enabled" : "disabled")}
              className="accent-red-600" id="job-enabled" />
            <label htmlFor="job-enabled" className="text-sm text-ink">Enable this job immediately</label>
          </div>
        </div>

        <div className="sticky bottom-0 bg-surface border-t border-app px-6 py-4 flex items-center justify-end gap-2">
          <button onClick={onClose} className="btn-ghost">Cancel</button>
          <button onClick={() => onSave(d)} disabled={!d.name.trim() || !d.description.trim()} className="btn-primary">
            <Check className="w-4 h-4" /> {isNew ? "Schedule job" : "Save changes"}
          </button>
        </div>
      </div>
    </div>
  );
}

// =============================================================================
// DASHBOARD — domain-driven data quality overview
// =============================================================================
function DashboardTab({ jobs, results, mlResults, dynRulesCount }) {
  // Domain tabs mirror the 10 SAP master-data domains in the catalog, plus an "All" overview
  const domains = useMemo(() => {
    const set = new Set(RULES.map(r => r.d));
    return ["All", ...Array.from(set)];
  }, []);
  const [activeDomain, setActiveDomain] = useState("All");

  // Base metrics derived from last validation if available, otherwise seeded baseline
  const mock = { passed: 387, failed: 97, anomalies: 23 };
  const live = useMemo(() => ({
    passed: results?.summary?.passed ?? null,
    failed: results?.summary?.failed ?? null,
    anomalies: mlResults?.total ?? null
  }), [results, mlResults]);

  // Per-domain baseline pass rates — realistic SAP master data health
  const domainBaseline = useMemo(() => ({
    "MM":         { passRate: 88, rulesRun: 95, failed: 11, critical: 2, anomalies: 7 },
    "Customer":   { passRate: 92, rulesRun: 73, failed: 6,  critical: 1, anomalies: 4 },
    "Vendor":     { passRate: 85, rulesRun: 72, failed: 11, critical: 3, anomalies: 6 },
    "BOM":        { passRate: 81, rulesRun: 64, failed: 12, critical: 4, anomalies: 3 },
    "Work Center":{ passRate: 94, rulesRun: 35, failed: 2,  critical: 0, anomalies: 1 },
    "Routing":    { passRate: 89, rulesRun: 35, failed: 4,  critical: 1, anomalies: 1 },
    "GL Account": { passRate: 96, rulesRun: 30, failed: 1,  critical: 0, anomalies: 0 },
    "Cost Center":{ passRate: 93, rulesRun: 25, failed: 2,  critical: 0, anomalies: 0 },
    "Equipment":  { passRate: 87, rulesRun: 30, failed: 4,  critical: 1, anomalies: 1 },
    "Info Record":{ passRate: 90, rulesRun: 25, failed: 3,  critical: 1, anomalies: 0 }
  }), []);

  // Compute metrics for the currently-selected domain
  const domainMetrics = useMemo(() => {
    if (activeDomain === "All") {
      const passed = live.passed ?? mock.passed;
      const failed = live.failed ?? mock.failed;
      const anomalies = live.anomalies ?? mock.anomalies;
      const total = passed + failed;
      const passRate = total > 0 ? (passed / total) * 100 : 0;
      return {
        scope: `All ${RULES.length} rules across ${Object.keys(domainBaseline).length} domains`,
        passed, failed, anomalies, passRate,
        rulesRun: total,
        critical: Object.values(domainBaseline).reduce((a, b) => a + b.critical, 0),
        dqScore: Math.round(passRate - anomalies * 0.08)
      };
    }
    const b = domainBaseline[activeDomain];
    const passed = b.rulesRun - b.failed;
    return {
      scope: `${activeDomain} domain · ${b.rulesRun} rules`,
      passed, failed: b.failed, anomalies: b.anomalies,
      passRate: b.passRate, rulesRun: b.rulesRun, critical: b.critical,
      dqScore: Math.round(b.passRate - b.anomalies * 0.1)
    };
  }, [activeDomain, live, domainBaseline]);

  // 30-day trend — stable seeded pseudo-random, shifted by domain for variety
  const trendData = useMemo(() => {
    const out = [];
    let seed = 7 + (activeDomain === "All" ? 0 : activeDomain.charCodeAt(0));
    const rand = () => { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    const base = activeDomain === "All" ? 95 : domainBaseline[activeDomain].rulesRun;
    const baseFail = activeDomain === "All" ? 25 : domainBaseline[activeDomain].failed * 2;
    const baseAnom = activeDomain === "All" ? 10 : Math.max(1, domainBaseline[activeDomain].anomalies);
    const now = new Date();
    for (let i = 29; i >= 0; i--) {
      const d = new Date(now.getTime() - i * 86400000);
      const noise = (rand() - 0.5) * (baseFail * 0.4);
      const failures = Math.max(1, Math.round(baseFail + noise - (29 - i) * 0.3));
      const anomaly = Math.max(0, Math.round(baseAnom + (rand() - 0.5) * 4 - (29 - i) * 0.08));
      out.push({
        date: d.toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        passed: Math.max(0, base - failures),
        failed: failures,
        anomalies: anomaly
      });
    }
    return out;
  }, [activeDomain, domainBaseline]);

  // Rules in the selected domain
  const domainRules = useMemo(() => {
    if (activeDomain === "All") return RULES;
    return RULES.filter(r => r.d === activeDomain);
  }, [activeDomain]);

  // Dimension breakdown for this domain
  const dimData = useMemo(() => {
    const counts = {};
    domainRules.forEach(r => counts[r.x] = (counts[r.x] || 0) + 1);
    return Object.entries(counts).map(([name, value]) => ({ name, value }));
  }, [domainRules]);

  // Top failing rules in this domain (real if available, otherwise mock)
  const topFailing = useMemo(() => {
    const pool = activeDomain === "All" ? domainRules : domainRules;
    if (results?.staticResults) {
      return Object.entries(results.staticResults)
        .map(([n, res]) => ({ n, res, rule: pool.find(r => r.n == n) }))
        .filter(x => x.rule && x.res.status === "executed" && x.res.failed > 0)
        .sort((a, b) => b.res.failed - a.res.failed)
        .slice(0, 8)
        .map(x => ({
          name: `#${x.rule.n} · ${x.rule.d}`,
          label: x.rule.t.length > 44 ? x.rule.t.slice(0, 44) + "…" : x.rule.t,
          failed: x.res.failed,
          severity: x.rule.s
        }));
    }
    // Mock by domain — pick realistic failing rules from the actual catalog
    const critical = pool.filter(r => r.s === "Critical").slice(0, 3);
    const high = pool.filter(r => r.s === "High").slice(0, 5);
    return [...critical, ...high].slice(0, 8).map((r, i) => ({
      name: `#${r.n} · ${r.d}`,
      label: r.t.length > 44 ? r.t.slice(0, 44) + "…" : r.t,
      failed: Math.max(2, 18 - i * 2),
      severity: r.s
    }));
  }, [domainRules, results, activeDomain]);

  // Domain health comparison (always shown on "All", hidden on single domain)
  const domainHealthData = useMemo(() => {
    return Object.entries(domainBaseline).map(([name, d]) => ({
      name, pass: d.passRate, fail: 100 - d.passRate, rules: d.rulesRun
    }));
  }, [domainBaseline]);

  // Recent activity — pulled from jobs
  const recentJobs = useMemo(() => {
    return [...jobs]
      .filter(j => j.lastRun)
      .sort((a, b) => (a.lastRun.timestamp > b.lastRun.timestamp ? -1 : 1))
      .slice(0, 5);
  }, [jobs]);

  const DIM_PIE_COLORS = {
    "Completeness": "#0369a1", "Validity": "#7c3aed", "Accuracy": "#0f766e",
    "Consistency": "#0891b2", "Uniqueness": "#be185d", "Referential": "#15803d",
    "AI-Assisted": "#b45309"
  };

  // Domain tone for the hero strip
  const DOMAIN_COLORS = {
    "All": "#dc2814", "MM": "#0369a1", "Customer": "#0f766e", "Vendor": "#7c3aed",
    "BOM": "#c2410c", "Work Center": "#0891b2", "Routing": "#be185d",
    "GL Account": "#15803d", "Cost Center": "#b45309", "Equipment": "#0e7490",
    "Info Record": "#9333ea"
  };
  const domainColor = DOMAIN_COLORS[activeDomain] || "#dc2814";

  // ----- Excel/CSV export of all rules with last-run status if available -----
  function exportToExcel() {
    // Two-tier approach: try a real .xlsx via the SheetJS bundle if available in the
    // artifact runtime, otherwise fall back to a multi-section CSV that opens in Excel.
    // In production (dataq-agent.zip) the backend generates a proper multi-sheet workbook.
    const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const lines = [];

    lines.push("=== SUMMARY ===");
    lines.push(["Domain","Rules","Pass Rate %","Failed","Critical","ML Anomalies"].map(escape).join(","));
    Object.entries(domainBaseline).forEach(([d, b]) => {
      lines.push([d, b.rulesRun, b.passRate, b.failed, b.critical, b.anomalies].map(escape).join(","));
    });
    lines.push("");

    Object.keys(domainBaseline).forEach(d => {
      lines.push(`=== ${d.toUpperCase()} RULES ===`);
      lines.push(["Rule #","Domain","Severity","Dimension","Description","SAP Tables","Method"].map(escape).join(","));
      RULES.filter(r => r.d === d).forEach(r => {
        lines.push([r.n, r.d, r.s, r.x, r.t, r.b, r.m].map(escape).join(","));
      });
      lines.push("");
    });

    const csv = lines.join("\n");
    // Add a UTF-8 BOM so Excel renders unicode correctly when the file is opened directly.
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const filename = `dataq-dashboard-${new Date().toISOString().slice(0,10)}.csv`;

    // CRITICAL: anchor MUST be in the DOM for sandboxed iframe downloads to fire.
    // Just calling a.click() on a detached node silently fails in many sandbox environments.
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    // Defer removal slightly so the browser has time to start the download.
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  }

  return (
    <div>
      {/* Header with export button */}
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <h2 className="font-display text-4xl mb-1">Data Quality Dashboard</h2>
          <p className="text-sm text-ink-mute">{domainMetrics.scope}</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={exportToExcel} className="btn-secondary">
            <FileText className="w-4 h-4" /> Export to Excel
          </button>
          <div className="text-right">
            <div className="text-10 uppercase tracking-xwide text-ink-mute">Refreshed</div>
            <div className="text-xs font-mono text-ink">{new Date().toLocaleString()}</div>
          </div>
        </div>
      </div>

      {/* ============================================================
          DOMAIN TILE GRID — click any tile to drill into that domain
          ============================================================ */}
      {activeDomain === "All" ? (
        <>
          {/* All-domains overview KPIs */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
            <div className="paper p-5" style={{ borderLeft: '4px solid var(--accent)' }}>
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-1.5">DQ Score</div>
              <div className="font-display text-4xl leading-none text-accent">{domainMetrics.dqScore}</div>
              <div className="text-10 text-ink-mute mt-2">across {Object.keys(domainBaseline).length} domains</div>
            </div>
            <div className="paper p-5">
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-1.5">Total rules</div>
              <div className="font-display text-4xl leading-none text-ink">{domainMetrics.rulesRun}</div>
              <div className="text-10 text-ink-mute mt-2">{domainMetrics.passed} passed last run</div>
            </div>
            <div className="paper p-5" style={{ borderLeft: '4px solid #16a34a' }}>
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-1.5">Pass rate</div>
              <div className="font-display text-4xl leading-none" style={{ color: '#16a34a' }}>{domainMetrics.passRate.toFixed(0)}%</div>
              <div className="text-10 text-ink-mute mt-2">organization-wide</div>
            </div>
            <div className="paper p-5" style={{ borderLeft: '4px solid #dc2814' }}>
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-1.5">Critical issues</div>
              <div className="font-display text-4xl leading-none" style={{ color: '#dc2814' }}>{domainMetrics.critical}</div>
              <div className="text-10 text-ink-mute mt-2">need immediate review</div>
            </div>
          </div>

          {/* Domain grid — click to drill in */}
          <div className="mb-3">
            <div className="text-xs font-semibold uppercase tracking-wider text-ink-soft">Domains · click to drill in</div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            {Object.entries(domainBaseline).map(([name, d]) => {
              const color = DOMAIN_COLORS[name] || "#71717a";
              const passColor = d.passRate >= 90 ? '#16a34a' : d.passRate >= 80 ? '#ca8a04' : '#dc2814';
              return (
                <button
                  key={name}
                  onClick={() => setActiveDomain(name)}
                  className="paper p-4 text-left hover:shadow-sm transition-all"
                  style={{ borderTopColor: color, borderTopWidth: '3px', cursor: 'pointer' }}
                >
                  <div className="text-xs font-semibold mb-2" style={{ color }}>{name}</div>
                  <div className="font-display text-3xl leading-none mb-1" style={{ color: passColor }}>
                    {d.passRate}%
                  </div>
                  <div className="text-10 text-ink-mute mb-3">pass rate</div>
                  <div className="flex items-center justify-between text-10">
                    <span className="text-ink-soft">{d.rulesRun} rules</span>
                    {d.critical > 0 && (
                      <span className="font-medium" style={{ color: '#dc2814' }}>{d.critical} critical</span>
                    )}
                  </div>
                  <div className="flex items-center gap-1 mt-3 text-10 text-accent-dark font-medium">
                    Drill in <ArrowRight className="w-3 h-3" />
                  </div>
                </button>
              );
            })}
          </div>

          {/* Cross-domain comparison chart */}
          <div className="paper p-5 mt-5">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="font-medium">Domain health comparison</div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mt-0.5">Pass rate by domain</div>
              </div>
            </div>
            <ResponsiveContainer width="100%" height={240}>
              <BarChart data={domainHealthData} margin={{ top: 5, right: 16, left: -10, bottom: 0 }}>
                <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" tick={{ fontSize: 10, fill: 'var(--ink-soft)' }} />
                <YAxis tick={{ fontSize: 10, fill: 'var(--ink-soft)' }} domain={[0, 100]} />
                <Tooltip wrapperStyle={{ fontSize: '0.75rem' }} />
                <Bar dataKey="pass" fill="#16a34a" radius={[4, 4, 0, 0]} name="Pass %" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      ) : (
        /* ============================================================
           DRILL-IN VIEW for the selected domain
           ============================================================ */
        <>
          {/* Back button + domain hero */}
          <div className="flex items-center gap-3 mb-4">
            <button onClick={() => setActiveDomain("All")} className="btn-ghost">
              <ArrowLeft className="w-3 h-3" /> Back to all domains
            </button>
            <div className="text-xs text-ink-mute">·</div>
            <div className="text-xs text-ink-soft">Viewing <span className="font-semibold text-ink">{activeDomain}</span></div>
          </div>

          {/* Domain KPI strip */}
          <div className="paper p-5 mb-5" style={{
            background: `linear-gradient(135deg, ${domainColor}10 0%, var(--surface) 60%)`,
            borderLeft: `4px solid ${domainColor}`
          }}>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              <div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Domain</div>
                <div className="font-display text-2xl" style={{ color: domainColor }}>{activeDomain}</div>
                <div className="text-10 text-ink-mute mt-1">SAP master data</div>
              </div>
              <div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Rules</div>
                <div className="font-display text-2xl text-ink">{domainMetrics.rulesRun}</div>
                <div className="text-10 text-ink-mute mt-1">in catalog</div>
              </div>
              <div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Pass rate</div>
                <div className="font-display text-2xl" style={{ color: '#16a34a' }}>{domainMetrics.passRate.toFixed(0)}%</div>
                <div className="text-10 text-ink-mute mt-1">{domainMetrics.passed} passed</div>
              </div>
              <div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">Failed</div>
                <div className="font-display text-2xl" style={{ color: '#dc2814' }}>{domainMetrics.failed}</div>
                <div className="text-10 text-ink-mute mt-1">{domainMetrics.critical} critical</div>
              </div>
              <div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mb-1">ML anomalies</div>
                <div className="font-display text-2xl" style={{ color: '#ca8a04' }}>{domainMetrics.anomalies}</div>
                <div className="text-10 text-ink-mute mt-1">unsupervised</div>
              </div>
            </div>
          </div>

          {/* Charts row */}
          <div className="grid lg:grid-cols-3 gap-4 mb-5">
            <div className="paper p-5 lg:col-span-2">
              <div className="font-medium mb-1">30-day validation trend</div>
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-4">{activeDomain} domain</div>
              <ResponsiveContainer width="100%" height={220}>
                <AreaChart data={trendData} margin={{ top: 5, right: 0, left: -20, bottom: 0 }}>
                  <defs>
                    <linearGradient id="gPassed" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#16a34a" stopOpacity={0.35}/>
                      <stop offset="95%" stopColor="#16a34a" stopOpacity={0}/>
                    </linearGradient>
                    <linearGradient id="gFailed" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor={domainColor} stopOpacity={0.35}/>
                      <stop offset="95%" stopColor={domainColor} stopOpacity={0}/>
                    </linearGradient>
                  </defs>
                  <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="date" tick={{ fontSize: 10, fill: 'var(--ink-soft)' }} interval={4} />
                  <YAxis tick={{ fontSize: 10, fill: 'var(--ink-soft)' }} />
                  <Tooltip wrapperStyle={{ fontSize: '0.75rem' }} />
                  <Area type="monotone" dataKey="passed" stroke="#16a34a" fill="url(#gPassed)" />
                  <Area type="monotone" dataKey="failed" stroke={domainColor} fill="url(#gFailed)" />
                </AreaChart>
              </ResponsiveContainer>
            </div>

            <div className="paper p-5">
              <div className="font-medium mb-1">By dimension</div>
              <div className="text-10 uppercase tracking-wider text-ink-mute mb-4">Rule distribution</div>
              <ResponsiveContainer width="100%" height={220}>
                <PieChart>
                  <Pie data={dimData} dataKey="value" nameKey="name" innerRadius={45} outerRadius={75} paddingAngle={2}>
                    {dimData.map((entry, i) => (
                      <Cell key={`c-${i}`} fill={DIM_PIE_COLORS[entry.name] || "#71717a"} />
                    ))}
                  </Pie>
                  <Tooltip wrapperStyle={{ fontSize: '0.75rem' }} />
                </PieChart>
              </ResponsiveContainer>
              <div className="grid grid-cols-2 gap-1 mt-3">
                {dimData.map(d => (
                  <LegendDot key={d.name} color={DIM_PIE_COLORS[d.name] || "#71717a"} label={`${d.name}: ${d.value}`} />
                ))}
              </div>
            </div>
          </div>

          {/* Top failing rules in this domain */}
          <div className="paper p-5">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="font-medium">Top failing rules</div>
                <div className="text-10 uppercase tracking-wider text-ink-mute mt-0.5">{activeDomain} · last validation run</div>
              </div>
            </div>
            {topFailing.length === 0 ? (
              <div className="text-center py-8 text-sm text-ink-mute">No failing rules.</div>
            ) : (
              <div className="space-y-2">
                {topFailing.map((f, i) => (
                  <div key={i} className="flex items-center gap-3 px-3 py-2.5 rounded-lg" style={{ background: 'var(--surface-2)' }}>
                    <span className="font-mono text-10 text-ink-mute flex-shrink-0" style={{ minWidth: '44px' }}>{f.name}</span>
                    <div className="flex-1 min-w-0">
                      <div className="text-xs truncate">{f.label}</div>
                    </div>
                    <span className={`chip ${SEV_STYLES[f.severity]}`}>{f.severity}</span>
                    <div className="font-mono text-sm font-semibold" style={{ color: domainColor, minWidth: '40px', textAlign: 'right' }}>
                      {f.failed}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

function KPICard({ label, value, sub, trend, trendUp }) {
  return (
    <div className="paper p-5">
      <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">{label}</div>
      <div className="font-display text-4xl leading-none text-ink">{value}</div>
      <div className="flex items-center gap-2 mt-2 text-10">
        {trend && (
          <span className={`flex items-center gap-0.5 font-medium ${trendUp ? "text-green-700" : "text-red-700"}`}>
            {trendUp ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
            {trend}
          </span>
        )}
        <span className="text-ink-mute">{sub}</span>
      </div>
    </div>
  );
}

function LegendDot({ color, label }) {
  return (
    <div className="flex items-center gap-1.5 text-ink-soft">
      <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: color }} />
      <span>{label}</span>
    </div>
  );
}

// =============================================================================
// ADMIN LANDING — tile grid linking to Connectors, Security, Jobs, Repository
// =============================================================================
function AdminTab({ connectors, users, jobs, repoConfig, myPermissions, onGo }) {
  const connectedCount = Object.values(connectors).filter(c => c.configured).length;
  const adminCount = users.filter(u => u.role === "Admin").length;
  const enabledJobs = jobs.filter(j => j.status === "enabled").length;
  const repoType = REPO_TYPES.find(t => t.id === repoConfig.type);

  const tiles = [
    {
      id: "connectors", icon: Plug, tone: "#0369a1",
      title: "Connectors",
      body: "Connect DataQ Agent to your SAP, Oracle, JDE, Kinaxis, and data-lake source systems.",
      stat: `${connectedCount} of ${CONNECTORS.length} configured`,
      available: true
    },
    {
      id: "security", icon: ShieldCheck, tone: "#7c3aed",
      title: "Security",
      body: "Manage users, roles, and feature-level permissions across the workspace.",
      stat: `${users.length} users · ${adminCount} admin${adminCount === 1 ? "" : "s"}`,
      available: true
    },
    {
      id: "jobs", icon: Clock, tone: "#0f766e",
      title: "Jobs",
      body: "Schedule recurring validations, ML scans, and connector syncs on a cadence.",
      stat: jobs.length ? `${enabledJobs} of ${jobs.length} enabled` : "No jobs scheduled",
      available: myPermissions.jobs
    },
    {
      id: "repository", icon: Database, tone: "#dc2814",
      title: "Repository",
      body: "Configure the database where DataQ Agent persists validation runs, ML results, job logs, and the audit trail.",
      stat: repoConfig.configured
        ? `${repoType?.name || repoConfig.type} · ${repoConfig.stats.validationRuns.toLocaleString()} runs stored`
        : "Not configured",
      available: true,
      featured: true
    }
  ];

  return (
    <div>
      <div className="mb-8">
        <h2 className="font-display text-4xl mb-1">Admin</h2>
        <p className="text-sm text-ink-mute">Configure connectivity, access control, scheduled jobs, and the results repository.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {tiles.map(t => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => t.available && onGo(t.id)}
              disabled={!t.available}
              className={`paper p-6 text-left transition-all ${
                t.available ? "hover:shadow-lg hover:border-app-strong cursor-pointer" : "opacity-60 cursor-not-allowed"
              } ${t.featured ? "relative" : ""}`}
              style={t.featured ? { borderColor: "var(--accent)", borderWidth: "2px" } : undefined}
            >
              {t.featured && (
                <div className="absolute -top-2 right-5 text-10 uppercase tracking-xwide font-bold text-white px-2 py-0.5 rounded" style={{ backgroundColor: "var(--accent)" }}>
                  Core
                </div>
              )}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: t.tone }}>
                  <Icon className="w-6 h-6 text-white" strokeWidth={2} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <div className="font-display text-xl">{t.title}</div>
                    {t.available ? (
                      <ArrowRight className="w-4 h-4 text-ink-mute" />
                    ) : (
                      <Lock className="w-3.5 h-3.5 text-ink-mute" />
                    )}
                  </div>
                  <div className="text-sm text-ink-soft leading-relaxed mb-3">{t.body}</div>
                  <div className="text-xs font-mono" style={{ color: t.tone }}>{t.stat}</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="paper-2 p-4 mt-6 flex items-start gap-3">
        <Info className="w-4 h-4 text-accent mt-0.5 flex-shrink-0" />
        <div className="text-xs text-ink-soft leading-relaxed">
          Admin tiles above are scoped to platform configuration. Day-to-day data quality work lives under <span className="font-medium text-ink">Catalog</span>, <span className="font-medium text-ink">ML Insights</span>, and the <span className="font-medium text-ink">AI Agent</span> workflows.
        </div>
      </div>
    </div>
  );
}

// =============================================================================
// REPOSITORY — configure the database where DataQ Agent persists results
// =============================================================================
function RepositoryTab({ config, onSave }) {
  const [draft, setDraft] = useState(config);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [saved, setSaved] = useState(false);

  // Reset test result whenever the user edits anything
  function patch(k, v) {
    setDraft(prev => ({ ...prev, [k]: v }));
    setTestResult(null); setSaved(false);
  }
  function patchPersist(k, v) {
    setDraft(prev => ({ ...prev, persist: { ...prev.persist, [k]: v } }));
    setSaved(false);
  }

  const selectedType = REPO_TYPES.find(t => t.id === draft.type);

  async function testConnection() {
    setTesting(true); setTestResult(null);
    await new Promise(r => setTimeout(r, 1100));
    const hasRequired = draft.host && draft.database && draft.user;
    setTestResult(hasRequired
      ? { ok: true, message: `Connected to ${selectedType?.name} · schema '${draft.schema || "public"}' · ${selectedType?.category.toLowerCase()} engine reached` }
      : { ok: false, message: "Host, database, and user are required." });
    setTesting(false);
  }

  function saveConfig() {
    const updated = { ...draft, configured: true };
    onSave(updated);
    setSaved(true);
    setTimeout(() => setSaved(false), 2200);
  }

  const persistItems = [
    { key: "validationRuns",  label: "Validation runs",       description: "Every rule-engine execution with per-rule results and failed-record samples." },
    { key: "mlResults",       label: "ML scan results",       description: "Anomaly findings from the five unsupervised detectors." },
    { key: "jobLogs",         label: "Job execution logs",    description: "Scheduled-job history, durations, pass/fail counts, triggering user." },
    { key: "userActivity",    label: "User activity audit",   description: "Who signed in, what they accessed, and which rules they authored." },
    { key: "dynamicRules",    label: "Dynamic rule library",  description: "Rules built via the profiler or NL builder, persisted across sessions." },
    { key: "recordSnapshots", label: "Full record snapshots", description: "Optional — persist the original row data alongside failures. Storage-heavy." }
  ];

  return (
    <div>
      <div className="flex items-end justify-between mb-2">
        <div>
          <h2 className="font-display text-4xl mb-1">Data Quality Repository</h2>
          <p className="text-sm text-ink-mute">The database where DataQ Agent persists validation runs, ML results, job logs, and the audit trail.</p>
        </div>
      </div>

      {/* Connection status banner */}
      <div className="paper p-4 mt-6 mb-5 flex items-center gap-4" style={{ borderLeftWidth: "4px", borderLeftColor: config.configured ? "var(--accent)" : "var(--border-strong)" }}>
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`} style={{ backgroundColor: selectedType?.tone || "#71717a" }}>
          <Database className="w-5 h-5 text-white" strokeWidth={2} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <div className="font-medium">{config.configured ? selectedType?.name : "Not configured"}</div>
            {config.configured && (
              <span className="chip bg-accent-soft text-accent-dark" style={{ borderColor: "transparent" }}>
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "var(--accent)" }} /> Connected
              </span>
            )}
          </div>
          <div className="text-xs font-mono text-ink-mute">
            {config.configured
              ? `${config.user}@${config.host}:${config.port}/${config.database}`
              : "Provide connection details below and test the connection to persist results."}
          </div>
        </div>
        {config.configured && (
          <div className="text-right flex-shrink-0">
            <div className="text-10 uppercase tracking-xwide text-ink-mute">Connected since</div>
            <div className="text-xs font-mono text-ink">{config.stats.connectedSince}</div>
          </div>
        )}
      </div>

      {/* Storage stats strip */}
      {config.configured && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
          <RepoStat label="Validation runs"  value={config.stats.validationRuns.toLocaleString()} />
          <RepoStat label="ML results"       value={config.stats.mlResults.toLocaleString()} />
          <RepoStat label="Job logs"         value={config.stats.jobLogs.toLocaleString()} />
          <RepoStat label="Audit events"     value={config.stats.auditEvents.toLocaleString()} />
          <RepoStat label="Size on disk"     value={config.stats.sizeOnDisk} />
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4 mb-5">
        {/* LEFT — Engine + connection */}
        <div className="paper p-5">
          <div className="flex items-center gap-2 mb-4">
            <Server className="w-4 h-4 text-accent" />
            <div className="font-medium">Database engine</div>
          </div>

          <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Type</label>
          <div className="grid grid-cols-2 gap-2 mb-4">
            {REPO_TYPES.map(t => {
              const active = draft.type === t.id;
              return (
                <button key={t.id}
                  onClick={() => { patch("type", t.id); patch("port", t.defaultPort); }}
                  className="rounded-lg border p-2.5 text-left transition-colors"
                  style={{
                    borderColor: active ? t.tone : "var(--border)",
                    backgroundColor: active ? "#ffffff" : "var(--surface-2)",
                    boxShadow: active ? `0 0 0 1px ${t.tone}` : "none"
                  }}>
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 rounded flex-shrink-0" style={{ backgroundColor: t.tone }} />
                    <div className="text-xs font-medium flex-1 truncate" style={{ color: active ? t.tone : "var(--ink)" }}>
                      {t.name}
                    </div>
                    {t.recommended && (
                      <span className="text-10 uppercase tracking-xwide font-bold" style={{ color: "var(--accent)" }}>★</span>
                    )}
                  </div>
                  <div className="text-10 text-ink-mute mt-0.5">{t.category}</div>
                </button>
              );
            })}
          </div>
          {selectedType && (
            <div className="text-10 text-ink-mute italic mb-4 pl-1">{selectedType.description}</div>
          )}

          <div className="flex items-center gap-2 mb-3 pt-3 border-t border-app">
            <Server className="w-4 h-4 text-accent" />
            <div className="font-medium text-sm">Connection</div>
          </div>

          <div className="grid grid-cols-3 gap-2 mb-2">
            <div className="col-span-2">
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Host</label>
              <input value={draft.host} onChange={e => patch("host", e.target.value)} placeholder="dataq-repo.corp.local"
                     className="input-base w-full font-mono text-xs" />
            </div>
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Port</label>
              <input value={draft.port} onChange={e => patch("port", e.target.value)} placeholder="5432"
                     className="input-base w-full font-mono text-xs" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 mb-2">
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Database</label>
              <input value={draft.database} onChange={e => patch("database", e.target.value)} placeholder="dataq_repo"
                     className="input-base w-full font-mono text-xs" />
            </div>
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Schema</label>
              <input value={draft.schema} onChange={e => patch("schema", e.target.value)} placeholder="dqa"
                     className="input-base w-full font-mono text-xs" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 mb-3">
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">User</label>
              <input value={draft.user} onChange={e => patch("user", e.target.value)} placeholder="dataq_svc"
                     className="input-base w-full font-mono text-xs" />
            </div>
            <div>
              <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1">Authentication</label>
              <div className="relative">
                <select value={draft.auth} onChange={e => patch("auth", e.target.value)} className="input-base w-full appearance-none pr-9 cursor-pointer">
                  <option>Username / password</option>
                  <option>Managed identity (Azure)</option>
                  <option>IAM role (AWS)</option>
                  <option>Kerberos / AD</option>
                  <option>Service principal</option>
                  <option>Certificate</option>
                </select>
                <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-4 mt-3 pt-3 border-t border-app">
            <label className="flex items-center gap-2 text-xs cursor-pointer">
              <input type="checkbox" checked={draft.ssl} onChange={e => patch("ssl", e.target.checked)} className="accent-red-600" />
              <span>Require SSL / TLS</span>
            </label>
            <label className="flex items-center gap-2 text-xs cursor-pointer">
              <input type="checkbox" checked={draft.encryption} onChange={e => patch("encryption", e.target.checked)} className="accent-red-600" />
              <span>Encrypt at rest</span>
            </label>
          </div>

          <button onClick={testConnection} disabled={testing} className="btn-secondary w-full justify-center mt-4">
            {testing ? <><Loader2 className="w-4 h-4 animate-spin" /> Testing...</> : <><Plug className="w-4 h-4" /> Test connection</>}
          </button>

          {testResult && (
            <div className={`flex items-start gap-2 rounded-lg px-3 py-2.5 text-xs mt-3 ${
              testResult.ok ? "bg-accent-tint border border-app text-accent-dark" : "bg-red-50 border border-red-200 text-red-800"
            }`}>
              {testResult.ok ? <CheckCircle2 className="w-4 h-4 mt-0.5 flex-shrink-0" /> : <CircleAlert className="w-4 h-4 mt-0.5 flex-shrink-0" />}
              <div>{testResult.message}</div>
            </div>
          )}
        </div>

        {/* RIGHT — What to persist + retention */}
        <div className="space-y-4">
          <div className="paper p-5">
            <div className="flex items-center gap-2 mb-3">
              <Save className="w-4 h-4 text-accent" />
              <div className="font-medium">What to persist</div>
            </div>
            <div className="space-y-2">
              {persistItems.map(it => (
                <label key={it.key} className="flex items-start gap-3 p-2.5 rounded-lg border border-app hover:bg-surface-2 cursor-pointer transition-colors">
                  <input type="checkbox"
                    checked={!!draft.persist[it.key]}
                    onChange={e => patchPersist(it.key, e.target.checked)}
                    className="mt-0.5 accent-red-600" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium">{it.label}</div>
                    <div className="text-10 text-ink-mute leading-snug mt-0.5">{it.description}</div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          <div className="paper p-5">
            <div className="flex items-center gap-2 mb-3">
              <History className="w-4 h-4 text-accent" />
              <div className="font-medium">Retention policy</div>
            </div>
            <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Keep data for</label>
            <div className="relative">
              <select value={draft.retention} onChange={e => patch("retention", e.target.value)} className="input-base w-full appearance-none pr-9 cursor-pointer">
                <option value="30">30 days</option>
                <option value="90">90 days</option>
                <option value="180">180 days (6 months)</option>
                <option value="365">365 days (1 year)</option>
                <option value="730">730 days (2 years)</option>
                <option value="forever">Indefinite</option>
              </select>
              <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
            </div>
            <div className="text-10 text-ink-mute italic mt-2">
              Data older than the retention window is automatically purged nightly via a background job.
            </div>
          </div>
        </div>
      </div>

      {/* Save bar */}
      <div className="paper p-4 flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs text-ink-soft">
          <Info className="w-3.5 h-3.5 text-ink-mute" />
          <span>Changes persist for this session. In production, repository config is managed through infrastructure-as-code.</span>
        </div>
        <div className="flex items-center gap-2">
          {saved && (
            <span className="flex items-center gap-1.5 text-xs text-accent-dark font-medium">
              <CheckCircle2 className="w-4 h-4" /> Saved
            </span>
          )}
          <button onClick={saveConfig} disabled={!testResult?.ok} className="btn-primary">
            <Save className="w-4 h-4" /> Save configuration
          </button>
        </div>
      </div>
    </div>
  );
}

function RepoStat({ label, value }) {
  return (
    <div className="paper p-4">
      <div className="text-10 uppercase tracking-xwide text-ink-mute mb-1.5">{label}</div>
      <div className="font-display text-2xl text-ink">{value}</div>
    </div>
  );
}

// =============================================================================
// LOGIN PAGE (Azure AD / Microsoft SSO — simulated for prototype)
// =============================================================================
function LoginPage({ onAuth }) {
  const [stage, setStage] = useState("idle"); // idle | redirecting | verifying | picker
  const [pickerOpen, setPickerOpen] = useState(false);

  const mockAccounts = [
    { name: "Demo User", email: "demo.user@idwteam.com", tenant: "idwteam.onmicrosoft.com", initial: "DU" },
    { name: "Data Admin", email: "data.admin@idwteam.com", tenant: "idwteam.onmicrosoft.com", initial: "DA" }
  ];

  async function beginSignIn() {
    setStage("redirecting");
    await new Promise(r => setTimeout(r, 650));
    setStage("verifying");
    await new Promise(r => setTimeout(r, 500));
    setPickerOpen(true);
    setStage("picker");
  }

  function pickAccount(acc) {
    onAuth(acc);
  }

  return (
    <div className="min-h-screen flex items-stretch bg-app font-body">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=Geist:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

        :root {
          /* IDWTEAM brand palette — sampled from logo */
          --bg: #ffffff;
          --surface: #ffffff;
          --surface-2: #fafaf9;
          --ink: #0b0b0b;
          --ink-soft: #3f3f46;
          --ink-mute: #71717a;
          --border: #e4e4e7;
          --border-strong: #d4d4d8;
          --accent: #dc2814;
          --accent-dark: #b01e0a;
          --accent-soft: #fde8e3;
          --accent-tint: #fff6f3;
        }
        .font-body { font-family: 'Geist', ui-sans-serif, system-ui, sans-serif; }
        .font-display { font-family: 'Fraunces', Georgia, serif; font-optical-sizing: auto; letter-spacing: -0.02em; }
        .font-mono { font-family: 'JetBrains Mono', ui-monospace, monospace; }

        .bg-app { background-color: var(--bg); }
        .bg-surface { background-color: var(--surface); }
        .bg-surface-2 { background-color: var(--surface-2); }
        .bg-accent { background-color: var(--accent); }
        .bg-accent-dark { background-color: var(--accent-dark); }
        .bg-accent-soft { background-color: var(--accent-soft); }
        .bg-accent-tint { background-color: var(--accent-tint); }
        .text-ink { color: var(--ink); }
        .text-ink-soft { color: var(--ink-soft); }
        .text-ink-mute { color: var(--ink-mute); }
        .text-accent { color: var(--accent); }
        .text-accent-dark { color: var(--accent-dark); }
        .border-app { border-color: var(--border); }
        .border-app-strong { border-color: var(--border-strong); }

        .login-left {
          background: #ffffff;
          position: relative; overflow: hidden;
          border-right: 1px solid var(--border);
        }
        .login-left::before {
          content: ""; position: absolute; inset: 0;
          background-image:
            radial-gradient(circle at 15% 85%, rgba(220, 40, 20, 0.08), transparent 45%),
            radial-gradient(circle at 90% 10%, rgba(11, 11, 11, 0.04), transparent 50%);
          pointer-events: none;
        }
        .login-left::after {
          content: ""; position: absolute; inset: 0; opacity: 0.35;
          background-image:
            linear-gradient(rgba(11,11,11,0.04) 1px, transparent 1px),
            linear-gradient(90deg, rgba(11,11,11,0.04) 1px, transparent 1px);
          background-size: 56px 56px;
          mask-image: radial-gradient(ellipse at 30% 70%, black 10%, transparent 70%);
          -webkit-mask-image: radial-gradient(ellipse at 30% 70%, black 10%, transparent 70%);
          pointer-events: none;
        }
        .login-accent-bar {
          width: 80px; height: 4px; background: var(--accent); border-radius: 2px;
        }

        .ms-btn {
          background: #2563eb; color: white; border: none; padding: 12px 18px;
          border-radius: 8px; font-weight: 500; font-size: 14px;
          display: inline-flex; align-items: center; gap: 10px; width: 100%;
          justify-content: center; cursor: pointer; transition: background 0.15s;
        }
        .ms-btn:hover:not(:disabled) { background: #1d4ed8; }
        .ms-btn:disabled { background: #93c5fd; cursor: wait; }

        .ms-tile {
          display: grid; grid-template-columns: repeat(2, 1fr); gap: 2px;
          width: 18px; height: 18px;
        }
        .ms-tile span { display: block; }
        .ms-tile span:nth-child(1) { background: #f25022; }
        .ms-tile span:nth-child(2) { background: #7fba00; }
        .ms-tile span:nth-child(3) { background: #00a4ef; }
        .ms-tile span:nth-child(4) { background: #ffb900; }
      `}</style>

      {/* Left brand panel — light, logo-forward */}
      <div className="login-left hidden md:flex flex-col justify-between p-12 w-2/5 relative z-10">
        <div className="relative z-10">
          <img src={IDWTEAM_LOGO} alt="IDWTEAM" className="h-12 w-auto" />
        </div>
        <div className="relative z-10">
          <div className="login-accent-bar mb-6" />
          <div className="font-display text-5xl leading-tight mb-4 text-ink">
            Master data quality,<br/><em className="not-italic text-accent">at your velocity.</em>
          </div>
          <p className="text-ink-soft text-base leading-relaxed max-w-md">
            484 production-grade SAP rules, dynamic profiling, natural-language rule authoring, and direct connectors into ECC, S/4HANA, Kinaxis, JDE, Oracle Fusion, EBS and your data lake.
          </p>
        </div>
        <div className="relative z-10 flex items-center gap-5 text-xs text-ink-mute">
          <span className="font-mono">© IDWTEAM LLC</span>
          <span>·</span>
          <span>Enterprise DQ Platform</span>
          <span>·</span>
          <span>SOC 2 · ISO 27001 ready</span>
        </div>
      </div>

      {/* Right auth card */}
      <div className="flex-1 flex items-center justify-center p-6 bg-surface-2">
        <div className="w-full" style={{ maxWidth: "420px" }}>
          <div className="md:hidden flex items-center gap-3 mb-8">
            <img src={IDWTEAM_LOGO} alt="IDWTEAM" className="h-8 w-auto" />
          </div>

          <h1 className="font-display text-3xl mb-1.5 text-ink">Sign in</h1>
          <p className="text-sm text-ink-soft mb-8">Use your work account to access DataQ Agent. Provisioned through your organization&rsquo;s identity provider.</p>

          {!pickerOpen ? (
            <>
              <button className="ms-btn" onClick={beginSignIn} disabled={stage !== "idle"}>
                {stage === "idle" && (
                  <>
                    <span className="ms-tile"><span/><span/><span/><span/></span>
                    Sign in with Microsoft
                  </>
                )}
                {stage === "redirecting" && (<><Loader2 className="w-4 h-4 animate-spin" /> Redirecting to Microsoft...</>)}
                {stage === "verifying" && (<><Loader2 className="w-4 h-4 animate-spin" /> Verifying your organization...</>)}
              </button>

              <div className="flex items-center gap-3 my-5">
                <div className="flex-1 h-px bg-surface-2 border-b border-app" />
                <span className="text-xs uppercase tracking-widest text-ink-mute">or</span>
                <div className="flex-1 h-px bg-surface-2 border-b border-app" />
              </div>

              <button
                onClick={() => { setPickerOpen(true); setStage("picker"); }}
                className="w-full text-sm text-ink-soft hover:text-accent-dark py-2.5 border border-app-strong rounded-lg bg-surface hover:bg-surface-2 transition-colors inline-flex items-center justify-center gap-2"
              >
                <KeyRound className="w-3.5 h-3.5" /> Continue with another account
              </button>

              <div className="mt-8 text-xs text-ink-mute leading-relaxed">
                <Lock className="w-3 h-3 inline mr-1 -mt-0.5" />
                Single sign-on secured by Azure Active Directory. Your session is bound to your tenant and device compliance policies.
              </div>
            </>
          ) : (
            <div className="border border-app rounded-xl bg-surface overflow-hidden">
              <div className="px-5 py-3.5 border-b border-app flex items-center gap-2">
                <span className="ms-tile"><span/><span/><span/><span/></span>
                <div className="text-sm font-medium">Pick an account</div>
              </div>
              <div className="divide-y divide-app">
                {mockAccounts.map(acc => (
                  <button key={acc.email} onClick={() => pickAccount(acc)}
                    className="w-full flex items-center gap-3 px-5 py-3.5 text-left hover:bg-surface-2 transition-colors">
                    <div className="w-9 h-9 rounded-full bg-accent-tint text-accent-dark font-medium text-sm flex items-center justify-center border border-app">
                      {acc.initial}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-medium">{acc.name}</div>
                      <div className="text-xs text-ink-mute truncate">{acc.email}</div>
                    </div>
                    <ChevronRight className="w-4 h-4 text-ink-mute" />
                  </button>
                ))}
                <button
                  onClick={() => { setPickerOpen(false); setStage("idle"); }}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left hover:bg-surface-2 transition-colors text-ink-soft">
                  <div className="w-9 h-9 rounded-full bg-surface-2 border border-app flex items-center justify-center">
                    <Plus className="w-4 h-4" />
                  </div>
                  <div className="text-sm">Use another account</div>
                </button>
              </div>
              <div className="px-5 py-3 bg-surface-2 border-t border-app text-xs text-ink-mute">
                Signing in to <span className="font-mono text-accent-dark">DataQ Agent</span> · IDWTEAM tenant
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// =============================================================================
// USER MENU (header, when authenticated)
// =============================================================================
function UserMenu({ user, onSignOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    function h(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(o => !o)}
        className="flex items-center gap-2 pl-1 pr-2 py-1 rounded-full hover:bg-surface-2 transition-colors">
        <div className="w-7 h-7 rounded-full bg-accent-tint text-accent-dark font-medium text-10 flex items-center justify-center border border-app">
          {user.initial}
        </div>
        <ChevronDown className="w-3.5 h-3.5 text-ink-mute" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-64 paper overflow-hidden z-50">
          <div className="px-4 py-3 border-b border-app">
            <div className="text-sm font-medium text-ink">{user.name}</div>
            <div className="text-xs text-ink-mute truncate">{user.email}</div>
            <div className="mt-2 flex items-center gap-1.5 text-10 text-ink-mute">
              <span className="ms-tile" style={{ transform: "scale(0.7)", transformOrigin: "left center" }}><span/><span/><span/><span/></span>
              <span>Azure AD · {user.tenant}</span>
            </div>
          </div>
          <button onClick={() => { setOpen(false); onSignOut(); }}
            className="w-full flex items-center gap-2 px-4 py-2.5 text-sm text-ink-soft hover:bg-surface-2 hover:text-red-700 transition-colors">
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      )}
    </div>
  );
}

// =============================================================================
// CONNECTORS TAB
// =============================================================================
function ConnectorsTab({ connectors, onOpen, onDisconnect }) {
  const [filter, setFilter] = useState("All");
  const cats = ["All", "ERP", "Planning", "Data Platform"];
  const visible = CONNECTORS.filter(c => filter === "All" || c.category === filter);

  const connectedCount = Object.values(connectors).filter(c => c.configured).length;

  return (
    <div>
      <div className="flex items-end justify-between mb-2">
        <div>
          <h2 className="font-display text-4xl mb-1">Connectors</h2>
          <p className="text-sm text-ink-mute">Connect DataQ Agent to your source systems. Configuration is persisted for your session.</p>
        </div>
        <div className="text-right">
          <div className="font-display text-2xl text-accent">{connectedCount} <span className="text-ink-mute text-base">/ {CONNECTORS.length}</span></div>
          <div className="text-10 uppercase tracking-xwide text-ink-mute">connected</div>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-6 mt-4">
        {cats.map(c => (
          <button key={c} onClick={() => setFilter(c)}
            className={`chip ${filter === c ? "bg-accent text-white border-accent" : "bg-surface text-ink-soft border-app hover:border-app-strong"}`}
            style={filter === c ? { borderColor: "var(--accent)" } : undefined}>
            {c}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {visible.map(c => (
          <ConnectorCard
            key={c.id} def={c} state={connectors[c.id]}
            onOpen={() => onOpen(c.id)}
            onDisconnect={() => onDisconnect(c.id)}
          />
        ))}
      </div>

      <div className="paper-2 p-4 mt-6 flex items-start gap-3">
        <Info className="w-4 h-4 text-accent mt-0.5 flex-shrink-0" />
        <div className="text-xs text-ink-soft leading-relaxed">
          Connections are simulated in this prototype for secure demonstration. In production, DataQ Agent's backend integration service handles credentials through Azure Key Vault (or equivalent), and SAP/JDE/Oracle connections are established via dedicated gateway services (SAP CPI, Oracle Integration Cloud, etc.).
        </div>
      </div>
    </div>
  );
}

function ConnectorCard({ def, state, onOpen, onDisconnect }) {
  const connected = !!state?.configured;
  const Icon = def.icon || Server;
  return (
    <div className="paper p-5 flex flex-col">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className="w-11 h-11 rounded-lg flex items-center justify-center text-white font-medium text-xs flex-shrink-0"
            style={{ backgroundColor: def.tone }}
          >
            <Icon className="w-5 h-5" strokeWidth={2} />
          </div>
          <div>
            <div className="font-medium text-sm leading-tight">{def.name}</div>
            <div className="text-10 uppercase tracking-xwide text-ink-mute mt-0.5">{def.category}</div>
          </div>
        </div>
        {connected ? (
          <div className="chip bg-accent-soft text-accent-dark" style={{ borderColor: "transparent" }}>
            <span className="w-1.5 h-1.5 rounded-full bg-accent" /> Connected
          </div>
        ) : (
          <div className="chip bg-surface-2 text-ink-mute" style={{ borderColor: "var(--border)" }}>
            <span className="w-1.5 h-1.5 rounded-full bg-ink-mute" style={{ backgroundColor: "var(--ink-mute)" }} /> Not connected
          </div>
        )}
      </div>

      <p className="text-xs text-ink-soft leading-relaxed flex-1 mb-4">{def.blurb}</p>

      {connected && state?.lastSync && (
        <div className="text-10 font-mono text-ink-mute mb-3 pb-3 border-b border-app">
          Last sync · {state.lastSync}
        </div>
      )}

      <div className="flex items-center gap-2">
        <button onClick={onOpen} className="btn-secondary flex-1 justify-center">
          <Settings className="w-3.5 h-3.5" /> {connected ? "Configure" : "Connect"}
        </button>
        {connected && (
          <button onClick={onDisconnect} className="btn-ghost" title="Disconnect">
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}

// =============================================================================
// CONNECTOR CONFIG MODAL
// =============================================================================
function ConnectorConfigModal({ draft, onClose, onField, onTest, onSave, isConfigured }) {
  const def = CONNECTORS.find(c => c.id === draft.id);
  if (!def) return null;
  const Icon = def.icon || Server;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-surface border border-app rounded-2xl max-w-xl w-full scroll-85vh overflow-y-auto scrollbar-thin">
        <div className="sticky top-0 bg-surface border-b border-app px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white" style={{ backgroundColor: def.tone }}>
              <Icon className="w-5 h-5" strokeWidth={2} />
            </div>
            <div>
              <div className="font-display text-lg leading-tight">{def.name}</div>
              <div className="text-10 uppercase tracking-xwide text-ink-mute mt-0.5">{def.category} · {isConfigured ? "Edit connection" : "New connection"}</div>
            </div>
          </div>
          <button onClick={onClose} className="text-ink-mute hover:text-ink"><X className="w-5 h-5" /></button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-xs text-ink-soft leading-relaxed">{def.blurb}</p>

          <div className="grid grid-cols-2 gap-3">
            {def.fields.map(f => {
              const colSpan = f.w === "sm" ? "col-span-1" : "col-span-2";
              return (
                <div key={f.key} className={colSpan}>
                  <label className="block text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">{f.label}</label>
                  {f.type === "select" ? (
                    <div className="relative">
                      <select
                        value={draft.config[f.key] || ""}
                        onChange={e => onField(f.key, e.target.value)}
                        className="input-base w-full appearance-none pr-9 cursor-pointer"
                      >
                        <option value="">Select...</option>
                        {f.options.map(o => <option key={o} value={o}>{o}</option>)}
                      </select>
                      <ChevronDown className="w-4 h-4 absolute right-2.5 top-1/2 -translate-y-1/2 text-ink-mute pointer-events-none" />
                    </div>
                  ) : (
                    <input
                      type={f.key.includes("password") ? "password" : "text"}
                      value={draft.config[f.key] || ""}
                      onChange={e => onField(f.key, e.target.value)}
                      placeholder={f.placeholder}
                      className="input-base w-full font-mono text-xs"
                    />
                  )}
                </div>
              );
            })}
          </div>

          {draft.testResult && (
            <div className={`flex items-start gap-2 rounded-lg px-3 py-2.5 text-xs ${
              draft.testResult.ok
                ? "bg-accent-tint border border-app text-accent-dark"
                : "bg-red-50 border border-red-200 text-red-800"
            }`}>
              {draft.testResult.ok ? <CheckCircle2 className="w-4 h-4 mt-0.5 flex-shrink-0" /> : <CircleAlert className="w-4 h-4 mt-0.5 flex-shrink-0" />}
              <div>
                <div className="font-medium">{draft.testResult.ok ? "Connection successful" : "Connection failed"}</div>
                <div className="mt-0.5 opacity-90">{draft.testResult.message}</div>
              </div>
            </div>
          )}
        </div>

        <div className="sticky bottom-0 bg-surface border-t border-app px-6 py-4 flex items-center justify-between">
          <button onClick={onTest} disabled={draft.testing} className="btn-secondary">
            {draft.testing ? <><Loader2 className="w-4 h-4 animate-spin" /> Testing...</> : <><Plug className="w-4 h-4" /> Test connection</>}
          </button>
          <div className="flex items-center gap-2">
            <button onClick={onClose} className="btn-ghost">Cancel</button>
            <button onClick={onSave} disabled={!draft.testResult?.ok} className="btn-primary">
              <Check className="w-4 h-4" /> Save connection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// =============================================================================
// RULE DETAIL MODAL
// =============================================================================
function RuleDetailModal({ rule, onClose }) {
  const fields = extractSapFields(rule.t);
  const cls = classifyStaticRule(rule);
  const autoExec = cls.type !== "ai";

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-6" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-surface border border-app rounded-2xl max-w-2xl w-full scroll-85vh overflow-y-auto scrollbar-thin">
        <div className="sticky top-0 bg-surface border-b border-app px-6 py-4 flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="font-mono text-xxs text-ink-mute">RULE #{String(rule.n).padStart(3, "0")}</span>
              <span className={`chip ${SEV_STYLES[rule.s]}`}>
                <span className={`w-1 h-1 rounded-full ${SEV_DOT[rule.s]}`} />{rule.s}
              </span>
              <span className={`chip ${DIM_STYLES[rule.x]}`}>{rule.x}</span>
            </div>
            <div className="font-display text-xl">{rule.d}</div>
          </div>
          <button onClick={onClose} className="text-ink-mute hover:text-ink"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-6 space-y-5">
          <div>
            <div className="text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Description</div>
            <div className="text-ink leading-relaxed">{rule.t}</div>
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div>
              <div className="text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">SAP tables</div>
              <div className="font-mono text-sm text-accent-dark">{rule.b}</div>
            </div>
            <div>
              <div className="text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Suggested method</div>
              <div className="text-sm text-ink-soft">{rule.m}</div>
            </div>
          </div>
          {fields.length > 0 && (
            <div>
              <div className="text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Detected SAP fields</div>
              <div className="flex flex-wrap gap-1.5">
                {fields.map(f => (
                  <span key={f} className="font-mono text-xs bg-surface-2 border border-app rounded px-2 py-0.5 text-accent-dark">{f}</span>
                ))}
              </div>
            </div>
          )}
          <div>
            <div className="text-xxs uppercase tracking-xwide text-ink-mute mb-1.5">Engine capability</div>
            {autoExec ? (
              <div className="flex items-center gap-2 text-sm text-accent-dark">
                <Zap className="w-4 h-4" /> Auto-executable ({cls.type})
              </div>
            ) : (
              <div className="flex items-center gap-2 text-sm text-orange-700">
                <Bot className="w-4 h-4" /> Requires AI agent for business-logic evaluation
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
